
import { ErrorResponse, GlobalStatus, OperationTypeEnum, PackingStatus, PalletType, SoProcessTypesEnum, SoStatusEnum, StockInTransactionsRequest, StockReportFilters, stockTypeEnum, StockTypesEnum, StockTypeStatus, TransactionType, UnitRequest, MessageRequest, UomEnum, MessageParameters, GlobalVariableValues } from '@gtpl/shared-models/common-models';
import { HlPercentageRangeRequest, OccupancyEnum, PalletDto, PalletRequest, PalletsResponseModel, RackPostionReq, RacksForRackId, ReserveRackRequest } from '@gtpl/shared-models/masters';
import { SaleOrderDropDownDto, SaleOrderInfo, saleOrderItemIdRequest, SaleOrderItemsBySoIdReaponseModel, SaleOrderItemsInfo, SoInvoiceDetailsInfo, UnitsOfWeightInput } from '@gtpl/shared-models/sale-management';
import {
    AssigningStockResponse, CommonResponse, FGStockData, ForkLiftItemsDTO, ForkLiftJobDTO, ForkLiftJobStatus, GetAllRepackingStockResponseModel, GetAllStockResponseModel, GetForkLiftJobResponseModel, GetStockResponseModel, Pallets, RackPositionServiceResponseModel, RackPostions, RackSuggestionDto, RackSuggestionsResponseModel, RepackingDtoRequest, StockAssigningResponse, StockDTO, StockQtyResponseModel, StockResponseDto, StockOutResponse, StockOutModel, PlantIdRequest, getDispatchListResponseModel, StockResponseData, ReprocessingInputRequest, ReprocessingBOMUpdateRequset, StockOutResponseDto, getAllStockInDetailsResponseModel, SaleOrderIdRequest, WarehouseResponseModel, WarehouseResponseData, RackDashboard, FgStockStatusEnum, WarehouseDashboardResponseModel, WarehouseDashboard, RackLevelResponseDto, RackTypeResponseDto, FgStockReportResponse, FgStockReportModel, gradeResponse, StockSummaryResponse, SoIdRequest, AssignRepackingRequest, AssignSuperDummyRepackingRequest, StockInReverseReq, AllocationRevereseRequest, LocationUpdateRequest
    // , gradeResponse, StockSummaryResponse 
} from '@gtpl/shared-models/warehouse-management';
import { EndCustomersService, GradeServices, HLpercentagesService, LocationsService, PackingMethodService, PalletService, ProductService, RackEndCustomerMapService, RackPositionService, RackService, SkuService, ZoneService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getConnection, getRepository, Repository, In, Raw, Any } from 'typeorm';
import { FGReStockData } from './dto/all-re-packorprocess-stock.dto';
import { RackPositionRequest } from './dto/rack-postion.request';
import { FgStockStatus } from './dto/fg-stock-status.enum';
import { InputIdRequest } from './dto/input-id.request';
import { StockSoItemRequest } from './dto/stock-so-item.request';
import { StockSoRequest } from './dto/stock-so.request';
import { StockStatus } from './dto/stock-status.enum';
import { StockStatusRequest } from './dto/stock-status.request';
import { StockAdapter } from './dto/stock.adapter';
import { StockDto } from './dto/stock.dto';
import { Stock } from './stock.entity';
import { RackPositionQtyRequest } from './dto/rack-position-qty.request';
import { OutBoundRequest } from './dto/out-bound.request';
import { ForkLiftJobService } from '@gtpl/shared-services/warehouse-management';
import { ForkLiftJobs } from '../fork-lift-jobs/fork-lift-jobs.entity';
import { ForkLiftJobRequest } from '../fork-lift-jobs/dto/fork-lift-job.request';
import { StockInService } from '../stock-in/stock-in.service';
import { StockIn } from '../stock-in/stock-in.entity';
import { StockInAdapter } from '../stock-in/dto/stock-in.adapter';
import { SoPlantRequest } from './dto/so-plant.request';
import { palletLocationRequest } from './dto/pallet-location-dto';
import { FgStockStates } from './dto/fg-stock-states.enum';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { StockLog } from './stock-log.entity';
import { StockRepository } from './repositories/stock-repository';
import { StockLogRepository } from './repositories/stock-log-repository';

// import { StockView } from './stock-view.entity';
import { getManager } from "typeorm";
import { appSettings } from '../../../../config';
import { globalVariable } from '../../../../global-variable';
import { WarehouseView } from './warehouse-view.entity';
import { PlantZone } from './dto/plant-zone.request.dto';
import { StockView } from './stock-view.entity';
import { LotCodesRequest } from './dto/lot-codes.request';
import { LotCodesDTO, LotCodesResponseModel } from '@gtpl/shared-models/raw-material-procurement';
import { RackReserveRequest } from './dto/rack-reserve.request';
import { RackZoneLevelRequest } from './dto/zone-rack-level.request';
import { StockTransferDto } from './dto/stock-transfer.dto';
import { BulkStockOutRequest } from './dto/bulk-stock-out.request';
import { SaleOrderItemsRequest } from './dto/sale-order-items-request';
import { ForkLiftItemsDto } from '../fork-lift-items/dto/fork-lift-items.dto';
import { ForkLiftJobDto } from '../fork-lift-jobs/dto/fork-lift-job.dto';
import { ReProcessingDtoReq } from './dto/reprocess-request';
import { StockInRepository } from '../stock-in/dto/stock-in.repository';
import { StockOutTransactionRequest } from './dto/stock-out.request';
import { FgSaleReportRequest } from './repositories/fg-sale-report.request';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { Cron } from '@nestjs/schedule';
import { whatsApp } from '../../../../whatsapp';
import { format } from 'url';
import { ShipmentStatusRequest } from './dto/shipment-status.report';
import { DPReportRequest } from './dto/dummy-packing-report.request';
import moment = require('moment');
import { concat } from 'rxjs';
import { ForkLiftJobsRepository } from '../fork-lift-jobs/dto/fork-lift-jobs.repository';
import { ForkLiftItems } from '../fork-lift-items/fork-lift-items.entity';
import { ForkLiftItemsRepository } from '../fork-lift-items/dto/fork-lift-items.repository';
import { BroadCastMessageRequest, WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { Broadcaster } from 'typeorm/subscriber/Broadcaster';
const warehouseStockTable = appSettings.warehouse_db + '.stock';
const salesSoTable = appSettings.sales_db + '.sale_order';
const salesSoItemTable = appSettings.sales_db + '.sale_order_items';
const salesInvTable = appSettings.sales_db + '.so_invoice_details';
const coldStorageTable = appSettings.masters_db + '.zone_master';
const rackPositionTable = appSettings.masters_db + '.rack_position';

@Injectable()
export class StockService {
    [x: string]: any;
    constructor(
        @InjectRepository(StockIn)
        private stockInRepository: Repository<StockIn>,
        private stockInAdapter: StockInAdapter,
        @InjectRepository(Stock)
        private stockRepository: Repository<Stock>,
        private stockAdapter: StockAdapter,
        private saleOrderService: SaleOrderService,
        private palletService: PalletService,
        private locationsService: LocationsService,
        private endCustomerRepository: EndCustomersService,
        private rackPositionRepository: RackPositionService,
        private rackEndCustomerMapService: RackEndCustomerMapService,
        private productRepository: ProductService,
        private skuCodesRepository: SkuService,
        private hlPerService: HLpercentagesService,
        private rackPositionService: RackPositionService,
        private packingMethodService: PackingMethodService,
        private forkLiftJobService: ForkLiftJobService,
        private stockInService: StockInService,
        private rackService: RackService,
        private zoneService: ZoneService,
        private gradeServices: GradeServices,
        private wpService: WhatsAppNotificationService,
        @InjectRepository(ForkLiftJobs)
        private forkLiftRepo: ForkLiftJobsRepository,
        @InjectRepository(ForkLiftItems)
        private forkLiftitemsRepo: ForkLiftItemsRepository,

        private wtsAppBroadCatService: WhatsappBroadCastService,
    ) { }

    async getStockBySoItemId(stockSoItemRequest: StockSoItemRequest): Promise<GetStockResponseModel> {
        try {
            // const stockData:StockDTO[] = [];
            console.log(stockSoItemRequest);
            const stockDetails = await this.stockRepository.findOne({
                where: { stockType: stockSoItemRequest.stockType, saleOrderItemId: stockSoItemRequest.saleOrderItemId, status: FgStockStatus.StockIn, location: stockSoItemRequest.location, pouchesShortage: stockSoItemRequest.pouchesShortage, cartonsShortage: stockSoItemRequest.cartonsShortage, productCategory: stockSoItemRequest.productCategory, packStyleId: stockSoItemRequest.packStyleId },
            })
            console.log('stockDetails' + stockDetails);
            if (stockDetails != undefined) {
                // for (const eachItem of stockDetails) {

                const palletDetails = await this.palletService.getPalletById({ palletId: stockDetails.pallet });
                if (!palletDetails) {
                    throw new ErrorResponse(1111, 'Failed to Get Pallet Details');
                }
                const locationDetails = await this.locationsService.getLocationById({ locationId: stockDetails.location });
                if (!locationDetails) {
                    throw new ErrorResponse(1111, 'Failed to Get Location Details');
                }
                const saleOrderDetails = await this.saleOrderService.getSaleOrderDataForSoId({ saleOrderId: stockDetails.saleOrderId });
                if (!saleOrderDetails) {
                    throw new ErrorResponse(1111, 'Failed to Get Sale Order Details');
                }
                const saleOrderItemDetails = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: stockDetails.saleOrderId, saleOrderItemId: stockDetails.saleOrderItemId });
                if (!saleOrderItemDetails) {
                    throw new ErrorResponse(1111, 'Failed to Get Sale Order Item Details');
                }
                const data = new StockDTO(stockDetails.saleOrderId, stockDetails.saleOrderItemId, stockDetails.totalCartons, stockDetails.totalPouches, stockDetails.loosePouches, stockDetails.location, stockDetails.pallet, stockDetails.date, stockDetails.stockType, stockDetails.status, stockDetails.lotNo, stockDetails.transactionType, stockDetails.shift, PackingStatus.NO, stockDetails.stockId, stockDetails.brandId, stockDetails.minGrade, stockDetails.maxGrade, stockDetails.varientId, stockDetails.pouches, stockDetails.pouchWeight, stockDetails.categoryId, stockDetails.productId, undefined, undefined, undefined, undefined, "", 0, 0, 0, undefined, undefined, undefined, 0, 0, stockDetails.stockInQty);
                // stockData.push(data);
                // }
                // console.log(stockData);
                const response = new GetStockResponseModel(true, 11101, "Stock retrived successfully", data)
                return response;
            }
            else {
                const response = new GetStockResponseModel(false, 1101, "Data not found")
                return response;
            }
        } catch (error) {
            return error;
        }
    }

    async getStockBySoId(stockSoRequest: StockSoRequest): Promise<GetAllStockResponseModel> {
        try {
            const stockData: StockDTO[] = [];
            const stockDetails = await this.stockRepository.find({
                where: { saleOrderId: stockSoRequest.saleOrderId },
            })
            console.log('stockDetails' + stockDetails);
            if (stockDetails) {
                for (const eachItem of stockDetails) {

                    const palletDetails = await this.palletService.getPalletById({ palletId: eachItem.pallet });
                    if (!palletDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Pallet Details');
                    }
                    const locationDetails = await this.locationsService.getLocationById({ locationId: eachItem.location });
                    if (!locationDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Location Details');
                    }
                    const saleOrderDetails = await this.saleOrderService.getSaleOrderDataForSoId({ saleOrderId: eachItem.saleOrderId });
                    if (!saleOrderDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Sale Order Details');
                    }
                    const saleOrderItemDetails = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: eachItem.saleOrderId, saleOrderItemId: eachItem.saleOrderItemId });
                    if (!saleOrderItemDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Sale Order Item Details');
                    }
                    const data = new StockDTO(eachItem.saleOrderId, eachItem.saleOrderItemId, eachItem.totalCartons, eachItem.totalPouches, eachItem.loosePouches, eachItem.location, eachItem.pallet, eachItem.date, eachItem.stockType, eachItem.status, eachItem.lotNo, eachItem.transactionType, eachItem.shift)
                    stockData.push(data);
                }
                const response = new GetAllStockResponseModel(true, 11101, "Stock retrived successfully", stockData)
                return response;
            }
            else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } catch (error) {
            return error;
        }
    }

    async getDispatchlistForSo(stockSoRequest: StockSoRequest): Promise<GetAllStockResponseModel> {
        try {
            const status = "StockIn";
            const stockData: StockDTO[] = [];
            const stockDetails = await this.stockRepository.find({
                where: { saleOrderId: stockSoRequest.saleOrderId, status: status },
            })
            if (stockDetails.length > 0) {
                for (const eachItem of stockDetails) {

                    const palletDetails = await this.palletService.getPalletById({ palletId: eachItem.pallet });
                    if (!palletDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Pallet Details');
                    }
                    const locationDetails = await this.locationsService.getLocationById({ locationId: eachItem.location });
                    if (!locationDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Location Details');
                    }
                    const saleOrderDetails = await this.saleOrderService.getSaleOrderDataForSoId({ saleOrderId: eachItem.saleOrderId });
                    if (!saleOrderDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Sale Order Details');
                    }
                    const saleOrderItemDetails = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: eachItem.saleOrderId, saleOrderItemId: eachItem.saleOrderItemId });
                    if (!saleOrderItemDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Sale Order Details');
                    }
                    const data = new StockDTO(eachItem.saleOrderId, eachItem.saleOrderItemId, eachItem.totalCartons, eachItem.totalPouches, eachItem.loosePouches, eachItem.location, eachItem.pallet, eachItem.date, eachItem.stockType, eachItem.status, eachItem.lotNo, eachItem.transactionType, eachItem.shift)
                    stockData.push(data);
                }
                const response = new GetAllStockResponseModel(true, 11101, "Stock retrived successfully", stockData)
                return response;
            }
            else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } catch (error) {
            return error;
        }
    }

    async createReportedStock(stockDto: StockDto, isUpdate: boolean): Promise<GetStockResponseModel> {
        console.log(stockDto);

        try {
            const connection = getManager();
            const getStockData = 'select * from ' + appSettings.warehouse_db + '.stock where sale_order_item_id = ' + stockDto.saleOrderItemId + ' and status = "StockIn"';
            const stockResult = await connection.query(getStockData);
            if (!isUpdate) {
                const soProcessType = await this.saleOrderService.getSaleOrderDetailsForId({ saleOrderId: stockDto.saleOrderId });
                const varientDetails = await this.saleOrderService.getSaleOrderItemDetailsBySoItemId({ saleOrderId: stockDto.saleOrderId, saleOrderItemId: stockDto.saleOrderItemId });
                console.log('soProcessType' + soProcessType.soProcessType + 'varientDetails' + varientDetails.data.valAdditionOne);
                // if(stockDto.stockType != undefined){
                //     if(soProcessType.soProcessType === "MTO"){
                //     if(stockDto.packingType === "YES"){
                //         stockDto.stockType = StockStatus.SaleOrder;
                //     }
                //     else if(stockDto.packingType === "NO"){
                //         stockDto.stockType = StockStatus.superDummy;
                //         }
                //     }
                //     else if(soProcessType.soProcessType === "MTS"){
                //         if(varientDetails.data.valAdditionOne === "HLSO"){
                //             stockDto.stockType = StockStatus.dummy;
                //         }
                //         else if(varientDetails.data.valAdditionOne != "HLSO"){
                //             stockDto.stockType = StockStatus.superDummy;
                //         }
                //     }
                // }
                const palletCodeDetails = await this.stockRepository.findOne({ where: { plantId: stockDto.unitId }, order: { stockId: "DESC" } })
                console.log(palletCodeDetails);
                let palletCode = 0;
                if (palletCodeDetails != undefined) {
                    palletCode = Number(palletCodeDetails.palletCode) + Number(1);
                }
                else {
                    palletCode = 1;
                }
                console.log('stockDto.shift');
                console.log(stockDto);
                const convertedStockEntity: Stock = this.stockAdapter.convertDtoToEntity(stockDto, isUpdate);
                const savedStockEntity: Stock = await this.stockRepository.save(
                    convertedStockEntity
                );
                const savedStockDto: StockDto = this.stockAdapter.convertEntityToDto(savedStockEntity);
                console.log('savedStockDto');
                console.log(savedStockDto);

                if (savedStockDto.saleOrderId != undefined) {
                    if (savedStockDto.transactionType != TransactionType.rm && savedStockDto.stockType === StockStatus.SaleOrder && stockDto.isDamaged === PackingStatus.NO && savedStockDto.transactionType != "stockTransfer") {

                        console.log(savedStockDto.transactionType + "***" + savedStockDto.stockType + "****" + stockDto.isDamaged + "******" + savedStockDto.transactionType);

                        let receivedQty = Number(stockDto.pouches) * Number(stockDto.pouchWeight) * Number(stockDto.totalCartons);
                        console.log("receivedQty" + receivedQty);
                        const updateQtyAgainstJob = await this.forkLiftJobService.updateForkLiftJobQty({ jobId: stockDto.jobId, receivedCartons: stockDto.totalCartons, receivedqty: receivedQty, saleOrderId: stockDto.saleOrderId, saleOrderItemId: stockDto.saleOrderItemId, isDamaged: stockDto.isDamaged, transactionType: stockDto.transactionType });
                        if (updateQtyAgainstJob.status) {
                            const response = new GetStockResponseModel(true, 11101, 'Stock Reported Successfully', savedStockDto);
                            return response;
                        }
                        else {
                            throw new ErrorResponse(11106, 'Something Went Wrong');
                        }
                    }
                    else if (savedStockDto.transactionType === "stockTransfer") {
                        let receivedQty = Number(stockDto.pouches) * Number(stockDto.pouchWeight) * Number(stockDto.totalCartons);
                        const updateQtyAgainstJob = await this.forkLiftJobService.updateForkLiftJobQty({ jobId: stockDto.jobId, receivedCartons: stockDto.totalCartons, receivedqty: receivedQty, saleOrderId: stockDto.saleOrderId, saleOrderItemId: stockDto.saleOrderItemId, isDamaged: stockDto.isDamaged, transactionType: stockDto.transactionType });
                        if (updateQtyAgainstJob.status) {
                            const response = new GetStockResponseModel(true, savedStockDto ? 11100 : 11101, savedStockDto ? 'Something went wrong' : 'Stock Reported Successfully', savedStockDto);
                            return response;
                        }
                        else {
                            throw new ErrorResponse(11106, 'Something Went Wrong');
                        }
                    }
                    else if (savedStockDto.transactionType != TransactionType.rm && savedStockDto.stockType === StockStatus.dummy && stockDto.isDamaged === PackingStatus.YES) {

                        let receivedQty = Number(stockDto.pouches) * Number(stockDto.pouchWeight) * Number(stockDto.totalCartons);
                        const updateQtyAgainstJob = await this.forkLiftJobService.updateForkLiftJobQty({ jobId: stockDto.jobId, receivedCartons: stockDto.totalCartons, receivedqty: receivedQty, saleOrderId: stockDto.saleOrderId, saleOrderItemId: stockDto.saleOrderItemId, isDamaged: stockDto.isDamaged, transactionType: stockDto.transactionType });
                        if (updateQtyAgainstJob.status) {
                            const response = new GetStockResponseModel(true, savedStockDto ? 11100 : 11101, savedStockDto ? 'Something went wrong' : 'Stock Reported Successfully', savedStockDto);
                            return response;
                        }
                        else {
                            throw new ErrorResponse(11106, 'Something Went Wrong');
                        }
                    }
                    else {
                        console.log("Hi")
                        const response = new GetStockResponseModel(true, savedStockDto ? 11100 : 11101, savedStockDto ? 'Something went wrong' : 'Stock Reported Successfully', savedStockDto);
                        return response;
                    }

                } else {
                    throw new ErrorResponse(11106, 'Something Went Wrong');
                }
            }
            else {
                if (stockDto) {

                    const updateStatus = await getConnection()
                        .createQueryBuilder()
                        .update(Stock)
                        .set({ totalCartons: stockDto.totalCartons, totalPouches: stockDto.totalCartons, loosePouches: stockDto.loosePouches })
                        .where("stock_id = " + stockDto.stockId)
                        .execute();
                    // const savedStockDto: StockDto = this.stockAdapter.convertEntityToDto(stockDto);

                    if (updateStatus) {
                        const response = new GetStockResponseModel(true, updateStatus ? 11100 : 11101, updateStatus ? 'Something went wrong' : 'Stock Updated Successfully', stockDto);
                        return response;
                    } else {
                        throw new ErrorResponse(11106, 'Something Went Wrong');
                    }
                }
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async createStock(stockDto: StockDto, isUpdate: boolean): Promise<GetStockResponseModel> {
        console.log('stockDto' + stockDto.packingType, isUpdate, stockDto.count);
        try {
            if (!isUpdate) {
                const soProcessType = await this.saleOrderService.getSaleOrderDetailsForId({ saleOrderId: stockDto.saleOrderId });
                const varientDetails = await this.saleOrderService.getSaleOrderItemDetailsBySoItemId({ saleOrderId: stockDto.saleOrderId, saleOrderItemId: stockDto.saleOrderItemId });
                console.log('soProcessType' + soProcessType.soProcessType + 'varientDetails' + varientDetails.data.valAdditionOne);
                // if (stockDto.stockType != undefined) {
                //     if (soProcessType.soProcessType === "MTO") {
                //         if (stockDto.packingType === "YES") {
                //             stockDto.stockType = StockStatus.SaleOrder;
                //         }
                //         else if (stockDto.packingType === "NO") {
                //             stockDto.stockType = StockStatus.superDummy;
                //         }
                //     }
                //     else if (soProcessType.soProcessType === "MTS") {
                //         if (varientDetails.data.valAdditionOne === "HLSO") {
                //             stockDto.stockType = StockStatus.dummy;
                //         }
                //         else if (varientDetails.data.valAdditionOne != "HLSO") {
                //             stockDto.stockType = StockStatus.superDummy;
                //         }
                //     }
                // }
                const palletCodeDetails = await this.stockRepository.findOne({ where: { plantId: stockDto.unitId }, order: { stockId: "DESC" } })
                // let palletCode = 0;
                // if (palletCodeDetails != undefined) {
                //     palletCode = Number(palletCodeDetails.palletCode) + Number(1);
                // }
                // else {
                //     palletCode = 1;
                // }
                const convertedStockEntity: Stock = this.stockAdapter.convertDtoToEntity(stockDto, isUpdate);
                const savedStockEntity: Stock = await this.stockRepository.save(
                    convertedStockEntity
                );
                const savedStockDto: StockDto = this.stockAdapter.convertEntityToDto(savedStockEntity);
                if (savedStockDto) {
                    const response = new GetStockResponseModel(true, savedStockDto ? 11100 : 11101, savedStockDto ? 'Something went wrong' : 'Stock Reported Successfully', savedStockDto);
                    return response;
                } else {
                    throw new ErrorResponse(11106, 'Something Went Wrong');
                }
            }
            else {
                if (stockDto) {

                    const updateStatus = await getConnection()
                        .createQueryBuilder()
                        .update(Stock)
                        .set({ date: stockDto.date, stockInQty: stockDto.stockInQty, totalCartons: stockDto.totalCartons, totalPouches: stockDto.totalCartons, loosePouches: stockDto.loosePouches })
                        .where("stock_id = " + stockDto.stockId)
                        .execute();
                    // const savedStockDto: StockDto = this.stockAdapter.convertEntityToDto(stockDto);

                    if (updateStatus) {
                        if (stockDto.transactionType != TransactionType.rm && stockDto.stockType === StockStatus.SaleOrder && stockDto.isDamaged === PackingStatus.NO && stockDto.transactionType != "stockTransfer") {

                            console.log(stockDto.transactionType + "***" + stockDto.stockType + "****" + stockDto.isDamaged + "******" + stockDto.transactionType);

                            let receivedQty = Number(stockDto.pouches) * Number(stockDto.pouchWeight) * Number(stockDto.totalCartons);
                            console.log("receivedQty" + receivedQty);
                            const updateQtyAgainstJob = await this.forkLiftJobService.updateForkLiftJobQty({ jobId: stockDto.jobId, receivedCartons: stockDto.totalCartons, receivedqty: receivedQty, saleOrderId: stockDto.saleOrderId, saleOrderItemId: stockDto.saleOrderItemId, isDamaged: stockDto.isDamaged, transactionType: stockDto.transactionType });
                            if (updateQtyAgainstJob.status) {
                                const response = new GetStockResponseModel(true, stockDto ? 11100 : 11101, stockDto ? 'Something went wrong' : 'Stock Reported Successfully', stockDto);
                                return response;
                            }
                            else {
                                throw new ErrorResponse(11106, 'Something Went Wrong');
                            }
                        }
                        else if (stockDto.transactionType === "stockTransfer") {
                            let receivedQty = Number(stockDto.pouches) * Number(stockDto.pouchWeight) * Number(stockDto.totalCartons);
                            const updateQtyAgainstJob = await this.forkLiftJobService.updateForkLiftJobQty({ jobId: stockDto.jobId, receivedCartons: stockDto.totalCartons, receivedqty: receivedQty, saleOrderId: stockDto.saleOrderId, saleOrderItemId: stockDto.saleOrderItemId, isDamaged: stockDto.isDamaged, transactionType: stockDto.transactionType });
                            if (updateQtyAgainstJob.status) {
                                const response = new GetStockResponseModel(true, stockDto ? 11100 : 11101, stockDto ? 'Something went wrong' : 'Stock Reported Successfully', stockDto);
                                return response;
                            }
                            else {
                                throw new ErrorResponse(11106, 'Something Went Wrong');
                            }
                        }
                        else if (stockDto.transactionType != TransactionType.rm && stockDto.stockType === StockStatus.dummy && stockDto.isDamaged === PackingStatus.YES) {

                            let receivedQty = Number(stockDto.pouches) * Number(stockDto.pouchWeight) * Number(stockDto.totalCartons);
                            const updateQtyAgainstJob = await this.forkLiftJobService.updateForkLiftJobQty({ jobId: stockDto.jobId, receivedCartons: stockDto.totalCartons, receivedqty: receivedQty, saleOrderId: stockDto.saleOrderId, saleOrderItemId: stockDto.saleOrderItemId, isDamaged: stockDto.isDamaged, transactionType: stockDto.transactionType });
                            if (updateQtyAgainstJob.status) {
                                const response = new GetStockResponseModel(true, updateStatus ? 11100 : 11101, updateStatus ? 'Something went wrong' : 'Stock Updated Successfully', stockDto);
                                return response;
                            }
                            else {
                                throw new ErrorResponse(11106, 'Something Went Wrong');
                            }
                        }
                        else {
                            const response = new GetStockResponseModel(true, updateStatus ? 11100 : 11101, updateStatus ? 'Something went wrong' : 'Stock Updated Successfully', stockDto);
                            return response;
                        }

                    } else {
                        throw new ErrorResponse(11106, 'Something Went Wrong');
                    }
                }
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async checkAvailableStock(saleOrderId: number, saleOrderItemId: number): Promise<Stock> {
        // tslint:disable-next-line: typedef
        const stockResponse = await this.stockRepository.findOne({
            where: { saleOrderId: saleOrderId, saleOrderItemId: saleOrderItemId },
        });
        if (stockResponse) {
            return stockResponse;
        } else {
            return null;
        }
    }
    async getAllStockData(): Promise<any> {
        // GetAllStockResponseModel
        try {
            let stockDto: StockDTO[] = [];
            // retrieves all plants
            const stockDetails: Stock[] = await this.stockRepository.find({
                order: { createdAt: "DESC" },
            });
            // console.log(stockDetails);
            if (stockDetails.length > 0) {
                for (const stockEntity of stockDetails) {
                    // const palletDetails = await this.palletService.getPalletById({palletId:stockEntity.pallet});
                    // if(!palletDetails){
                    //     throw new ErrorResponse(1111,'Failed to Get Pallet Details');
                    // }
                    // const locationDetails = await this.locationsService.getLocationById({locationId:stockEntity.location});
                    // if(!locationDetails){
                    //     throw new ErrorResponse(1111,'Failed to Get Location Details');
                    // }
                    // const saleOrderDetails = await this.saleOrderService.getSaleOrderDataForSoId({saleOrderId:stockEntity.saleOrderId});
                    // if(!saleOrderDetails){
                    //     throw new ErrorResponse(1111,'Failed to Get Sale Order Details');
                    // }
                    // const saleOrderItemDetails = await this.saleOrderService.getSaleOrderItemDetails({saleOrderId:stockEntity.saleOrderId,saleOrderItemId:stockEntity.saleOrderItemId});
                    // if(!saleOrderItemDetails){
                    //     throw new ErrorResponse(1111,'Failed to Get Sale Order Details');
                    // }
                    const stockDtoData = new StockDTO(stockEntity.saleOrderId, stockEntity.saleOrderItemId, stockEntity.totalCartons, stockEntity.totalPouches, stockEntity.loosePouches, stockEntity.location, stockEntity.pallet, stockEntity.date, stockEntity.stockType, stockEntity.status, stockEntity.lotNo, stockEntity.transactionType, stockEntity.shift)
                    stockDto.push(stockDtoData);
                };
                console.log(stockDto)

                if (stockDto) {
                    const response = new GetAllStockResponseModel(true, 11208, "Stock data Retrived successfully", stockDto);
                    return response;
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
    async updateStockStatus(stockStatusRequest: StockStatusRequest): Promise<boolean> {
        try {

            const stockData = await this.stockRepository.findOne({
                select: ['status', 'stockId'],
                where: { stockId: stockStatusRequest.stockId }
            })
            console.log(stockData);
            let stockStatus = stockStatusRequest.status;
            if (stockData) {
                const updateStatus = await getConnection()
                    .createQueryBuilder()
                    .update(Stock)
                    .set({ status: stockStatus })
                    .where("stock_id = " + stockStatusRequest.stockId)
                    .execute();

                if (updateStatus) {
                    return true;
                } else {
                    return false;
                }
            }
            else {
                throw new ErrorResponse(11106, 'Stock not found.');
            }

        } catch (err) {
            return err;
        }

    }

    async getReProcessingStockst(req: ReProcessingDtoReq): Promise<AssigningStockResponse> {
        try {
            const reProcessingStock = await this.stockRepository.createQueryBuilder("stock")
                .select("sum(total_cartons) as quantity")
                .where("varient_id = " + req.variantId)
                // .andWhere("brand_id =" + req.brand)
                // .andWhere("min_grade =" + req.minGrade)
                // .andWhere("max_grade =" + req.maxGrade)
                .andWhere("stock_type = '" + StockStatus.dummy + "'")
                .getRawOne();
            if (reProcessingStock) {
                return new AssigningStockResponse(true, 1111, 'Re-Processing Stock Found', reProcessingStock.quantity)
            } else {
                throw new ErrorResponse(11106, 'Stock not found.');
            }
        } catch (error) {
            return error
        }
    }


    async getReProcessingStock(req: ReProcessingDtoReq): Promise<AssigningStockResponse> {
        console.log("getReProcessingStock");
        console.log(req);
        console.log(req.variantId.length)
        try {
            if (req.variantId.length > 0) {

                let hlPercentage;
                let productMinCount;
                let productMaxCount;
                const hlPercentagedata = await this.hlPerService.getHlPercentageByRange(
                    new HlPercentageRangeRequest(
                        req.maxGrade,
                    )
                );

                await Promise.all([hlPercentagedata]).then(res => {
                    // calculate count 
                    if (res[0].status && res[0].data.hlPercentage > 0) {

                        hlPercentage = res[0].data.hlPercentage;
                    } else {
                        throw new ErrorResponse(99998, 'No HL percentages found for selected Grade Range.');
                    }
                    console.log("hlPercentage"+hlPercentage)
                    let gmsMinWeight
                    let gmsMaxWeight

                    //weight calculation 
                    gmsMinWeight = 454 / req.minGrade;
                    gmsMaxWeight = 454 / req.maxGrade;


                    //   const yieldPercentage = req.finalPercentage
                    //   const productPercentageafterhl = 1000*hlPercentage/100;
                    //   const productPercentageafterSoaking = productPercentageafterhl*yieldPercentage/100;
                    //   const rmRatioPerKg = 1000/productPercentageafterSoaking;


                    //output product count and quantity calculation
                    let outputMinWeight
                    let outputMaxWeight
                    if (hlPercentage != 0) {
                        outputMinWeight = gmsMinWeight / ((hlPercentage / 100));
                        outputMaxWeight = gmsMaxWeight / ((hlPercentage / 100));
                    } else {
                        outputMinWeight = 0
                        outputMaxWeight = 0
                    }

                    productMinCount = Math.round(1000 / outputMinWeight);
                    productMaxCount = Math.round(1000 / outputMaxWeight);
                    // const avgCount = productMinCount+productMaxCount/2;
                    // const count = Math.ceil(avgCount/5)*5;

                    // let caseWeight = stockEntity.pouches*shrimpWeight;
                    //     //conversion of case weight into Kg if UOM in SO is LB 
                    //     if(uomId == 2 || uomId == 3){
                    //     caseWeight = caseWeight*0.453592
                    //     }
                    // const reqQtyPercase = caseWeight*rmRatioPerKg;
                    // const totalRequiredQty = Number(Number(stockEntity.quantity*reqQtyPercase).toFixed(3));
                })
                const profitCountsList = []
                const lossCountsList = []
                let avgCount = Math.round((productMinCount + productMaxCount) / 2)
                for (let i = avgCount; i <= productMaxCount; i++) {
                    profitCountsList.push(i)
                }
                for (let j = productMinCount; j < avgCount; j++) {
                    lossCountsList.push(j)
                }
                if (req.minGrade == 11 && req.maxGrade == 20) {
                }
                const reProcessingStock = await this.stockRepository.createQueryBuilder("stock")
                    .select("min_grade as minGrade,max_grade as maxGrade,total_cartons as totalCartons,pouches,pouch_weight as pouchWeight")
                    // .where("product_id = " + req.product)
                    // .andWhere("brand_id =" + req.brand)
                    // .andWhere("varient_id in (" + req.variantId + ")")// need variants from reproceesing maters
                    // .andWhere("min_grade <= " + productMaxCount)  
                    // .andWhere("max_grade >= " + productMinCount)
                    //   .andWhere("count <=" + productMaxCount)
                    .andWhere("stock_type = '" + StockStatus.dummy + "'")
                    // .orWhere("stock_type = '" + StockStatus.Anticipated + "'")
                    .andWhere("state = '" + FgStockStates.Stock + "'")
                    .andWhere("status ='" + FgStockStatus.StockIn + "'")
                    .getRawMany();
                let assignableReprocessProfitQty = 0
                let assignableReprocessLossQty = 0
                for (const stockItem of reProcessingStock) {
                    const stockProfitGradesRange = []
                    const stockLossGradesRange = []
                    const stockAvgGrade = Math.round((stockItem.minGrade + stockItem.maxGrade) / 2)
                    for (let k = stockAvgGrade; k <= stockItem.maxGrade; k++) {
                        stockProfitGradesRange.push(k)
                    }
                    for (let l = stockItem.minGrade; l < stockAvgGrade; l++) {
                        stockLossGradesRange.push(l)
                    }
                    const profitGradeMatches = stockProfitGradesRange.some(r => profitCountsList.indexOf(r) >= 0)
                    const lossGradeMatches = stockLossGradesRange.some(r => lossCountsList.indexOf(r) >= 0)
                    // if (profitGradeMatches) {
                    assignableReprocessProfitQty += (stockItem.totalCartons * stockItem.pouches * stockItem.pouchWeight);
                    // } else {
                    //     if (lossGradeMatches) {
                    //         assignableReprocessLossQty += (stockItem.totalCartons * stockItem.pouches * stockItem.pouchWeight);
                    //     }
                    // }


                }

                if (reProcessingStock) {

                    return new AssigningStockResponse(true, 1111, 'Re-Processing Stock Found', { profitReproceeQty: assignableReprocessProfitQty, lossReproceeQty: assignableReprocessLossQty })
                } else {
                    return new AssigningStockResponse(false, 1111, 'Re-Processing Stock not Found', undefined)
                }
            } else {
                return new AssigningStockResponse(false, 1111, 'No conversion variants found', undefined)

            }
        } catch (error) {
            return error
        }
    }

    // async getAllAssignableReProcessingStock(req: ReProcessingDtoReq):Promise<GetAllRepackingStockResponseModel>{
    //     try {

    //             let hlPercentage;
    //             let productMinCount;
    //             let productMaxCount;
    //             const hlPercentagedata = await this.hlPerService.getHlPercentageByRange(
    //                 new HlPercentageRangeRequest(
    //                 req.maxGrade,
    //             )
    //             );

    //           await Promise.all([hlPercentagedata]).then(res => {
    //                // calculate count 
    //                if(res[0].status && res[0].data.hlPercentage>0){

    //                 hlPercentage = res[0].data.hlPercentage;
    //               }else{
    //                 throw new ErrorResponse(99998, 'No HL percentages found for selected Grade Range.');
    //               }

    //                 let gmsMinWeight
    //                 let gmsMaxWeight

    //                 //weight calculation 
    //                   gmsMinWeight = 454/req.minGrade;
    //                   gmsMaxWeight = 454/req.maxGrade;

    //                     let outputMinWeight
    //                     let outputMaxWeight
    //                     if(hlPercentage != 0){
    //                         outputMinWeight = gmsMinWeight/((hlPercentage/100));
    //                         outputMaxWeight = gmsMaxWeight/((hlPercentage/100));
    //                     }else{
    //                         outputMinWeight = 0
    //                         outputMaxWeight = 0
    //                     }

    //                      productMinCount = Math.round(1000/outputMinWeight);
    //                      productMaxCount = Math.round(1000/outputMaxWeight);
    //           })
    //         const reProcessingStock = await this.stockRepository.createQueryBuilder("stock")
    //             .where("product_id = " + req.product)
    //             // .andWhere("brand_id =" + req.brand)
    //             // .andWhere("min_grade =" + req.minGrade)
    //             // .andWhere("max_grade =" + req.maxGrade)
    //             .andWhere(`total_cartons>0`)
    //             .andWhere(`stock_type = "` + `${StockStatus.dummy}`+`"`)
    //             .andWhere("count between " + productMinCount+" and "+productMaxCount)
    //             .groupBy("count")
    //             .getMany();
    //         if (reProcessingStock&&reProcessingStock.length>0) {
    //             const fgStockInfo : FGStockData[] =[];
    //             for(const stockEntity of reProcessingStock){
    //                 // const palletDetails =this.palletService.getPalletById({palletId:stockEntity.pallet});

    //                 const locationDetails =this.locationsService.getLocationById({locationId:stockEntity.location});

    //                 const saleOrderDetails =this.saleOrderService.getSaleOrderDataForSoId({saleOrderId:stockEntity.saleOrderId});

    //                 const saleOrderItemDetails =await this.saleOrderService.getSaleOrderItemDetails({saleOrderId:stockEntity.saleOrderId,saleOrderItemId:stockEntity.saleOrderItemId});
    //                 const brandId = this.endCustomerRepository.getBrandsById({ brandId: stockEntity.brandId });
    //                 const productId = this.productRepository.getActiveProductById({ productId: stockEntity.productId });

    //                 const variantId = this.skuCodesRepository.getSkuDataById({ skuCodeId: stockEntity.varientId });

    //                 const netWeightData = this.saleOrderService.getReProcessingRequiredQuantity({productId: stockEntity.productId, saleOrderId: stockEntity.saleOrderId, saleOrderItemId: stockEntity.saleOrderItemId});

    //                 let hlPercentage;

    //                 const hlPercentagedata = await this.hlPerService.getHlPercentageByRange(
    //                     new HlPercentageRangeRequest(
    //                         req.maxGrade,
    //                     )
    //                   );



    //                 await Promise.all([locationDetails, saleOrderDetails, saleOrderItemDetails, brandId, productId, variantId, netWeightData, hlPercentagedata]).then(res => {
    //                     const location: string = res[0].status ? res[0].data.locationName : null;
    //                     const saleOrder: SaleOrderDropDownDto = res[1] ? res[1] : null;

    //                     const brand: string = res[3].status ? res[3].data.brandName : null;
    //                     const product: string = res[4].status ? res[4].data.productCode : null;
    //                     const varient: string = res[5].status ? res[5].data.variantCode : null;
    //                     const netWeight: number = res[6] ;
    //                     const uom =res[2].status?res[2].data.uom:null;
    //                     const soakingStyle =res[2].status?res[2].data.soakingStyle:null;
    //                     const soakingTime =res[2].status?res[2].data.soakingTime:null;
    //                     const shrimpWeight =res[2].status?res[2].data.shrimpWeight:null;
    //                     const uomId =res[2].status?res[2].data.uomId:null;

    //                     // calculate count 

    //                     if(res[7].status && res[7].data.hlPercentage>0){

    //                         hlPercentage = res[7].data.hlPercentage;
    //                       }else{
    //                         throw new ErrorResponse(99998, 'No HL percentages found for selected Grade Range.');
    //                       }



    //                       const productWeight = stockEntity.totalCartons*stockEntity.pouches*stockEntity.pouchWeight;
    //                     const finalWeight = productWeight*Number((res[2].data.finalPercentage))/100;
    //                     const usableCases = finalWeight/(stockEntity.pouches*stockEntity.pouchWeight);


    //                     const fgStock = new FGStockData(stockEntity.stockId, stockEntity.saleOrderId, saleOrder.saleOrderNumber, stockEntity.saleOrderItemId, stockEntity.brandId, brand, stockEntity.minGrade, stockEntity.maxGrade, stockEntity.varientId, varient, stockEntity.pouches, stockEntity.pouchWeight, stockEntity.categoryId, 'category', stockEntity.productId, product, stockEntity.totalCartons,stockEntity.totalPouches,stockEntity.loosePouches, stockEntity.location, location,  stockEntity.date, stockEntity.stockType, stockEntity.status, stockEntity.pallet, stockEntity.totalCartons, 0, null, null, soakingStyle, soakingTime, uom, shrimpWeight, finalWeight, usableCases, stockEntity.lotNo)
    //                     fgStockInfo.push(fgStock);
    //                   })
    //             }

    //             return new GetAllRepackingStockResponseModel(true, 1111, 'Re-Processing Stock Found', fgStockInfo)
    //         } else {
    //             throw new ErrorResponse(11106, 'Stock not found.');
    //         }
    //     } catch (error) {
    //         return error
    //     }
    // }

    async getAllAssignableReProcessingStock(req: ReProcessingDtoReq): Promise<GetAllRepackingStockResponseModel> {
        try {
            console.log('dfghjk')
            console.log(req)

            let hlPercentage;
            let productMinCount;
            let productMaxCount;
            const hlPercentagedata = await this.hlPerService.getHlPercentageByRange(
                new HlPercentageRangeRequest(
                    req.maxGrade,
                )
            );

            await Promise.all([hlPercentagedata]).then(res => {
                // calculate count 
                if (res[0].status && res[0].data.hlPercentage > 0) {

                    hlPercentage = res[0].data.hlPercentage;
                } else {
                    throw new ErrorResponse(99998, 'No HL percentages found for selected Grade Range.');
                }

                let gmsMinWeight
                let gmsMaxWeight

                //weight calculation 
                gmsMinWeight = 454 / req.minGrade;
                gmsMaxWeight = 454 / req.maxGrade;

                let outputMinWeight
                let outputMaxWeight
                if (hlPercentage != 0) {
                    outputMinWeight = gmsMinWeight / ((hlPercentage / 100));
                    outputMaxWeight = gmsMaxWeight / ((hlPercentage / 100));
                } else {
                    outputMinWeight = 0
                    outputMaxWeight = 0
                }

                productMinCount = Math.round(1000 / outputMinWeight);
                productMaxCount = Math.round(1000 / outputMaxWeight);
            })
            const reProcessingStock = await this.stockRepository.createQueryBuilder("stock")
                // .where("product_id = " + req.product)
                .where("varient_id in (" + req.variantId + ")")
                // .andWhere("brand_id =" + req.brand)
                // .andWhere("min_grade =" + req.minGrade)
                // .andWhere("max_grade =" + req.maxGrade)
                .andWhere(`total_cartons>0`)
                // .andWhere("min_grade between " + productMinCount + " and " + productMaxCount)
                // .orWhere("max_grade between " + productMinCount + " and " + productMaxCount)
                .andWhere(`stock_type = "` + `${StockStatus.dummy}` + `"`)
                .andWhere(`state = "` + `${FgStockStates.Stock}` + `"`)
                .andWhere("status ='" + FgStockStatus.StockIn + "'")
                // .groupBy("count")
                .getMany();
            if (reProcessingStock && reProcessingStock.length > 0) {
                const fgStockInfo: FGStockData[] = [];
                let assignableRmWeight = 0
                let inventoryWeightInKgs = 0
                let requiredQty = req.requiredRmQty;
                console.log('34567890')
                console.log(requiredQty)
                let key = 0
                //nned to include map for so and so item details
                for (const stockEntity of reProcessingStock) {
                    // const palletDetails =this.palletService.getPalletById({palletId:stockEntity.pallet});

                    // const locationDetails =this.locationsService.getLocationById({locationId:stockEntity.location});

                    const saleOrderDetails = this.saleOrderService.getSaleOrderDataForSoId({ saleOrderId: stockEntity.saleOrderId });

                    const saleOrderItemDetails = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: stockEntity.saleOrderId, saleOrderItemId: stockEntity.saleOrderItemId });


                    await Promise.all([saleOrderDetails, saleOrderItemDetails]).then(res => {
                        const saleOrder: SaleOrderDropDownDto = res[0] ? res[0] : null;

                        const uom = res[1].status ? res[1].data.uom : null;
                        const soakingStyle = res[1].status ? res[1].data.soakingStyle : null;
                        const soakingTime = res[1].status ? res[1].data.soakingTime : null;
                        const shrimpWeight = res[1].status ? res[1].data.shrimpWeight : null;
                        const uomId = res[1].status ? res[1].data.uomId : null;

                        // calculate count 

                        // if(res[7].status && res[7].data.hlPercentage>0){

                        //     hlPercentage = res[7].data.hlPercentage;
                        //   }else{
                        //     throw new ErrorResponse(99998, 'No HL percentages found for selected Grade Range.');
                        //   }



                        let productWeight = stockEntity.totalCartons * stockEntity.pouches * stockEntity.pouchWeight;
                        if (uomId == 2 || uomId == 3) {
                            productWeight = productWeight * 0.454
                        }
                        inventoryWeightInKgs += productWeight;
                        const finalWeightPer = 1000 * Number((res[1].data.finalPercentage)) / 100;
                        const ratio = 1000 / finalWeightPer;
                        const finalWeight = ratio * productWeight
                        assignableRmWeight += finalWeight;
                        key += 1;

                        // const usableCases = finalWeight/(stockEntity.pouches*stockEntity.pouchWeight);

                        const fgStock = new FGStockData(stockEntity.stockId, stockEntity.saleOrderId, saleOrder.saleOrderNumber, stockEntity.saleOrderItemId, stockEntity.brandId, undefined, stockEntity.minGrade, stockEntity.maxGrade, stockEntity.varientId, undefined, stockEntity.pouches, stockEntity.pouchWeight, stockEntity.categoryId, 'category', stockEntity.productId, undefined, stockEntity.totalCartons, stockEntity.totalPouches, stockEntity.loosePouches, stockEntity.location, undefined, stockEntity.date, stockEntity.stockType, stockEntity.status, stockEntity.pallet, stockEntity.totalCartons, 0, null, null, soakingStyle, soakingTime, uom, shrimpWeight, finalWeight, null, stockEntity.lotNo, Number((assignableRmWeight.toFixed(3))), inventoryWeightInKgs)
                        fgStockInfo.push(fgStock);
                    })
                    if (assignableRmWeight >= requiredQty) {
                        break
                    }
                }

                return new GetAllRepackingStockResponseModel(true, 1111, 'Re-Processing Stock Found', fgStockInfo)
            } else {
                throw new ErrorResponse(11106, 'Stock not found.');
            }
        } catch (error) {
            return error
        }
    }
    async getLotWiseReportedQuantity(): Promise<any> {
        try {
            const lotWiseReportedStock = await this.stockRepository.createQueryBuilder("stock")
                .where("date = CURDATE()")
                .select('saleOrderItemId,sum(netWeight) as netWeight')
                .groupBy('saleOrderItemId')
                .getMany();
            console.log(lotWiseReportedStock);
        } catch (error) {
            return error
        }
    }

    // async getAllAssignableRePackingStock(req: RepackingDtoRequest):Promise<GetAllRepackingStockResponseModel>{
    //     try {
    //         const reProcessingStock = await this.stockRepository.createQueryBuilder("stock")
    //             .where("product_id = " + req.product)
    //             // .andWhere("brand_id =" + req.brand)
    //             .andWhere("category_id =" + req.category)
    //             .andWhere("varient_id =" + req.varient)
    //             .andWhere("min_grade =" + req.minGrade)
    //             .andWhere("max_grade =" + req.maxGrade)
    //             .andWhere("soaking_time =" + req.soakingTime)
    //             .andWhere("soaking_style ='" + req.soakingStyle+"'")
    //             .andWhere("stock_type ='" + StockStatus.superDummy+"'")
    //             .andWhere("state ='" + FgStockStates.Stock+"'")
    //             .andWhere(`total_cartons>0`)
    //             .getMany();

    //         if (reProcessingStock&&reProcessingStock.length>0) {
    //             const fgStockInfo : FGStockData[] =[];
    //             for(const stockEntity of reProcessingStock){
    //                 // const palletDetails =this.palletService.getPalletById({palletId:stockEntity.pallet});

    //                 const locationDetails =this.locationsService.getLocationById({locationId:stockEntity.location});

    //                 const saleOrderDetails =this.saleOrderService.getSaleOrderDataForSoId({saleOrderId:stockEntity.saleOrderId});

    //                 const saleOrderItemDetails =this.saleOrderService.getSaleOrderItemDetails({saleOrderId:stockEntity.saleOrderId,saleOrderItemId:stockEntity.saleOrderItemId});

    //                 const brandId = this.endCustomerRepository.getBrandsById({ brandId: stockEntity.brandId });
    //                 const productId = this.productRepository.getActiveProductById({ productId: stockEntity.productId });

    //                 const variantId = this.skuCodesRepository.getSkuDataById({ skuCodeId: stockEntity.varientId });

    //                 const netWeightData = this.saleOrderService.getReProcessingRequiredQuantity({productId: stockEntity.productId, saleOrderId: stockEntity.saleOrderId, saleOrderItemId: stockEntity.saleOrderItemId});


    //                 await Promise.all([locationDetails, saleOrderDetails, saleOrderItemDetails, brandId, productId, variantId, netWeightData]).then(res => {
    //                     const location: string = res[0].status ? res[0].data.locationName : null;
    //                     const saleOrder: SaleOrderDropDownDto = res[1] ? res[1] : null;

    //                     const brand: string = res[3].status ? res[3].data.brandName : null;
    //                     const product: string = res[4].status ? res[4].data.productCode : null;
    //                     const varient: string = res[5].status ? res[5].data.variantCode : null;
    //                     const netWeight: number = res[6] ;
    //                     const uom =res[2].status?res[2].data.uom:null;
    //                     const soakingStyle =res[2].status?res[2].data.soakingStyle:null;
    //                     const soakingTime =res[2].status?res[2].data.soakingTime:null;
    //                     const shrimpWeight =res[2].status?res[2].data.shrimpWeight:null;
    //                     console.log(shrimpWeight);
    //                     console.log(res[2].data);
    //                     const fgStock = new FGStockData(stockEntity.stockId, stockEntity.saleOrderId, saleOrder.saleOrderNumber, stockEntity.saleOrderItemId, stockEntity.brandId, brand, stockEntity.minGrade, stockEntity.maxGrade, stockEntity.varientId, varient, stockEntity.pouches, stockEntity.pouchWeight, stockEntity.categoryId, 'category', stockEntity.productId, product, stockEntity.totalCartons,stockEntity.totalPouches,stockEntity.loosePouches, stockEntity.location, location,  stockEntity.date, stockEntity.stockType, stockEntity.status, stockEntity.pallet, 0, 0, null, null, soakingStyle, soakingTime, uom, shrimpWeight, netWeight, 0, stockEntity.lotNo)
    //                     fgStockInfo.push(fgStock);
    //                   })
    //             }

    //             return new GetAllRepackingStockResponseModel(true, 1111, 'Re-Processing Stock Found', fgStockInfo)
    //         } else {
    //             throw new ErrorResponse(11106, 'Stock not found.');
    //         }
    //     } catch (error) {
    //         return error
    //     }
    // }

    async getAllAssignableRePackingStock(req: RepackingDtoRequest): Promise<GetAllRepackingStockResponseModel> {
        try {
            console.log(req);
            const reProcessingStock = await this.stockRepository.createQueryBuilder("stock")
                // .where("product_id = " + req.product)
                // .andWhere("brand_id =" + req.masterBrandId)
                // .andWhere("category_id =" + req.category)
                .andWhere("varient_id =" + req.varient)
                // .andWhere("min_grade =" + req.minGrade)
                // .andWhere("max_grade =" + req.maxGrade)
                // .andWhere("soaking_time =" + req.soakingTime)
                // .andWhere("soaking_style ='" + req.soakingStyle + "'")
                .andWhere("stock_type in('" + StockStatus.Anticipated + "','" + StockStatus.dummy + "')") //dummy also
                .andWhere("state ='" + FgStockStates.Stock + "'")
                .andWhere("status ='" + FgStockStatus.StockIn + "'")
                .andWhere("unit_id =" + req.unitId)
                .andWhere(`total_cartons>0`)
                .orderBy('date')
                .getMany();

            if (reProcessingStock && reProcessingStock.length > 0) {
                const fgStockInfo: FGStockData[] = [];
                let assignableNetWeight = 0;
                let assignableCartons = 0;
                for (const stockEntity of reProcessingStock) {
                    // const palletDetails =this.palletService.getPalletById({palletId:stockEntity.pallet});

                    // const locationDetails =this.locationsService.getLocationById({locationId:stockEntity.location});

                    const saleOrderDetails = this.saleOrderService.getSaleOrderDataForSoId({ saleOrderId: stockEntity.saleOrderId });

                    const saleOrderItemDetails = this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: stockEntity.saleOrderId, saleOrderItemId: stockEntity.saleOrderItemId });

                    // const brandId = this.endCustomerRepository.getBrandsById({ brandId: stockEntity.brandId });
                    // const productId = this.productRepository.getActiveProductById({ productId: stockEntity.productId });

                    // const variantId = this.skuCodesRepository.getSkuDataById({ skuCodeId: stockEntity.varientId });

                    // const netWeightData = this.saleOrderService.getReProcessingRequiredQuantity({productId: stockEntity.productId, saleOrderId: stockEntity.saleOrderId, saleOrderItemId: stockEntity.saleOrderItemId});


                    await Promise.all([saleOrderDetails, saleOrderItemDetails]).then(res => {
                        const saleOrder: SaleOrderDropDownDto = res[0] ? res[0] : null;
                        const uom = res[1].status ? res[1].data.uom : null;
                        const soakingStyle = res[1].status ? res[1].data.soakingStyle : null;
                        const soakingTime = res[1].status ? res[1].data.soakingTime : null;
                        const shrimpWeight = res[1].status ? res[1].data.shrimpWeight : null;
                        const uomId = res[1].status ? res[1].data.uomId : null
                        // let productWeight = res[1].status ? (res[1].data.caseWeight * stockEntity.totalCartons):0
                        let productWeight = stockEntity.pouches * stockEntity.pouchWeight * stockEntity.totalCartons
                        let multipliedVal = 1

                        if (Number(req.uomId) != stockEntity.uomId) {
                            const uomVal = UnitsOfWeightInput.find(uom => uom.value == Number(req.uomId)).name

                            if (uomVal == 'lb' && (stockEntity.uomId == 1)) {
                                multipliedVal = 2.20462
                            }
                            if (uomVal == 'lb' && stockEntity.uomId == 3) {
                                multipliedVal = 0.0625
                            }
                            if (uomVal == 'lb' && stockEntity.uomId == 4) {
                                multipliedVal = 0.0022
                            }

                            if (uomVal == 'kg' && (stockEntity.uomId == 2)) {
                                multipliedVal = 0.454
                            }
                            if (uomVal == 'kg' && (stockEntity.uomId == 3)) {
                                multipliedVal = 0.0283
                            }
                            if (uomVal == 'kg' && (stockEntity.uomId == 4)) {
                                multipliedVal = 0.001
                            }


                            productWeight = productWeight * multipliedVal

                            // if (uomId == 2 || uomId == 3) {
                            //     if(stockEntity.uomId == 2){
                            //         productWeight = productWeight * 0.454
                            //     }
                            //     productWeight = productWeight * 0.454
                            // }else if(uomId == 1 || uomId == 4){

                            // }
                        }

                        assignableNetWeight += productWeight;

                        assignableCartons += stockEntity.totalCartons;
                        const fgStock = new FGStockData(stockEntity.stockId, stockEntity.saleOrderId, saleOrder.saleOrderNumber, stockEntity.saleOrderItemId, stockEntity.brandId, undefined, stockEntity.minGrade, stockEntity.maxGrade, stockEntity.varientId, undefined, stockEntity.pouches, stockEntity.pouchWeight, stockEntity.categoryId, 'category', stockEntity.productId, undefined, stockEntity.totalCartons, stockEntity.totalPouches, stockEntity.loosePouches, stockEntity.location, undefined, stockEntity.date, stockEntity.stockType, stockEntity.status, stockEntity.pallet, 0, 0, null, null, soakingStyle, soakingTime, uom, shrimpWeight, undefined, 0, stockEntity.lotNo, Number(assignableNetWeight.toFixed(3)), undefined, assignableCartons)
                        fgStockInfo.push(fgStock);
                    })
                    if (assignableNetWeight >= req.requiredQty || assignableCartons >= req.requiredCases) {
                        break
                    }
                }

                return new GetAllRepackingStockResponseModel(true, 1111, 'Re-Processing Stock Found', fgStockInfo)
            } else {
                throw new ErrorResponse(11106, 'Stock not found.');
            }
        } catch (error) {
            return error
        }
    }

    async checkAvailableStockForSo(saleOrderId: number, saleOrderItemId: number): Promise<Stock> {
        // tslint:disable-next-line: typedef
        const stockResponse = await this.stockRepository.findOne({
            where: { saleOrderId: saleOrderId, saleOrderItemId: saleOrderItemId, stocktype: StockStatus.SaleOrder },
        });
        if (stockResponse) {
            return stockResponse;
        } else {
            return null;
        }
    }

    async AssignReprocessQty(req: ReprocessingInputRequest): Promise<StockAssigningResponse> {

        console.log(req);
        const manager = new GenericTransactionManager();
        try {
            let assignedRmQty
            let gmsMinWeight
            let gmsMaxWeight
            let state
            if (req.category == 'reProcess') {
                assignedRmQty = req.rmStockQty;
                state = FgStockStates.AllocatedForReprocessing
            }
            if (req.category == 'rePack') {
                state = FgStockStates.AllocatedForRepacking
                gmsMinWeight = 454 / req.minGrade;
                gmsMaxWeight = 454 / req.maxGrade;
                const productPercentageafterhl = 1000 * req.hlPercentage / 100;
                const productPercentageafterSoaking = productPercentageafterhl * req.finalPercentage / 100;
                console.log("productPercentageafterhl" + productPercentageafterhl);
                console.log(productPercentageafterSoaking);
                const rmRatioPerKg = 1000 / productPercentageafterSoaking;
                console.log(rmRatioPerKg);
                let outputMinWeight
                let outputMaxWeight
                if (req.finalPercentage != 0 && req.hlPercentage != 0) {
                    outputMinWeight = gmsMinWeight / ((req.finalPercentage / 100) * (req.hlPercentage / 100));
                    outputMaxWeight = gmsMaxWeight / ((req.finalPercentage / 100) * (req.hlPercentage / 100));

                } else {
                    outputMinWeight = 0
                    outputMaxWeight = 0
                }
                console.log(outputMinWeight);
                console.log(outputMaxWeight);

                const productMinCount = 1000 / outputMinWeight;
                const productMaxCount = 1000 / outputMaxWeight;
                const avgCount = (productMinCount + productMaxCount) / 2;
                const count = Math.ceil(avgCount);

                let assignedNetQty = req.rmStockQty;
                assignedNetQty = Number(req.totalPouches) * Number(req.shrimpWeight);

                console.log("assignedNetQty");
                console.log(assignedNetQty);

                //conversion of case weight into Kg if UOM in SO is LB 
                if (req.uomId == 2) {
                    assignedNetQty = assignedNetQty * 0.453592
                }
                if (req.uomId == 3) {
                    assignedNetQty = assignedNetQty * 0.0283495
                }
                if (req.uomId == 4) {
                    assignedNetQty = assignedNetQty * 0.001
                }
                console.log(assignedNetQty+"assignedNetQty");
                assignedRmQty = Number(assignedNetQty) * Number(rmRatioPerKg);
                console.log(assignedRmQty+"assignedRmQty 0");
                console.log(rmRatioPerKg);

                assignedRmQty = Number(assignedRmQty) * Number(req.totalCases);
                console.log(req.totalCases+"req.totalCases");
                console.log(assignedRmQty+"assignedRmQty 1");


                console.log(productMinCount+"**"+productMaxCount+"**"+avgCount+"**"+count+"**"+assignedNetQty+"**"+assignedRmQty);
            }
            console.log(req.stockId);
            const stockResponse = await this.stockRepository.find({
                where: { stockId: Raw(alias => `stock_id IN (${req.stockId})`) },
            });
            console.log(stockResponse);
            console.log('99999999999999');
            console.log(stockResponse);
            if (stockResponse) {
                let savedLog
                await manager.startTransaction();
                let stockQty = 0
                for (const stockItem of stockResponse) {
                    stockQty += Number(stockItem.totalCartons * stockItem.pouches * stockItem.pouchWeight)
                    const stockLogObj = new StockLog();
                    stockLogObj.stockId = stockItem.stockId;
                    stockLogObj.oldSoId = stockItem.saleOrderId;
                    stockLogObj.oldSoItemId = stockItem.saleOrderItemId;
                    stockLogObj.updatedSoId = req.saleOrderId;
                    stockLogObj.updatedSoItemId = req.saleOrderItemId;
                    stockLogObj.purpose = req.category;
                    stockLogObj.cartons = stockQty;
                    stockLogObj.plantId = req.plantId;
                    // stockLogObj.updatedUser = req.;
                    savedLog = await manager.getCustomRepository(StockLogRepository).save(stockLogObj);
                    if (!savedLog) {
                        throw new ErrorResponse(11106, 'Something Went Wrong');
                    }

                }
                console.log("savedLog");
                console.log(savedLog);

                if (savedLog) {
                    const updateReProcessedStock = await manager.getCustomRepository(StockRepository).update({ stockId: Raw(alias => `stock_id IN (${req.stockId})`) }, { allocatedSaleOrderId: req.saleOrderId, allocatedSaleOrderItemId: req.saleOrderItemId, state: state });
                    console.log("updateReProcessedStock" + updateReProcessedStock.affected);
                    if (updateReProcessedStock.affected) {
                        console.log(req.saleOrderId+"&&&&&&&&&&&&&&&&&&"+req.saleOrderItemId+"&&&&&&&&&&&&&&&&&&"+assignedRmQty);
                        const bomUpdate = await this.saleOrderService.updateReproceesingQtyInBom(new ReprocessingBOMUpdateRequset(req.saleOrderId, req.saleOrderItemId, assignedRmQty))
                        console.log(bomUpdate);
                        if (bomUpdate.status) {
                            manager.completeTransaction()
                            const response = new StockAssigningResponse(true, 1111, 'Stock Assigned Successfully');
                            return response;
                        } else {
                            await manager.releaseTransaction();
                            throw new ErrorResponse(11106, 'Something Went Wrong went in BOM updation');
                        }
                    } else {
                        await manager.releaseTransaction();
                        throw new ErrorResponse(11106, 'Something Went Wrong');
                    }
                }
                else {
                    await manager.releaseTransaction();
                    throw new CommonResponse(false, 11106, 'Something went wrong');
                }

            } else {
                throw new CommonResponse(false, 11106, 'No stock Exist with requseted saleorder');
            }
        } catch (error) {
            console.log(error);
            await manager.releaseTransaction();
            return error
        }
    }

    async AssignQty(req: FGReStockData): Promise<StockAssigningResponse> {

        try {
            console.log(req);
            const stockEntity = await this.checkAvailableStockForSo(req.assignedSoId, req.assignedSoItemId);
            let assignedCases = Number(req.assigningQty) / Number(req.pouches * req.pouchWeight)

            if (stockEntity) {
                // const updateStatus = await getConnection()
                //         .createQueryBuilder()
                //         .update(Stock)
                //         .set({quantity: ()=>`quantity+${assignedCases}`})
                //         .where("stock_id = "+stockEntity.stockId)
                //         .execute();
                //         if(updateStatus.affected){
                const updateReProcessedStock = await getConnection()
                    .createQueryBuilder()
                    .update(Stock)
                    .set({ totalCartons: () => `total_cartons-${assignedCases}`, netWeight: () => `net_weight-${req.assigningQty}` })
                    .where("stock_id = " + req.stockId)
                    .execute();

                if (updateReProcessedStock.affected) {
                    const response = new StockAssigningResponse(true, 1111, 'Stock Assigned Successfully');
                    return response;
                } else {
                    throw new ErrorResponse(11106, 'Something Went Wrong');
                }
                // }else{
                //     throw new ErrorResponse(11106,'Something Went Wrong');
                // }
            } else {
                // const convertedStockEntity: Stock = this.stockAdapter.convertReprocessDtoToEntity(req, assignedCases);
                // const savedStockEntity: Stock = await this.stockRepository.save(
                //     convertedStockEntity
                // );
                // const savedStockDto: StockDto = this.stockAdapter.convertEntityToDto(savedStockEntity);
                // if (savedStockDto) {
                const updateReProcessedStock = await getConnection()
                    .createQueryBuilder()
                    .update(Stock)
                    .set({ totalCartons: () => `total_cartons-${assignedCases}`, netWeight: () => `net_weight-${req.assigningQty}` })
                    .where("stock_id = " + req.stockId)
                    .execute();
                if (updateReProcessedStock.affected) {
                    const response = new StockAssigningResponse(true, 1111, 'Stock Assigned Successfully');
                    return response;
                } else {
                    throw new ErrorResponse(11106, 'Something Went Wrong');
                }

                // } else {
                //     throw new ErrorResponse(11106,'Something Went Wrong');
                // }
            }
        } catch (error) {
            return error
        }
    }


    async getRePackingStock(req: RepackingDtoRequest): Promise<AssigningStockResponse> {
        try {
            const rePackingStock = await this.stockRepository.createQueryBuilder("stock")
                .select("sum(total_cartons*pouches*pouch_weight) as quantity")
                // .where("product_id = " + req.product)
                // .andWhere("brand_id =" + req.masterBrandId)
                // .andWhere("category_id =" + req.category)
                .andWhere("varient_id =" + req.varient)
                // .andWhere("min_grade =" + req.minGrade)
                // .andWhere("max_grade =" + req.maxGrade)
                // .andWhere("soaking_time =" + req.soakingTime)
                // .andWhere("soaking_style ='" + req.soakingStyle+"'")
                .andWhere("stock_type in('" + StockStatus.Anticipated + "','" + StockStatus.dummy + "')")
                .andWhere("state ='" + FgStockStates.Stock + "'")
                .andWhere("status ='" + FgStockStatus.StockIn + "'")
                .andWhere("unit_id =" + req.unitId)
                .getRawOne();

            if (rePackingStock) {
                return new AssigningStockResponse(true, 1111, 'Re-Packing Stock Found', { profitReproceeQty: rePackingStock.quantity, lossReproceeQty: rePackingStock.quantity })
            } else {
                throw new ErrorResponse(11106, 'Stock not found.');
            }
        } catch (error) {
            return error
        }
    }

    async getAllReProcessingStock(): Promise<AssigningStockResponse> {
        try {
            const reProcessingStock = await this.stockRepository.createQueryBuilder("stock")
                .andWhere("stock_type = '" + StockStatus.dummy + "'")
                .groupBy('product_id, brand_id, min_grade, max_grade')
                .getRawOne();

            if (reProcessingStock) {
                return new AssigningStockResponse(true, 1111, 'Re-Processing Stock Found', reProcessingStock.quantity)
            } else {
                throw new ErrorResponse(11106, 'Stock not found.');
            }
        } catch (error) {
            return error
        }
    }

    async getAllRePackingStock(): Promise<GetAllRepackingStockResponseModel> {
        try {
            const rePackingStock = await this.stockRepository.createQueryBuilder("stock")
                .andWhere("stock_type ='" + StockStatus.superDummy + "'")
                .groupBy('product_id, brand_id, category_id, varient_id, min_grade, max_grade')
                .getRawOne();

            if (rePackingStock) {
                return new GetAllRepackingStockResponseModel(true, 1111, 'Re-Packing Stock Found')
            } else {
                throw new ErrorResponse(11106, 'Stock not found.');
            }
        } catch (error) {
            return error
        }
    }

    /**
     * Warehouse API 
     * Suggest rack postion 
     * @param rackPositionRequest 
     * @returns  
     */
    // async getRackSuggestion(rackPositionRequest: RackPositionRequest): Promise<RackSuggestionsResponseModel> {
    //     console.log(rackPositionRequest);
    //     const checkStockExist = await this.stockRepository.findOne({where:{saleOrderId:rackPositionRequest.saleOrderId, saleOrderItemId:rackPositionRequest.saleOrderItemId,status:FgStockStatus.StockIn},});
    //     console.log(checkStockExist);
    //     if(checkStockExist.saleOrderId===rackPositionRequest.saleOrderId){
    //         const checkPalletAvailability = await this.stockInService.checkPalletAvailability({palletId:checkStockExist.pallet});
    //         if(checkPalletAvailability){
    //             const saleOrderItemDetails = await this.saleOrderService.getSaleOrderItemDetailsBySoItemId({saleOrderId:rackPositionRequest.saleOrderId,saleOrderItemId:rackPositionRequest.saleOrderItemId});
    //             console.log('saleOrderItemDetails'+saleOrderItemDetails.data);
    //             const checkSaleOrder = this.stockInRepository.createQueryBuilder("StockIn")
    //             .select(["pallet_id as palletId","SUM(reported_cases) as reportedCases"])
    //             .where("sale_order_id ="+ rackPositionRequest.saleOrderId )
    //             .andWhere("sale_order_item_id ="+ rackPositionRequest.saleOrderItemId )
    //             .groupBy("pallet_id");
    //             const checkSaleOrderReport = await checkSaleOrder.getRawMany();
    //             console.log(checkSaleOrderReport);
    //             console.log(checkSaleOrderReport.length);
    //             const checkPalletCapacity = await this.packingMethodService.getPalletCapacity({noOfPouches:saleOrderItemDetails.data.noOfPouches,pouchesPerRow:saleOrderItemDetails.data.pouchWeight});
    //             console.log('checkPalletCapacity'+checkPalletCapacity.data.palletCapacity);


    //             if(checkSaleOrderReport.length>0){
    //                 for (const eachItem of checkSaleOrderReport) {
    //                     console.log(eachItem.reportedCases, rackPositionRequest.mastersCartons);
    //                     const calPalletCapacity = checkPalletCapacity.data.palletCapacity - (Number(eachItem.reportedCases) + Number(rackPositionRequest.mastersCartons));
    //                     const checkCapacity = (calPalletCapacity/checkPalletCapacity.data.palletCapacity)*100
    //                     console.log('checkCapacity'+checkCapacity);
    //                     if(checkCapacity >= 0){
    //                         const palletCodes = await this.palletService.getPalletById({palletId:eachItem.palletId});
    //                         const existingPallets = new Pallets(palletCodes.data.palletId,palletCodes.data.palletNo);
    //                         existingPalletData.push(existingPallets);
    //                         message = "Exisiting pallets retrived Successfully. ";
    //                     }
    //                     else{
    //                         message = "Exisiting pallet capacity is not enough. ";
    //                     }
    //                 }
    //             }
    //             else{
    //                 message = "Exisiting pallets not found, go for new pallet. ";
    //             }
    //         }

    //     }
    // }

    /**
     * Warehouse API 
     * Suggest rack postion 
     * @param rackPositionRequest 
     * @returns 
     */
    async getRackSuggestion(rackPositionRequest: RackPositionRequest): Promise<RackSuggestionsResponseModel> {
        try {
            // console.log(rackPositionRequest);
            const checkStockExist = await this.stockRepository.findOne({ where: { saleOrderId: rackPositionRequest.saleOrderId, saleOrderItemId: rackPositionRequest.saleOrderItemId, status: FgStockStatus.StockIn }, });
            // console.log(checkStockExist);
            const checkSaleOrder = await this.stockInRepository.createQueryBuilder("StockIn")
                .select(["pallet_id as palletId", "SUM(reported_cases) as reportedCases, rack_postion as rackPosition"])
                .where("sale_order_id =" + rackPositionRequest.saleOrderId)
                .andWhere("sale_order_item_id =" + rackPositionRequest.saleOrderItemId)
                .groupBy("pallet_id");
            const checkSaleOrderReport = await checkSaleOrder.getRawMany();
            // console.log('checkSaleOrderReport' + checkSaleOrderReport.length);
            const soProcessType = await this.saleOrderService.getSaleOrderDetailsForId({ saleOrderId: rackPositionRequest.saleOrderId });
            const endCustomerId = await this.saleOrderService.getEndCustomerDetails({ saleOrderId: rackPositionRequest.saleOrderId })
            // console.log(endCustomerId);
            const totalCases = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: rackPositionRequest.saleOrderId, saleOrderItemId: rackPositionRequest.saleOrderItemId });
            const saleOrderItemDetails = await this.saleOrderService.getPackingStyleDetails({ saleOrderId: rackPositionRequest.saleOrderId, saleOrderItemId: rackPositionRequest.saleOrderItemId });
            // console.log('saleOrderItemDetails' + saleOrderItemDetails.data.pouches + '===' + saleOrderItemDetails.data.pouchWeight);
            const checkPalletCapacity = await this.packingMethodService.getPalletCapacity({ noOfPouches: saleOrderItemDetails.data.pouches, pouchesPerRow: saleOrderItemDetails.data.pouchWeight, uomId: saleOrderItemDetails.data.uomId });
            // console.log('checkPalletCapacity' + checkPalletCapacity.data);
            if (checkPalletCapacity.status) {
                const palletCapacity = (rackPositionRequest.mastersCartons / checkPalletCapacity.data.palletCapacity) * 100;
                let palletStatus: string = undefined;
                if (palletCapacity > 100) {
                    palletStatus = "Reporting cartons exceeded pallet capacity. ";
                }
                else {
                    palletStatus = "Reporting Cartons. ";
                }
                // if(rackPositionRequest.palletType === PalletType.new){
                //     console.log('endCustomerIdendCustomerId' + endCustomerId.data);
                //         const endCustomerMapping = await this.rackEndCustomerMapService.getAllRacksByEndCustomer({ endCustomerId: endCustomerId.data });
                //         console.log(endCustomerMapping.data);
                //         if (endCustomerMapping.status) {
                //             let rackPositionDto: RackPostions = undefined;
                //             for (const eachItem of endCustomerMapping.data) {
                //                 const rackPositionsForRack = await this.rackPositionService.getRackByRackId({ rackId: eachItem.rackId });
                //                 console.log('rackPositionsForRack' + rackPositionsForRack.status);
                //                 if (rackPositionsForRack.status) {
                //                     rackPositionDto = new RackPostions(endCustomerMapping.data[0].zoneId, rackPositionsForRack.data[0].rackMasterId, rackPositionsForRack.data[0].rackCode,);
                //                 }
                //             }
                //             const rackSuggestionDto = new RackSuggestionDto(rackPositionRequest.plantId, totalCases.data.cases, 0, soProcessType.soProcessType === "MTO" ? true : soProcessType.soProcessType === "MTS" ? false : false, checkPalletCapacity.data.palletCapacity, palletStatus, rackPositionDto);
                //             const response = new RackSuggestionsResponseModel(true, 1111, "Racks data retrived successfully.", rackSuggestionDto);
                //             return response;
                //         }
                //         else {
                //             throw new ErrorResponse(11106, "No racks are allocated for the end customer. ");
                //         }
                // }
                // else{
                if (checkStockExist != undefined) {
                    const palletDetails = await this.palletService.getPalletById({ palletId: checkStockExist.pallet });
                    // console.log(palletDetails);
                    const rackDetails = await this.rackPositionService.getRackByRackId({ rackId: checkStockExist.location });
                    // console.log(rackDetails);
                    const rackFilledPercentage = ((Number(checkStockExist.totalCartons) + Number(rackPositionRequest.mastersCartons)) / checkPalletCapacity.data.palletCapacity) * 100;
                    // console.log(checkPalletCapacity.data.palletCapacity - checkStockExist.totalCartons + '******' + rackFilledPercentage);
                    let existingRackPositionDto: RackPostions = undefined;
                    let newRackPositionDto: RackPostions = undefined;
                    if (rackFilledPercentage <= 70 && rackFilledPercentage > 0) {
                        const getRackPostion = await this.rackPositionService.getRackPositionsForRackMasterId({ rackId: checkStockExist.location });
                        const zoneId = await this.rackService.getRacksForRackId({ rackId: getRackPostion.data.rackId });
                        console.log("zoneId" + zoneId.zoneId);
                        existingRackPositionDto = new RackPostions(getRackPostion.data.zoneId, getRackPostion.data.rackId, getRackPostion.data.rackName, palletDetails.data.palletId, palletDetails.data.palletNo, checkPalletCapacity.data.palletCapacity);
                        // console.log('endCustomerIdendCustomerId' + endCustomerId.data);
                        const endCustomerMapping = await this.rackEndCustomerMapService.getAllRacksByEndCustomer({ endCustomerId: endCustomerId.data });
                        // console.log(endCustomerMapping.data);
                        if (endCustomerMapping.status) {
                            for (const eachItem of endCustomerMapping.data) {
                                const rackPositionsForRack = await this.rackPositionService.getRackByRackId({ rackId: eachItem.rackId });
                                // console.log('rackPositionsForRack' + rackPositionsForRack.status);
                                if (rackPositionsForRack.status) {
                                    newRackPositionDto = new RackPostions(endCustomerMapping.data[0].zoneId, rackPositionsForRack.data[0].rackMasterId, rackPositionsForRack.data[0].rackCode,);
                                }
                            }
                        }
                        const rackSuggestionDto = new RackSuggestionDto(rackPositionRequest.plantId, totalCases.data.cases, checkStockExist.totalCartons === undefined ? 0 : checkStockExist.totalCartons, soProcessType.soProcessType === "MTO" ? true : soProcessType.soProcessType === "MTS" ? false : false, existingRackPositionDto, newRackPositionDto);
                        const response = new RackSuggestionsResponseModel(true, 1111, "Racks data retrived successfully.", rackSuggestionDto);
                        return response;
                    }
                    else {
                        // console.log('endCustomerIdendCustomerId' + endCustomerId.data);
                        const endCustomerMapping = await this.rackEndCustomerMapService.getAllRacksByEndCustomer({ endCustomerId: endCustomerId.data });
                        // console.log(endCustomerMapping.data);
                        if (endCustomerMapping.status) {
                            let existingRackPositionDto: RackPostions = undefined;
                            let newRackPositionDto: RackPostions = undefined;
                            for (const eachItem of endCustomerMapping.data) {
                                const rackPositionsForRack = await this.rackPositionService.getRackByRackId({ rackId: eachItem.rackId });
                                // console.log('rackPositionsForRack' + rackPositionsForRack.status);
                                if (rackPositionsForRack.status) {
                                    newRackPositionDto = new RackPostions(endCustomerMapping.data[0].zoneId, rackPositionsForRack.data[0].rackMasterId, rackPositionsForRack.data[0].rackCode,);
                                }
                            }
                            const rackSuggestionDto = new RackSuggestionDto(rackPositionRequest.plantId, totalCases.data.cases, 0, soProcessType.soProcessType === "MTO" ? true : soProcessType.soProcessType === "MTS" ? false : false, existingRackPositionDto, newRackPositionDto);
                            const response = new RackSuggestionsResponseModel(true, 1111, "Racks data retrived successfully.", rackSuggestionDto);
                            return response;
                        }
                        else {
                            const response = new RackSuggestionsResponseModel(false, 11106, "No racks are allocated for the end customer. ");
                            return response;
                        }
                    }
                }
                else if (checkSaleOrderReport.length > 0) {
                    for (const eachItem of checkSaleOrderReport) {
                        // console.log('eachItem' + eachItem.rackPosition);
                        const palletDetails = await this.palletService.getPalletById({ palletId: eachItem.palletId });
                        // console.log('palletDetails' + palletDetails.data.palletId);
                        const rackDetails = await this.rackPositionService.getRackByRackId({ rackId: eachItem.rackPosition });
                        // console.log(rackDetails);
                        if (checkPalletCapacity.status) {

                            console.log('palletCapacity' + checkPalletCapacity.data.palletCapacity + 'reportedCases' + eachItem.reportedCases + 'reportingCases' + rackPositionRequest.mastersCartons);
                            const rackFilledPercentage = ((Number(eachItem.reportedCases) + Number(rackPositionRequest.mastersCartons)) / checkPalletCapacity.data.palletCapacity) * 100;
                            // console.log('rackFilledPercentage' + rackFilledPercentage);

                            let existingRackPositionDto: RackPostions = undefined;
                            let newRackPositionDto: RackPostions = undefined;
                            if (rackFilledPercentage < 70 && rackFilledPercentage > 0) {
                                const getRackPostion = await this.rackPositionService.getRackPositionsForRackMasterId({ rackId: eachItem.rackPosition });
                                console.log(getRackPostion.data)
                                const zoneId = await this.rackService.getRacksForRackId({ rackId: getRackPostion.data.rackId });
                                console.log("ZoneDetails" + zoneId.zoneId)
                                existingRackPositionDto = new RackPostions(getRackPostion.data.zoneId, getRackPostion.data.rackId, getRackPostion.data.rackName, palletDetails.data.palletId, palletDetails.data.palletNo, checkPalletCapacity.data.palletCapacity);
                                // console.log('endCustomerIdendCustomerId' + endCustomerId.data);
                                const endCustomerMapping = await this.rackEndCustomerMapService.getAllRacksByEndCustomer({ endCustomerId: endCustomerId.data });
                                // console.log(endCustomerMapping.data);
                                if (endCustomerMapping.status) {
                                    let rackPositionDto: RackPostions = undefined;
                                    for (const eachItem of endCustomerMapping.data) {
                                        const rackPositionsForRack = await this.rackPositionService.getRackByRackId({ rackId: eachItem.rackId });
                                        // console.log('rackPositionsForRack' + rackPositionsForRack.status);
                                        if (rackPositionsForRack.status) {
                                            newRackPositionDto = new RackPostions(endCustomerMapping.data[0].zoneId, rackPositionsForRack.data[0].rackMasterId, rackPositionsForRack.data[0].rackCode,);
                                        }
                                    }
                                }
                                const rackSuggestionDto = new RackSuggestionDto(rackPositionRequest.plantId, totalCases.data.cases, 0, soProcessType.soProcessType === "MTO" ? true : soProcessType.soProcessType === "MTS" ? false : false, existingRackPositionDto, newRackPositionDto);
                                const response = new RackSuggestionsResponseModel(true, 1111, "Racks data retrived successfully.", rackSuggestionDto);
                                return response;
                            }
                            else {
                                // console.log('endCustomerIdendCustomerId' + endCustomerId.data);
                                const endCustomerMapping = await this.rackEndCustomerMapService.getAllRacksByEndCustomer({ endCustomerId: endCustomerId.data });
                                // console.log(endCustomerMapping.data);
                                if (endCustomerMapping.status) {
                                    let existingRackPositionDto: RackPostions = undefined;
                                    let newRackPositionDto: RackPostions = undefined;
                                    for (const eachItem of endCustomerMapping.data) {
                                        const rackPositionsForRack = await this.rackPositionService.getRackByRackId({ rackId: eachItem.rackId });
                                        // console.log('rackPositionsForRack' + rackPositionsForRack.status);
                                        if (rackPositionsForRack.status) {
                                            newRackPositionDto = new RackPostions(endCustomerMapping.data[0].zoneId, rackPositionsForRack.data[0].rackMasterId, rackPositionsForRack.data[0].rackCode,);
                                        }
                                    }
                                    const rackSuggestionDto = new RackSuggestionDto(rackPositionRequest.plantId, totalCases.data.cases, 0, soProcessType.soProcessType === "MTO" ? true : soProcessType.soProcessType === "MTS" ? false : false, existingRackPositionDto, newRackPositionDto);
                                    const response = new RackSuggestionsResponseModel(true, 1111, "Racks data retrived successfully.", rackSuggestionDto);
                                    return response;
                                }
                                else {
                                    const response = new RackSuggestionsResponseModel(false, 11106, "No racks are allocated for the end customer. ");
                                    return response;
                                }
                            }
                        }
                        else {
                            const response = new RackSuggestionsResponseModel(false, 11106, "Packing method for So item not found. ");
                            return response;
                        }
                    }
                }
                else {
                    // console.log('endCustomerIdendCustomerId' + endCustomerId.data);
                    const endCustomerMapping = await this.rackEndCustomerMapService.getAllRacksByEndCustomer({ endCustomerId: endCustomerId.data });
                    // console.log(endCustomerMapping.data);
                    if (endCustomerMapping.status) {
                        let existingRackPositionDto: RackPostions = undefined;
                        let newRackPositionDto: RackPostions = undefined;
                        for (const eachItem of endCustomerMapping.data) {
                            const rackPositionsForRack = await this.rackPositionService.getRackByRackId({ rackId: eachItem.rackId });
                            // console.log('rackPositionsForRack' + rackPositionsForRack.status);
                            if (rackPositionsForRack.status) {
                                newRackPositionDto = new RackPostions(endCustomerMapping.data[0].zoneId, rackPositionsForRack.data[0].rackMasterId, rackPositionsForRack.data[0].rackCode,);
                            }
                        }
                        const rackSuggestionDto = new RackSuggestionDto(rackPositionRequest.plantId, totalCases.data.cases, 0, soProcessType.soProcessType === "MTO" ? true : soProcessType.soProcessType === "MTS" ? false : false, existingRackPositionDto, newRackPositionDto);
                        const response = new RackSuggestionsResponseModel(true, 1111, "Racks data retrived successfully.", rackSuggestionDto);
                        return response;
                    }
                    else {
                        const response = new RackSuggestionsResponseModel(false, 11106, "No racks are allocated for the end customer. ");
                        return response;
                    }
                }
                // }

            }
            else {
                const response = new RackSuggestionsResponseModel(false, 11107, "No pallet capacity found for the packing method. ");
                return response;
            }
        }
        catch (error) {
            return error
        }
    }


    /**
     * get product details for a pallet relared sale order item id
     * @param req 
     * @returns 
     */
    async productDetailsForPalletId(req: InputIdRequest): Promise<SaleOrderItemsBySoIdReaponseModel> {
        try {
            const saleOrderItemId = await this.stockRepository.findOne({ select: ['saleOrderId', 'saleOrderItemId'], where: { pallet: req.inputId, status: FgStockStatus.StockIn } });
            if (!saleOrderItemId) {
                const stockInRes = await this.stockInService.productDetailsForPalletId(req);
                if (!stockInRes.status) {
                    throw new ErrorResponse(10000, 'Pallet not avaiable in stock/In transit');
                }
                return stockInRes;
            } else {
                return await this.saleOrderService.getProductDetailsBySoItemId({ saleOrderId: saleOrderItemId.saleOrderId, saleOrderItemId: saleOrderItemId.saleOrderItemId });
            }
        } catch (error) {
            return error
        }
    }

    /**
     * get pallet details for rack position id
     * @param req 
     * @returns 
     */
    async getPalletDetailsForRackPosition(req: InputIdRequest): Promise<PalletsResponseModel> {
        try {
            const palletId = await this.stockRepository.findOne({ select: ['pallet'], where: { location: req.inputId, status: FgStockStatus.StockIn } });
            if (!palletId) {
                throw new ErrorResponse(10000, 'Rack Position not avaiable in stock');
            }
            return await this.palletService.getPalletById(new PalletRequest(palletId.pallet));
        } catch (error) {
            return error
        }
    }
    async getRackPostionToAssign(rackPositionQtyRequest: RackPositionQtyRequest): Promise<RackPositionServiceResponseModel> {
        try {
            const stock = await this.stockRepository.findOne({ where: { saleOrderId: rackPositionQtyRequest.saleOrderId, saleOrderItemId: rackPositionQtyRequest.saleOrderItemId } });
            const totalCases = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: rackPositionQtyRequest.saleOrderId, saleOrderItemId: rackPositionQtyRequest.saleOrderItemId });
            const soProcessType = await this.saleOrderService.getSaleOrderDetailsForId({ saleOrderId: rackPositionQtyRequest.saleOrderId });
            if (!totalCases.status) {
                throw new ErrorResponse(10000, 'Sale Order item data not found.');
            }
            const data = new RackSuggestionDto(rackPositionQtyRequest.plantId, totalCases.data.cases, (stock) ? stock.totalCartons : 0, soProcessType.soProcessType === "MTO" ? true : soProcessType.soProcessType === "MTS" ? false : false)
            const response = new RackPositionServiceResponseModel(true, 1111, "Racks data retrived successfully.", data);
            return response;
        } catch (error) {
            return error
        }
    }
    async getOutBoundDataSubmission(outBoundRequest: OutBoundRequest): Promise<GetForkLiftJobResponseModel> {
        try {
            const forkLiftJobItemsData: ForkLiftItemsDTO[] = [];
            // const getPalletByPalletNo = await this.palletService.getPalletByPalletNo({plantId:outBoundRequest.plantId,palletId:outBoundRequest.palletNo})
            // if(getPalletByPalletNo.status){
            const stockDetails = await this.stockRepository.find({ where: { pallet: outBoundRequest.palletNo, status: FgStockStatus.StockIn } });
            if (stockDetails.length > 0) {
                stockDetails.forEach(stock => {
                    const forkLiftJobItemData = new ForkLiftItemsDTO(stock.saleOrderId, stock.saleOrderItemId, stock.pallet, stock.location, stock.location, stock.location, stock.date, stock.createdUser, stock.updatedUser);
                    forkLiftJobItemsData.push(forkLiftJobItemData);
                });
                const forkLiftJobData = new ForkLiftJobDTO(0, "", new Date(), ForkLiftJobStatus.Open, 2, TransactionType.dispatch, forkLiftJobItemsData, "Admin", outBoundRequest.plantId, "")
                const raiseForkLiftJob = await this.forkLiftJobService.createForkLiftJob(forkLiftJobData)
                if (raiseForkLiftJob.status) {
                    return new GetForkLiftJobResponseModel(true, 1010, "Outbound jobs raised successfully. ", raiseForkLiftJob.data);
                }
                else {
                    return new GetForkLiftJobResponseModel(false, 1010, "Something went wrong. ");
                }
                return raiseForkLiftJob;
            }
            else {
                return new GetForkLiftJobResponseModel(false, 1010, "Stock Data not found. ");
            }
            // }
            // else{
            //     return new GetForkLiftJobResponseModel(false, 1010, "Pallet not found. ");
            // }
        } catch (error) {
            return error
        }
    }

    async getStockQtyForSo(saleOrderIdRequest: StockSoRequest): Promise<StockQtyResponseModel> {
        try {

            const totalsQty = await this.stockRepository.createQueryBuilder("stock").select("sale_order_id as saleOrderId, stock_id as stockId, sum(total_cartons) as totQty").andWhere("sale_order_id  = " + saleOrderIdRequest.saleOrderId).andWhere("status  = '" + FgStockStatus.StockIn + "'").groupBy('sale_order_id').getRawOne();
            console.log(totalsQty);
            if (totalsQty) {
                const data = new StockResponseDto(totalsQty.saleOrderId, totalsQty.stockId, totalsQty.totQty);
                return new StockQtyResponseModel(true, 1001, 'Rm stock retrived successfully', data);
            }
            else {
                return new StockQtyResponseModel(false, 1010, 'No data found');
            }
        } catch (error) {
            return error
        }
    }
    async getStockQtyForSoAndSoItem(req: SaleOrderItemsRequest): Promise<StockQtyResponseModel> {
        try {

            const totalsQty = await this.stockRepository.createQueryBuilder("stock").select("sale_order_id as saleOrderId, stock_id as stockId, sum(total_cartons) as totQty").andWhere("sale_order_id  = " + req.saleOrderId).andWhere("sale_order_item_id  = " + req.saleOrderItemId).andWhere("status  = '" + FgStockStatus.StockIn + "'").groupBy('sale_order_id').getRawOne();
            console.log(totalsQty);
            if (totalsQty) {
                const data = new StockResponseDto(totalsQty.saleOrderId, totalsQty.stockId, totalsQty.totQty);
                return new StockQtyResponseModel(true, 1001, 'Rm stock retrived successfully', data);
            }
            else {
                return new StockQtyResponseModel(false, 1010, 'No data found');
            }
        } catch (error) {
            return error
        }
    }

    /**
     * get stock with stock in status
     * @param req 
     */
    async getStockInData(req: SoPlantRequest): Promise<StockOutResponse> {
        let stockInDetails;
        if (req.saleOrderId !== 0) {
            stockInDetails = await this.stockRepository.find({ select: ["stockId", "lotNo", "saleOrderId", "location", "totalCartons", "totalPouches", "loosePouches", "pouchWeight", "pallet", "saleOrderItemId", "palletCode"], where: { plantId: req.plantId, saleOrderId: req.saleOrderId, status: FgStockStatus.StockIn } });
        } else {
            stockInDetails = await this.stockRepository.find({ select: ["stockId", "lotNo", "saleOrderId", "location", "totalCartons", "totalPouches", "loosePouches", "pouchWeight", "pallet", "saleOrderItemId", "palletCode"], where: { plantId: req.plantId, status: FgStockStatus.StockIn } });
        }

        if (stockInDetails.length === 0) {
            throw new ErrorResponse(10000, 'Stock out data not found.');
        }
        const stockOutModelArry: StockOutModel[] = [];
        for (const stockIn of stockInDetails) {
            const reportingInfo = await this.stockInRepository.findOne({ select: ["coldStorageId", "packingCompleted"], where: { lotCode: stockIn.lotNo, saleOrderId: stockIn.saleOrderId, saleOrderItemId: stockIn.saleOrderItemId, palletId: stockIn.pallet, rackPostion: stockIn.location, unitId: req.plantId } });
            let coldStorage = '';
            if (reportingInfo) {
                const zoneData = await this.zoneService.getZoneById({ zoneId: reportingInfo.coldStorageId });
                coldStorage = (zoneData) ? zoneData.zoneName : '';
            }
            const rackPositionData = await this.rackPositionService.getRackPositionsForRackMasterId({ rackId: stockIn.location });
            const palletData = await this.palletService.getPalletById({ palletId: stockIn.pallet });
            const saleOrderData = await this.saleOrderService.getSaleOrderDataForSoId({ saleOrderId: stockIn.saleOrderId });
            stockOutModelArry.push(new StockOutModel(stockIn.stockId, stockIn.lotNo, (saleOrderData) ? saleOrderData.saleOrderNumber : '', (rackPositionData.status) ? rackPositionData.data.rackName : '', stockIn.totalPouches * stockIn.pouchWeight, stockIn.totalCartons, stockIn.totalPouches, stockIn.loosePouches, stockIn.pouchWeight, (palletData.status) ? palletData.data.palletNo : '', coldStorage, reportingInfo.packingCompleted, stockIn.palletCode, stockIn.zoneId));
        }
        return new StockOutResponse(true, 1001, 'Stock out data retrieved successfully', stockOutModelArry);
    }

    /**
     * update stock status
     * @param stockStatusRequest 
     * @returns 
     */
    async updateStockOutStatus(stockStatusRequest: BulkStockOutRequest[]): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            const connection = getManager();
            console.log(stockStatusRequest);
            const stockOutData: BulkStockOutRequest[] = stockStatusRequest;
            let stockData;
            let updateRackPosition
            const flagSet = new Set<Boolean>()
            let forklistItems: ForkLiftItemsDto[] = []
            let stock;
            let totIssuedQty = 0
            let totJobCartons = 0
            for (const iterator of stockOutData) {
                console.log("iterator");
                console.log(iterator);

                stock = await this.stockRepository.findOne({
                    select: ['allocatedSaleOrderId', 'allocatedSaleOrderItemId', 'location', 'stockOutQty', 'stockInQty', 'totalCartons', 'saleOrderId', 'saleOrderItemId', 'plantId', 'pallet', 'location', 'pouches', 'pouchWeight','stockType'], where: {
                        stockId: iterator.stockId
                    }
                });
                const forklistItemsDto = new ForkLiftItemsDto();
                if (iterator.stockOutType === "Dispatch") {
                    forklistItemsDto.saleOrderId = stock.saleOrderId
                    forklistItemsDto.saleOrderItemId = stock.saleOrderItemId
                    forklistItemsDto.issuedQuantity = 0
                }
                else {
                    forklistItemsDto.saleOrderId = stock.allocatedSaleOrderId
                    forklistItemsDto.saleOrderItemId = stock.allocatedSaleOrderItemId
                    forklistItemsDto.issuedQuantity = iterator.issuedQty
                }
                
                totIssuedQty = totIssuedQty + iterator.issuedQty;
                totJobCartons = totJobCartons + iterator.stockOutQty

                forklistItemsDto.pallet = stock.pallet
                forklistItemsDto.currentPosition = stock.location
                forklistItemsDto.jobCartons = iterator.stockOutQty
                forklistItemsDto.stockId = iterator.stockId
                forklistItemsDto.unitId = stock.plantId
                forklistItems.push(forklistItemsDto);
                console.log(iterator);
                console.log(stock);

                const udatedstockOutQty = Number(iterator?.stockOutQty) + Number(stock?.stockOutQty)
                console.log("updatedTotcartons" + udatedstockOutQty);

                const updatedTotcartons = Number(stock.stockInQty) - Number(udatedstockOutQty);
                console.log("updatedTotcartons" + updatedTotcartons);
                console.log(Number(iterator?.stockOutQty));
                console.log(Number(stock?.stockOutQty));
                console.log(Number(stock.stockInQty));
                if (updatedTotcartons >= 0) {
                    console.log("hhhhhhhh")
                    if (updatedTotcartons == 0) {
                        iterator.status = FgStockStatus.StockOut
                    }
                    if ((iterator.stockOutType == StockTypesEnum.RE_PACK) || iterator.stockOutType == StockTypesEnum.RE_PROCESS) {
                        const state = iterator.stockOutType == StockTypesEnum.RE_PACK ? updatedTotcartons != 0 ? FgStockStates.PartiallyAssignedForRepacking : FgStockStates.AssignedForRepacking : FgStockStates.AssignedForReprocessing
                        const updateState = await manager.getCustomRepository(StockRepository).update({ stockId: iterator.stockId }, { state: state });
                        if (!updateState) {
                            await manager.releaseTransaction()
                            return new CommonResponse(false, 11111, 'Something went wrong in state updation')
                        }
                    }
                    const updateStatus = await manager.getCustomRepository(StockRepository).update({ stockId: iterator.stockId }, { status: iterator.status, updatedUser: iterator.updatedUser, stockOutQty: udatedstockOutQty, totalCartons: updatedTotcartons });
                    console.log(updateStatus)

                    const checkStockExist = await manager.getCustomRepository(StockRepository).find({ where: { location: stock.location, status: FgStockStatus.StockIn } });
                    console.log("checkStockExist" + checkStockExist.length);
                    if (updateStatus.affected > 0) {
                        console.log("flag set true");
                        flagSet.add(true)
                    } else {
                        await manager.releaseTransaction()
                        flagSet.add(false)
                        return new CommonResponse(false, 11111, 'Something went wrong in updation')
                    }
                    if (stock) {
                        console.log("updatedTotcartons" + updatedTotcartons);
                        if (updatedTotcartons == 0 && checkStockExist.length == 0) {
                            updateRackPosition = await this.rackPositionRepository.freeRackPostionOccupancy({ rackId: stock.location });
                            console.log("updateRackPosition" + updateRackPosition);
                            if (!updateRackPosition.status) {
                                await manager.releaseTransaction();
                                return new CommonResponse(false, 1001, 'Stock status update failed');
                            }
                        }
                    }
                    if (updateStatus.affected > 0) {
                        let getReportedCases = 'select reported_cases AS reportedCases,dispatched_qty AS dispatchedQty from ' + appSettings.sales_db + '.sale_order_items where sale_order_item_id =' + stock.saleOrderItemId;
                        let reportedData = await connection.query(getReportedCases);
                        console.log(reportedData[0])
                        let reportedCases = reportedData[0].reportedCases;
                        let dispatchedQty = reportedData[0].dispatchedQty;
                        let updateCases = iterator.stockOutType === "Dispatch" ? Number(reportedCases) : iterator.stockOutType === StockTypesEnum.RE_PACK ? Number(reportedCases) - Number(iterator.stockOutQty):iterator.stockOutType === StockTypesEnum.RE_PROCESS ? Number(reportedCases) - Number(iterator.stockOutQty):Number(reportedCases);
                        console.log("**********************");
                        console.log(updateCases);
                        let updateDispatchCases = iterator.stockOutType === "Dispatch" ? Number(dispatchedQty) + Number(iterator.stockOutQty) : Number(dispatchedQty);
                        let updateResult = await this.saleOrderService.updateReportedAndDispatchCases({ saleOrderItemId: stock.saleOrderItemId, reported: updateCases, dispatch: updateDispatchCases, dispatchStatus: iterator.stockOutType })
                        // let updateReportedCases='update '+appSettings.sales_db+'.sale_order_items set reported_cases='+updateCases+' where sale_order_item_id ='+stock.saleOrderItemId;
                        // let updateResult=await connection.query(updateReportedCases);
                        console.log(updateResult)
                        console.log(updateResult.status)
                        if (updateResult.status) {
                            flagSet.add(true)
                        }
                        else {
                            flagSet.add(false)
                            await manager.releaseTransaction();
                            return new CommonResponse(false, 1001, 'Reported Cases update failed');
                        }
                    }
                    else {
                        flagSet.add(false)
                        await manager.releaseTransaction();
                        return new CommonResponse(false, 1001, 'Stock not updated, something went wrong. ');
                    }
                }
                else {
                    console.log("Break point")
                    await manager.releaseTransaction();
                    return new CommonResponse(false, 1001, 'Stock Out qty should be less than Stock.');
                }

            }
            let transactionType
            let jobStatus = ForkLiftJobStatus.Open
            if (stockStatusRequest[0].stockOutType == StockTypesEnum.Dispatch) {
                transactionType = TransactionType.dispatch
                jobStatus = ForkLiftJobStatus.Completed
            }
            if (stockStatusRequest[0].stockOutType == StockTypesEnum.RE_PACK) {
                transactionType = TransactionType.repacking
            }
            if (stockStatusRequest[0].stockOutType == StockTypesEnum.RE_PROCESS) {
                transactionType = TransactionType.reprocessing
            }

            const forklistJobObj = new ForkLiftJobDTO(0, "", new Date(), jobStatus, null, transactionType, forklistItems, "Admin", stock.plantId, "", undefined, totJobCartons, totIssuedQty, 0, 0, 0, null, null)
            const raiseForkLiftJob = await this.forkLiftJobService.createForkLiftJob(forklistJobObj)
            console.log("raiseForkLiftJob" + raiseForkLiftJob);
            if (raiseForkLiftJob.status) {

                if (!(flagSet.has(false))) {
                    manager.completeTransaction();
                    return new CommonResponse(true, 1001, 'Stock status updated successfully');
                } else {
                    await manager.releaseTransaction();
                    return new CommonResponse(false, 1001, 'Stock status update failed');
                }
            } else {
                await manager.releaseTransaction();
                return new CommonResponse(false, 1001, 'Something Went wrong in forklistItems updation');
            }

        }
        catch (error) {
            await manager.releaseTransaction();
            return error
        }
    }
    async getStockOutData(req: PlantIdRequest): Promise<getDispatchListResponseModel> {
        const outStock = await this.stockRepository.find({ where: { status: FgStockStatus.StockOut, plantId: req.plantId } });
        const response: FGStockData[] = [];
        if (outStock.length > 0) {
            for (const stockEntity of outStock) {
                const locationDetails = this.locationsService.getLocationById({ locationId: stockEntity.location });
                const saleOrderDetails = this.saleOrderService.getSaleOrderDataForSoId({ saleOrderId: stockEntity.saleOrderId });
                const saleOrderItemDetails = this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: stockEntity.saleOrderId, saleOrderItemId: stockEntity.saleOrderItemId });
                const brandId = this.endCustomerRepository.getBrandsById({ brandId: stockEntity.brandId });
                const productId = this.productRepository.getActiveProductById({ productId: stockEntity.productId });
                const variantId = this.skuCodesRepository.getSkuDataById({ skuCodeId: stockEntity.varientId });
                const netWeightData = this.saleOrderService.getReProcessingRequiredQuantity({ productId: stockEntity.productId, saleOrderId: stockEntity.saleOrderId, saleOrderItemId: stockEntity.saleOrderItemId });
                await Promise.all([locationDetails, saleOrderDetails, saleOrderItemDetails, brandId, productId, variantId, netWeightData]).then(res => {
                    const location: string = res[0].status ? res[0].data.locationName : null;
                    const saleOrder: SaleOrderDropDownDto = res[1] ? res[1] : null;
                    const brand: string = res[3].status ? res[3].data.brandName : null;
                    const product: string = res[4].status ? res[4].data.productCode : null;
                    const varient: string = res[5].status ? res[5].data.variantCode : null;
                    const netWeight: number = res[6];
                    const uom = res[2].status ? res[2].data.uom : null;
                    const soakingStyle = res[2].status ? res[2].data.soakingStyle : null;
                    const soakingTime = res[2].status ? res[2].data.soakingTime : null;
                    const shrimpWeight = res[2].status ? res[2].data.shrimpWeight : null;
                    const uomId = res[2].status ? res[2].data.uomId : null;
                    const productWeight = stockEntity.totalCartons * stockEntity.pouches * stockEntity.pouchWeight;
                    const finalWeight = Number(Number(productWeight * (res[2].data.finalPercentage / 100)).toFixed(3));
                    const usableCases = finalWeight / (stockEntity.pouches * stockEntity.pouchWeight);
                    const fgStock = new FGStockData(stockEntity.stockId, stockEntity.saleOrderId, saleOrder.saleOrderNumber, stockEntity.saleOrderItemId, stockEntity.brandId, brand, stockEntity.minGrade, stockEntity.maxGrade, stockEntity.varientId, varient, stockEntity.pouches, stockEntity.pouchWeight, stockEntity.categoryId, 'category', stockEntity.productId, product, stockEntity.totalCartons, stockEntity.totalPouches, stockEntity.loosePouches, stockEntity.location, location, stockEntity.date, stockEntity.stockType, stockEntity.status, stockEntity.pallet, 0, 0, null, null, soakingStyle, soakingTime, uom, shrimpWeight, finalWeight, usableCases, stockEntity.lotNo)
                    response.push(fgStock);
                    return new getDispatchListResponseModel(true, 1001, "Dispatch List retrived successfully. ", response);
                })
            }
        } else {
            return new getDispatchListResponseModel(false, 1010, "No data found. ", response);
        }
    }

    /**
     * get sale orders with stock in status
     * @param req 
     */
    async getStockInSaleOrders_org(req: InputIdRequest): Promise<CommonResponse> {
        // const stockInDetails = await this.stockRepository.find({select:distinct["saleOrderId"],where:{plantId:req.inputId, status:FgStockStatus.StockIn}});
        const stockInDetails = await this.stockRepository.createQueryBuilder('stock')
            .select('distinct sale_order_id as saleOrderId')
            .where(`unit_id=` + req.inputId + ` and status='StockIn' and location>0`)
            .getRawMany();
        console.log(stockInDetails);
        if (stockInDetails.length === 0) {
            throw new ErrorResponse(10000, 'Sale orders not found.');
        }
        // const rawData = await this.connection.query(`SELECT * FROM so_invoice_details`).getRawMany();

        const soData = [];
        for (const stockIn of stockInDetails) {
            const saleOrderData = await this.saleOrderService.getSaleOrderDataForSoId({ saleOrderId: stockIn.saleOrderId });
            soData.push({ saleOrderNumber: (saleOrderData) ? saleOrderData.saleOrderNumber : '', saleOrderId: stockIn.saleOrderId });
        }
        return new CommonResponse(true, 1001, 'Sale orders retrieved successfully', soData);
    }
    async getStockInSaleOrders(req?: InputIdRequest): Promise<CommonResponse> {
        const manager = getManager();
        let stockType;
        let rawData;
        if (req.dispatchType === StockTypesEnum.Dispatch) {
            stockType = "'" + stockTypeEnum.SaleOrder + "'";
            rawData = `SELECT soi.sale_order_id as saleOrderId,po_Number AS saleOrderNumber FROM ` + appSettings.sales_db + `.so_invoice_details soi left join ` + appSettings.sales_db + `.sale_order so on soi.sale_order_id = so.sale_order_id WHERE so.sale_order_id IN(SELECT DISTINCT sale_order_id FROM ` + appSettings.warehouse_db + `.stock s WHERE unit_id=` + req.inputId + ` AND STATUS='StockIn' AND location>0) and so.so_process_type IN ('MTO','MTS') order by po_number ASC`;
            // AND stock_type = 'saleOrder' 

        }
        else if (req.dispatchType === StockTypesEnum.RE_PROCESS) {
            stockType = "'" + stockTypeEnum.Dummy + "'";
            rawData = `SELECT soi.sale_order_id as saleOrderId,po_Number AS saleOrderNumber FROM ` + appSettings.sales_db + `.so_invoice_details soi left join ` + appSettings.sales_db + `.sale_order so on soi.sale_order_id = so.sale_order_id WHERE so.sale_order_id IN(SELECT DISTINCT sale_order_id FROM ` + appSettings.warehouse_db + `.stock s WHERE unit_id=` + req.inputId + ` AND STATUS='StockIn' AND location>0) and so.so_process_type != "MTO" order by po_number ASC`;
        }
        else{
            stockType = "'" + stockTypeEnum.Dummy+"','"+stockTypeEnum.SuperDummy + "'";
            rawData = `SELECT soi.sale_order_id as saleOrderId,po_Number AS saleOrderNumber FROM ` + appSettings.sales_db + `.so_invoice_details soi left join ` + appSettings.sales_db + `.sale_order so on soi.sale_order_id = so.sale_order_id WHERE so.sale_order_id IN(SELECT DISTINCT sale_order_id FROM ` + appSettings.warehouse_db + `.stock s WHERE unit_id=` + req.inputId + ` AND STATUS='StockIn' AND location>0 and (state IN ("Allocated For Repacking","Partially Assigned For Repacking","Stock")) and stock_type IN ('anticipated','superDummy','dummy')) and so.so_process_type IN ('MTO','MTS') order by po_number ASC`;
        }
        console.log(stockType);

        let result = await manager.query(rawData);
        const soData = [];
        for (const stockIn of result) {
            soData.push({ saleOrderNumber: (stockIn) ? stockIn.saleOrderNumber : '', saleOrderId: stockIn.saleOrderId });
        }
        return new CommonResponse(true, 1001, 'Sale orders retrieved successfully', soData);
    }
    async getStockInSaleOrdersDropdown(): Promise<CommonResponse> {
        const manager = getManager();
        const rawData = await manager.query(`SELECT sale_order_id as saleOrderId,po_Number AS saleOrderNumber FROM ` + appSettings.sales_db + `.so_invoice_details WHERE sale_order_id IN(SELECT DISTINCT sale_order_id FROM ` + appSettings.warehouse_db + `.stock WHERE location>0)`);
        // console.log(`SELECT sale_order_id as saleOrderId,po_Number AS saleOrderNumber FROM `+appSettings.sales_db+`.so_invoice_details WHERE sale_order_id IN(SELECT DISTINCT sale_order_id FROM `+appSettings.warehouse_db+`.stock WHERE unit_id=` + req.inputId + ` AND STATUS='StockIn')`);

        const soData = [];
        for (const stockIn of rawData) {
            soData.push({ saleOrderNumber: (stockIn) ? stockIn.saleOrderNumber : '', saleOrderId: stockIn.saleOrderId });
        }
        return new CommonResponse(true, 1001, 'Sale orders retrieved successfully', soData);
    }
    async updatePalletLocation(req: palletLocationRequest): Promise<boolean> {
        const getSaleOrder = await this.stockInRepository.findOne({ stockId: req.stockId });
        console.log(req);
        let res = await getConnection()
            .createQueryBuilder()
            .update(Stock)
            .set({ location: req.location, warehouseIncharge: req.warehouseIncharge, zoneId: req.coldStorage })
            .where("stockId = :stockId", { stockId: req.stockId })
            .execute();
        let res_reporting = await getConnection()
            .createQueryBuilder()
            .update(StockIn)
            .set({ rackPostion: req.location, coldStorageId: req.coldStorage })
            .where("stockId = :stockId", { stockId: req.stockId })
            .execute();
        let rackId = new ReserveRackRequest(req.location, getSaleOrder.saleOrderId != undefined ? getSaleOrder.saleOrderId : 0);
        const updateRackOccupancy = await this.rackPositionService.updateRackPostionOccupancy(rackId)
        if (res.raw['affectedRows'] > 0 && updateRackOccupancy.status) {
            return true;
        } else {
            return false;
        }
    }
    async getAllStock(unitId: number, saleOrderId?: number, role?: string, varientId?: number): Promise<StockResponseData> {
        const entityManager = getManager();
        const stockOutModelArry: StockOutModel[] = [];
        try {
            let dataQuery = `SELECT inv.po_number AS poNumber,so.sale_order_id as saleOrderId,so.sale_order_no AS saleOrderNumber,s.stock_id AS stockId,s.lot_no AS lotNo,s.total_cartons AS totalCartons,s.unit_id AS unitId,s.packing_completed AS packingCompleted,z.zone_name AS coldStorage,r.rack_code AS rackPosition,s.location AS stockLocationId,s.pallet_code AS palletCode,b.brand_name AS brandName,p.name AS productName,sc.variant_code AS variantCode,s.min_grade AS minGrade,s.max_grade AS maxGrade,concat(s.min_grade,'-',s.max_grade) as grade,s.state AS stockState,s.date as stockDate,s.pouches_shortage AS pouchesShortage,s.cartons_shortage AS cartonsShortage,s.stock_type AS stockType,s.product_category as productCategory,pm.packing_method_name  as packStyle, uc.unit_name AS unitName,s.varient_id as varientId 
             FROM ` + warehouseStockTable + ` s LEFT JOIN ` + salesInvTable + ` inv ON inv.sale_order_id=s.sale_order_id LEFT JOIN ` + salesSoTable + ` so ON so.sale_order_id=s.sale_order_id LEFT JOIN ` + salesSoItemTable + ` soi ON soi.sale_order_item_id=s.sale_order_item_id  LEFT JOIN ` + coldStorageTable + ` z ON z.zone_id=s.zone_id LEFT JOIN ` + rackPositionTable + ` r ON r.rack_Position_id=s.location LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=s.brand_id LEFT JOIN ` + appSettings.masters_db + `.products p ON p.product_id=s.product_id LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=s.varient_id LEFT JOIN ` + appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id = s.pack_style_id LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc on uc.unit_code_id = s.unit_id where s.status='StockIn'`;
            if (unitId != 5) {
                dataQuery = dataQuery + ` and s.unit_id=` + unitId;
            }
            if (saleOrderId > 0) {
                dataQuery = dataQuery + ` and s.sale_order_id=` + saleOrderId;
            }
            if (varientId > 0) {
                dataQuery = dataQuery + ` and s.varient_id = ` + varientId;
            }
            dataQuery = dataQuery + ` ORDER BY uc.unit_name ASC, inv.po_number ASC`;
            var stockData: any = await entityManager.query(dataQuery);
            return new StockResponseData(true, 1001, 'Stock data retrieved successfully', stockData);
        } catch (error) {
            return error;
        }
    }

    async getReportedStockForSoId_org(req: SaleOrderIdRequest): Promise<getAllStockInDetailsResponseModel> {
        try {
            const response: StockOutResponseDto[] = [];
            const data = await this.stockRepository.find({ saleOrderId: req.saleOrderId, plantId: req.plantId, status: FgStockStatus.StockIn });

            if (!data) {
                throw new ErrorResponse(10000, 'No data found. ');
            }
            else {
                for (const eachItem of data) {
                    let coldStorage = '';
                    if (eachItem) {
                        const zoneData = await this.zoneService.getZoneById({ zoneId: eachItem.zoneId });
                        coldStorage = (zoneData) ? zoneData.zoneName : '';
                    }
                    const saleOrderItemDetails = await this.saleOrderService.getSaleOrderItemDetailsBySoItemId({ saleOrderId: eachItem.saleOrderId, saleOrderItemId: eachItem.saleOrderItemId });
                    const rackPositionData = await this.rackPositionService.getRackPositionsForRackMasterId({ rackId: eachItem.location });
                    console.log('rackPositionData');
                    console.log(rackPositionData);
                    const palletData = await this.palletService.getPalletById({ palletId: eachItem.pallet });
                    const saleOrderData = await this.saleOrderService.getSaleOrderInformationById({ saleOrderId: eachItem.saleOrderId });
                    const data = new StockOutResponseDto(eachItem.stockId, eachItem.lotNo, saleOrderData.data.saleOrder, rackPositionData.data.rackName, (saleOrderItemDetails.data.noOfPouches * saleOrderItemDetails.data.pouchWeight), eachItem.totalCartons, eachItem.totalCartons * saleOrderItemDetails.data.noOfPouches, eachItem.loosePouches, saleOrderItemDetails.data.pouchWeight, "", coldStorage, eachItem.packingCompleted, eachItem.palletCode, eachItem.location, '', '', eachItem.stockType);
                    response.push(data);
                }
                console.log(response);

                return new getAllStockInDetailsResponseModel(true, 1010, "Reported data retrived successfully. ", response);
            }
        } catch (error) {
            console.log(error);
            return error
        }
    }
    async getReportedStockForSoId(req: SoPlantRequest): Promise<StockResponseData> {
        try {
            const manager = getManager();
            const response: StockOutResponseDto[] = [];
            const data = await this.stockRepository.find({ saleOrderId: req.saleOrderId, plantId: req.plantId, status: FgStockStatus.StockIn });
            const soStatus = await manager.query("select so_process_type AS soProcessType from "+appSettings.sales_db+".sale_order so where so.sale_order_id = "+req.saleOrderId);
            console.log(soStatus[0].soProcessType);
            let concatStr = ''
            if (req.stockOutType == StockTypesEnum.RE_PACK && soStatus[0].soProcessType == "MTS") {
                concatStr = ' and s.state in ("' + FgStockStates.AllocatedForRepacking + '","' + FgStockStates.PartiallyAssignedForRepacking + '")'
            } 
            else if( req.stockOutType == StockTypesEnum.RE_PACK && soStatus[0].soProcessType == "MTO"){
                concatStr = ' and s.stock_type = "superDummy"'
            }
            else if (req.stockOutType == StockTypesEnum.RE_PROCESS) {
                concatStr = ' and s.state in ("' + FgStockStates.AllocatedForReprocessing + '","' + FgStockStates.PartiallyAssignedForReprocessing + '")'
            }
            else if (req.stockOutType == "Dispatch") {
                // concatStr = ' and s.state="' + FgStockStates.Stock + '" and stock_type = "saleOrder" '
                // concatStr = ' and s.stock_type not in ("superDummy") and s.state="' + FgStockStates.Stock + '"' allowed repacking allocated stock to dispatch
                concatStr = ' and s.stock_type not in ("superDummy") '


            }
            let query = `SELECT s.allocated_sale_order_id AS allocatedSaleOrder, sid.po_number AS allocatedCustomerPO, inv.po_number AS poNumber,so.sale_order_id as saleOrderId,so.sale_order_no AS saleOrderNumber,s.stock_id AS stockId,s.lot_no AS lotNo,s.total_cartons AS totalCartons,s.unit_id AS unitId,s.packing_completed AS packingCompleted,z.zone_name AS coldStorage,r.rack_code AS rackPosition,s.location AS stockLocationId,s.pallet_code AS palletCode,b.brand_name AS brandName,p.name AS productName,
            sc.variant_code AS variantCode,s.min_grade AS minGrade,s.max_grade AS maxGrade,concat(s.min_grade,'-',s.max_grade) as grade,s.state AS stockState,soi.pouches,soi.pouch_weight as pouchWeight, soi.soaking_style AS soakingStyle, soi.soaking_time AS soakingTime, s.total_cartons AS stockOutQty,pm.packing_method_name  as packStyle,s.stock_type as stockType,s.pouches_shortage AS pouchesShortage,s.cartons_shortage AS cartonsShortage,s.product_category as productCategory,uc.unit_name as unitName , s.remarks FROM `+ warehouseStockTable + ` s LEFT JOIN ` + salesInvTable + ` inv ON inv.sale_order_id=s.sale_order_id 
            LEFT JOIN `+ salesSoTable + ` so ON so.sale_order_id=s.sale_order_id 
            LEFT JOIN `+ salesSoItemTable + ` soi ON soi.sale_order_item_id=s.sale_order_item_id 
            LEFT JOIN `+ coldStorageTable + ` z ON z.zone_id=s.zone_id
            LEFT JOIN `+ rackPositionTable + ` r ON r.rack_position_id=s.location
            LEFT JOIN `+ appSettings.masters_db + `.master_brands b ON b.master_brand_id=s.brand_id
            LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id=s.product_id
            LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=s.varient_id
            LEFT JOIN `+ appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id = s.pack_style_id
            LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = s.unit_id
            LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = s.allocated_sale_order_id
            where s.status='StockIn' and s.sale_order_id=`+ req.saleOrderId + ` and s.location>0` + concatStr;
            if (req.plantId != 5) {
                query = query + ' and s.unit_id = ' + req.plantId;
            }
            // console.log(query);
            const rawData = await manager.query(query);
            console.log(rawData);
            if (rawData.length > 0) {
                return new StockResponseData(true, 1001, 'Stock data retrieved successfully', rawData);
            }
            else {
                return new StockResponseData(false, 1010, '');
            }
        } catch (error) {
            console.log(error);
            return error
        }
    }


    async getRackDetails(req: RackReserveRequest): Promise<StockResponseData> {
        const manager = getManager();
        let warehouseResponseFront: WarehouseResponseData[] = [];
        let warehouseResponseRear: WarehouseResponseData[] = [];
        try {
            const colCountQuery = `select MAX(rack_column) AS colCount from ` + appSettings.masters_db + `.rack_position where zone_id=` + req.zoneId;
            const colCount = await manager.query(colCountQuery);
            const racksQuery = `select rack_id,rack_code from ` + appSettings.masters_db + `.rack where zone_id=` + req.zoneId + ` and rack_id = ` + req.rackId + ` order by CAST(rack_code as UNSIGNED),rack_code`;
            const racksData = await manager.query(racksQuery);
            console.log("racksQuery" + racksQuery)
            console.log("racksData" + racksData)
            const levelsQuery = `select level_id,level_code from ` + appSettings.masters_db + `.level where is_active= true order by level_id asc`;
            // console.log(levelsQuery)
            const levelsData = await manager.query(levelsQuery);
            // console.log(levelsData);
            const data = [];
            const racksInfo: RackDashboard[] = [];
            if (racksData.length > 0) {
                for (const rack of racksData) {
                    const rackData = new RackDashboard();
                    rackData.rackId = rack.rack_id;
                    rackData.rackName = rack.rack_code;
                    rackData.colCount = colCount[0].colCount;
                    let rackPositionsData = [];
                    for (const level of levelsData) {
                        // console.log(level.level_id);                    
                        const rackPositionsFrontQuery = `SELECT z.zone_id as zoneId,z.zone_code AS zoneCode,r.rack_id as rackId,r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,sid.po_number AS poNumber,b.brand_name as brandName,CONCAT(s.min_grade,'-',s.max_grade) AS grade,p.name AS productName,sk.variant_code as variantCode,s.pallet_code AS palletCode,s.packing_completed AS packingCompleted,s.state AS stockState,s.stock_type AS stockType,r.plant_id AS unitId, UPPER(r.rack_position_type) AS rackPositionType, so.po_number AS poNo, r.is_reserved AS isReserved, sc.variant_code AS variantCode, SUM(st.total_cartons) AS totalCartons, s.pallet_capacity AS palletCapacity, r.rack_level AS rackLevel, r.rack_column AS rackColumn,r.is_active AS isActive FROM ` + appSettings.masters_db + `.rack_position r LEFT JOIN ` + appSettings.warehouse_db + `.stock s ON s.location= r.rack_position_id AND s.stock_id = (SELECT MAX(stock_id) FROM stock s WHERE s.location = r.rack_position_id and s.status = "StockIn") LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.location= r.rack_position_id LEFT JOIN ` + appSettings.masters_db + `.level l ON l.level_id= r.rack_level LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id=r.zone_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details so ON so.sale_order_id=s.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id=r.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.sale_order_items si ON si.sale_order_item_id=st.sale_order_item_id LEFT JOIN  ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id = si.varient_id LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=s.brand_id LEFT JOIN ` + appSettings.masters_db + `.products p ON p.product_id=s.product_id LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=r.varient_id where r.rack_id=` + rack.rack_id + ` and r.rack_position_type='front' and r.rack_level = ` + level.level_id + ` group by r.rack_position_id order by r.rack_column asc,r.rack_level asc, s.stock_id desc`;
                        // const rackPositionsFrontQuery = `SELECT z.zone_id as zoneId,z.zone_code AS zoneCode,r.rack_id as rackId,r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,r.plant_id AS unitId FROM ` + appSettings.masters_db + `.rack_position r LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id=r.zone_id LEFT JOIN ` + appSettings.masters_db + `.level l ON l.level_id= r.rack_level  where r.rack_id=` + rack.rack_id + ` and r.rack_position_type='front' and r.rack_level = `+ level.level_id +` group by r.rack_position_id order by r.rack_column desc,r.rack_level desc`;
                        // console.log('rackPositionsQuery');
                        console.log(rackPositionsFrontQuery);
                        warehouseResponseFront = await manager.query(rackPositionsFrontQuery);
                        // rackData.rackPositions = warehouseResponseFront;
                        // console.log('warehouseResponseFront'+warehouseResponseFront[0].rackCode);
                        const rackPositionsRearQuery = `SELECT z.zone_id as zoneId,z.zone_code AS zoneCode,r.rack_id as rackId,r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,sid.po_number AS poNumber,b.brand_name as brandName,CONCAT(s.min_grade,'-',s.max_grade) AS grade,p.name AS productName,sk.variant_code as variantCode,s.pallet_code AS palletCode,s.packing_completed AS packingCompleted,s.state AS stockState,s.stock_type AS stockType,r.plant_id AS unitId, UPPER(r.rack_position_type) AS rackPositionType, so.po_number AS poNo, r.is_reserved AS isReserved, sc.variant_code AS variantCode, SUM(st.total_cartons) AS totalCartons, s.pallet_capacity AS palletCapacity, r.rack_level AS rackLevel, r.rack_column AS rackColumn,r.is_active AS isActive FROM ` + appSettings.masters_db + `.rack_position r LEFT JOIN ` + appSettings.warehouse_db + `.stock s ON s.location= r.rack_position_id AND s.stock_id = (SELECT MAX(stock_id) FROM stock s WHERE s.location = r.rack_position_id and s.status = "StockIn") LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.location= r.rack_position_id LEFT JOIN ` + appSettings.masters_db + `.level l ON l.level_id= r.rack_level LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id=r.zone_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details so ON so.sale_order_id=s.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id=r.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.sale_order_items si ON si.sale_order_item_id=st.sale_order_item_id LEFT JOIN  ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id = si.varient_id LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=s.brand_id LEFT JOIN ` + appSettings.masters_db + `.products p ON p.product_id=s.product_id LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=r.varient_id where r.rack_id=` + rack.rack_id + ` and r.rack_position_type='rear' and r.rack_level = ` + level.level_id + ` group by r.rack_position_id order by r.rack_column asc,r.rack_level asc,s.stock_id desc`;
                        // const rackPositionsRearQuery = `SELECT z.zone_id as zoneId,z.zone_code AS zoneCode,r.rack_id as rackId,r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,r.plant_id AS unitId FROM ` + appSettings.masters_db + `.rack_position r LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id=r.zone_id LEFT JOIN ` + appSettings.masters_db + `.level l ON l.level_id= r.rack_level  where r.rack_id=` + rack.rack_id + ` and r.rack_position_type='rear' and r.rack_level = `+ level.level_id +` group by r.rack_position_id order by r.rack_column desc,r.rack_level desc`;
                        // console.log(rackPositionsRearQuery);
                        warehouseResponseRear = await manager.query(rackPositionsRearQuery);
                        // console.log(warehouseResponseRear);

                        // rackData.rackPositions = [...warehouseResponseRear,...warehouseResponseFront];
                        rackPositionsData.push.apply(rackPositionsData, warehouseResponseRear);
                        rackPositionsData.push.apply(rackPositionsData, warehouseResponseFront);

                        // rackPositionsData=[...rackPositionsData,warehouseResponseRear];

                        // for(const i of warehouseResponseFront){
                        //     console.log(i.rackCode + "--- RACK");
                        // }
                    }
                    // console.log(rackPositionsData);

                    rackData.rackPositions = rackPositionsData;

                    racksInfo.push(rackData);
                }

                // console.log(racksInfo[0].rackPositions);
                return new StockResponseData(true, 1001, 'data retrieved successfully', racksInfo);
            } else {
                return new StockResponseData(false, 99999, 'Racks Data not found');
            }
            // await new Promise(resolve => setTimeout(resolve, 200));                   
            // warehouseResponse = await manager.find(WarehouseView,{unitId:req.plantId,zoneId:req.zoneId});

        } catch (error) {
            return error;
        }
    }
    async getWarehouseView(req: PlantZone): Promise<StockResponseData> {
        const manager = getManager();
        let warehouseResponseFront: WarehouseResponseData[] = [];
        let warehouseResponseRear: WarehouseResponseData[] = [];
        try {
            const colCountQuery = `select MAX(rack_column) AS colCount from ` + appSettings.masters_db + `.rack_position where zone_id=` + req.zoneId;
            const colCount = await manager.query(colCountQuery);

            const racksQuery = `select rack_id,rack_code from ` + appSettings.masters_db + `.rack where zone_id=` + req.zoneId + ` order by CAST(rack_code as UNSIGNED),rack_code`;
            const racksData = await manager.query(racksQuery);
            const levelsQuery = `select level_id,level_code from ` + appSettings.masters_db + `.level where is_active= true order by level_id asc`;
            // console.log(levelsQuery)
            const levelsData = await manager.query(levelsQuery);
            // console.log(levelsData);
            const data = [];
            const racksInfo: RackDashboard[] = [];
            if (racksData.length > 0) {
                for (const rack of racksData) {
                    const rackData = new RackDashboard();
                    rackData.rackId = rack.rack_id;
                    rackData.rackName = rack.rack_code;
                    rackData.colCount = colCount[0].colCount;
                    let rackPositionsData = [];
                    for (const level of levelsData) {
                        // console.log(level.level_id);                    
                        const rackPositionsFrontQuery = `SELECT z.zone_id as zoneId,z.zone_code AS zoneCode,r.rack_id as rackId,r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,sid.po_number AS poNumber,b.brand_name as brandName,CONCAT(s.min_grade,'-',s.max_grade) AS grade,p.name AS productName,sk.variant_code as variantCode,s.pallet_code AS palletCode,s.packing_completed AS packingCompleted,s.state AS stockState,s.stock_type AS stockType,r.plant_id AS unitId, UPPER(r.rack_position_type) AS rackPositionType, so.po_number AS poNo, r.is_reserved AS isReserved, sc.variant_code AS variantCode, SUM(st.total_cartons) AS totalCartons, s.pallet_capacity AS palletCapacity, r.rack_level AS rackLevel, r.rack_column AS rackColumn,r.is_active AS isActive FROM ` + appSettings.masters_db + `.rack_position r LEFT JOIN ` + appSettings.warehouse_db + `.stock s ON s.location= r.rack_position_id AND s.stock_id = (SELECT MAX(stock_id) FROM stock s WHERE s.location = r.rack_position_id and s.status = "StockIn") LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.location= r.rack_position_id LEFT JOIN ` + appSettings.masters_db + `.level l ON l.level_id= r.rack_level LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id=r.zone_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details so ON so.sale_order_id=s.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id=r.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.sale_order_items si ON si.sale_order_item_id=st.sale_order_item_id LEFT JOIN  ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id = si.varient_id LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=s.brand_id LEFT JOIN ` + appSettings.masters_db + `.products p ON p.product_id=s.product_id LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=r.varient_id where r.rack_id=` + rack.rack_id + ` and r.rack_position_type='front' and r.rack_level = ` + level.level_id + ` group by r.rack_position_id order by r.rack_column asc,r.rack_level asc, s.stock_id desc`;
                        // const rackPositionsFrontQuery = `SELECT z.zone_id as zoneId,z.zone_code AS zoneCode,r.rack_id as rackId,r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,r.plant_id AS unitId FROM ` + appSettings.masters_db + `.rack_position r LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id=r.zone_id LEFT JOIN ` + appSettings.masters_db + `.level l ON l.level_id= r.rack_level  where r.rack_id=` + rack.rack_id + ` and r.rack_position_type='front' and r.rack_level = `+ level.level_id +` group by r.rack_position_id order by r.rack_column desc,r.rack_level desc`;
                        // console.log('rackPositionsQuery');
                        console.log(rackPositionsFrontQuery);
                        warehouseResponseFront = await manager.query(rackPositionsFrontQuery);
                        // rackData.rackPositions = warehouseResponseFront;
                        // console.log('warehouseResponseFront'+warehouseResponseFront[0].rackCode);
                        const rackPositionsRearQuery = `SELECT z.zone_id as zoneId,z.zone_code AS zoneCode,r.rack_id as rackId,r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,sid.po_number AS poNumber,b.brand_name as brandName,CONCAT(s.min_grade,'-',s.max_grade) AS grade,p.name AS productName,sk.variant_code as variantCode,s.pallet_code AS palletCode,s.packing_completed AS packingCompleted,s.state AS stockState,s.stock_type AS stockType,r.plant_id AS unitId, UPPER(r.rack_position_type) AS rackPositionType, so.po_number AS poNo, r.is_reserved AS isReserved, sc.variant_code AS variantCode, SUM(st.total_cartons) AS totalCartons, s.pallet_capacity AS palletCapacity, r.rack_level AS rackLevel, r.rack_column AS rackColumn,r.is_active AS isActive FROM ` + appSettings.masters_db + `.rack_position r LEFT JOIN ` + appSettings.warehouse_db + `.stock s ON s.location= r.rack_position_id AND s.stock_id = (SELECT MAX(stock_id) FROM stock s WHERE s.location = r.rack_position_id and s.status = "StockIn") LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.location= r.rack_position_id LEFT JOIN ` + appSettings.masters_db + `.level l ON l.level_id= r.rack_level LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id=r.zone_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details so ON so.sale_order_id=s.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id=r.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.sale_order_items si ON si.sale_order_item_id=st.sale_order_item_id LEFT JOIN  ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id = si.varient_id LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=s.brand_id LEFT JOIN ` + appSettings.masters_db + `.products p ON p.product_id=s.product_id LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=r.varient_id where r.rack_id=` + rack.rack_id + ` and r.rack_position_type='rear' and r.rack_level = ` + level.level_id + ` group by r.rack_position_id order by r.rack_column asc,r.rack_level asc,s.stock_id desc`;
                        // const rackPositionsRearQuery = `SELECT z.zone_id as zoneId,z.zone_code AS zoneCode,r.rack_id as rackId,r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,r.plant_id AS unitId FROM ` + appSettings.masters_db + `.rack_position r LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id=r.zone_id LEFT JOIN ` + appSettings.masters_db + `.level l ON l.level_id= r.rack_level  where r.rack_id=` + rack.rack_id + ` and r.rack_position_type='rear' and r.rack_level = `+ level.level_id +` group by r.rack_position_id order by r.rack_column desc,r.rack_level desc`;
                        // console.log(rackPositionsRearQuery);
                        warehouseResponseRear = await manager.query(rackPositionsRearQuery);
                        // console.log(warehouseResponseRear);

                        // rackData.rackPositions = [...warehouseResponseRear,...warehouseResponseFront];
                        rackPositionsData.push.apply(rackPositionsData, warehouseResponseRear);
                        rackPositionsData.push.apply(rackPositionsData, warehouseResponseFront);

                        // rackPositionsData=[...rackPositionsData,warehouseResponseRear];

                        // for(const i of warehouseResponseFront){
                        //     console.log(i.rackCode + "--- RACK");
                        // }
                    }
                    // console.log(rackPositionsData);

                    rackData.rackPositions = rackPositionsData;

                    racksInfo.push(rackData);
                }

                // console.log(racksInfo[0].rackPositions);
                return new StockResponseData(true, 1001, 'data retrieved successfully', racksInfo);
            } else {
                return new StockResponseData(false, 99999, 'Racks Data not found');
            }
            // await new Promise(resolve => setTimeout(resolve, 200));                   
            // warehouseResponse = await manager.find(WarehouseView,{unitId:req.plantId,zoneId:req.zoneId});

        } catch (error) {
            return error;
        }
    }

    async getStockForPlant(req: PlantIdRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const query = `SELECT rp.rack_id AS rackId, rp.rack_code AS rackName,so.sale_order_no AS saleOrderNo,st.total_cartons AS cartons, st.stock_id AS stockId,sd.po_number AS poNumber,st.sale_order_id AS saleOrderId, st.sale_order_item_id AS saleOrderItemId, st.location AS rackPositionId, st.unit_id AS plantId, b.brand_name AS brandName, si.min_grade_id AS minGrade, si.max_grade_id AS maxGrade, sk.sku_code_id AS varientId,sk.variant_code AS productName,r.rack_code AS rackCode,zm.zone_id AS coldStorageId,zm.zone_name AS coldStorage, st.pouches As pouches, st.pouch_weight AS pouchWeight, st.total_cartons AS totalCartons,st.pallet_code As pallet,uc.unit_name as unit,st.stock_type AS stockType, pm.packing_method_name AS packStyle FROM ` + appSettings.warehouse_db + `.stock st LEFT JOIN ` + appSettings.masters_db + `.rack_position rp ON rp.rack_position_id=st.location 
            LEFT JOIN ` + appSettings.masters_db + `.rack r ON r.rack_id=rp.rack_id 
            LEFT JOIN ` + appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id=st.pack_style_id 
            LEFT JOIN ` + appSettings.masters_db + `.zone_master zm ON zm.zone_id=r.zone_id 
            LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id=st.sale_order_id 
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sd ON sd.sale_order_id=st.sale_order_id 
            LEFT JOIN ` + appSettings.sales_db + `.sale_order_items si ON si.sale_order_item_id=st.sale_order_item_id 
            LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=si.brand_id 
            LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id=si.varient_id 
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = st.unit_id
            where st.unit_id=`+ req.plantId + ` and st.status= "` + FgStockStatusEnum.StockIn + '"' + ` and st.location != 0 group by st.stock_id order by so.sale_order_id asc , rp.rack_code asc`;
            const getStockData = await manager.query(query);
            // const getStockData = await this.stockRepository.find({
            //     where:{plantId:req.plantId, status:FgStockStatusEnum.StockIn},
            // });
            if (getStockData != undefined) {
                return new CommonResponse(true, 1001, "Stock data retrived successfully. ", getStockData)
            }
            else {
                return new CommonResponse(false, 1010, "No data found. ")
            }
        } catch (err) {
            return err;
        }
    }
    async getLotCodesBySoIdAndSoItemIdTemporary(req: LotCodesRequest): Promise<LotCodesResponseModel> {
        try {
            const manager = getManager();
            const query = `SELECT rm.lot_number as lotNumber FROM ` + appSettings.rm_procure_db + `.grn_items rm 
          where rm.sale_order_id=`+ req.saleOrderId + ` and rm.sale_order_item_id=` + req.saleOrderItemId;
            const lotCodes: LotCodesDTO[] = await manager.query(query);
            if (lotCodes.length > 0) {
                const response = new LotCodesResponseModel(true, 11101, 'lot codes retrieved Successfully', lotCodes);
                return response;
            }
            else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }


    async getStockSummaryReportData(req?: RackZoneLevelRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const getGrades = await this.gradeServices.getAllGrades();
            // console.log(getGrades.data);
            let variantQuery = "SELECT sk.sku_code_id As skuCodeId,sk.short_code as prodShortCode, CONCAT(p.code,ft.food_type_code,val1.code,val2.code,val3.code,val4.code,val5.code,'/',IF(sk.soaking_style = 'STPP 2% + SALT 2%','S2S2', IF(sk.soaking_style = 'Only SALT 2%','OS2', IF(sk.soaking_style = 'NP 2% + SALT 2%','NP2S2', IF(sk.soaking_style = 'NT','NT',''))))) AS varientCode,SUM(st.total_cartons) AS totalCartons, ut.unit_name AS unit FROM " + appSettings.warehouse_db + ".stock st  LEFT JOIN " + appSettings.masters_db + ".uoms u ON u.uom_id=st.uom_id  LEFT JOIN " + appSettings.masters_db + ".sku_codes sk ON sk.sku_code_id=st.varient_id  LEFT JOIN " + appSettings.masters_db + ".products p ON p.product_id=sk.product_id LEFT JOIN " + appSettings.masters_db + ".`food_types` ft ON ft.food_type_id=sk.food_type_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_one_types` val1 ON val1.value_addition_one_id=sk.value_addition_one_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_two_types` val2 ON val2.value_addition_two_id=sk.value_addition_two_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_three_types` val3 ON val3.value_addition_three_id=sk.value_addition_three_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_four_types` val4 ON val4.value_addition_four_id=sk.value_addition_four_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_five_types` val5 ON val5.value_addition_five_id=sk.value_addition_five_id LEFT JOIN " + appSettings.masters_db + ".`rack_position` rp ON rp.rack_position_id=st.location LEFT JOIN " + appSettings.masters_db + ".`unitcodes` ut ON ut.unit_code_id=st.unit_id WHERE sk.sku_code_id is not null and st.status = 'StockIn' ";
            // if (req.unitId != 5 || req.role != "ADMIN") {
            //     variantQuery = variantQuery + ' and st.unit_id = ' + req.unitId;
            // }
            if (req.unitId && req.unitId != null) {
                variantQuery = variantQuery + ' and st.unit_id IN (' + req.unitId.toString() + ')';
            }
            if (req.zoneId > 0) {
                variantQuery = variantQuery + ' and st.zone_id = ' + req.zoneId;
            }
            if (req.rackId > 0) {
                variantQuery = variantQuery + ' and rp.rack_id = ' + req.rackId;
            }
            if (req.levelId > 0) {
                variantQuery = variantQuery + ' and rp.rack_level = ' + req.levelId;
            }
            if (req.stockType) {
                variantQuery = variantQuery + ' and st.stock_type = "' + req.stockType + '"';
            }
            if (req.reportingFromDate != undefined && req.reportingToDate != undefined) {
                variantQuery = variantQuery + ' and DATE(r.reporting_date)  >= "' + req.reportingFromDate + '" and DATE(r.reporting_date) <="' + req.reportingToDate + '"';
            }
            if (req.variantCode && req.variantCode.length > 0) {
                var quotedAndCommaSeparated = "'" + req.variantCode.join("','") + "'";
                variantQuery = variantQuery + ' and CONCAT(p.code,ft.food_type_code,val1.code,val2.code,val3.code,val4.code,val5.code) IN (' + quotedAndCommaSeparated + ')';
            }

            variantQuery = variantQuery + " GROUP BY sk.product_id, sk.food_type_id, sk.value_addition_one_id, sk.value_addition_two_id, sk.value_addition_three_id, sk.value_addition_four_id,sk.value_addition_five_id, sk.soaking_style";
            // if (req.unitId == 5 || req.role == "ADMIN") {
            //     variantQuery = variantQuery + ' ,st.unit_id ';
            // }
            variantQuery = variantQuery + " ORDER BY varientCode";

            const variantCodes = await manager.query(variantQuery);


            let query = "SELECT CONCAT(g.grade_min_count,'-',g.grade_max_count) AS header,sk.short_code as prodShortCode, CONCAT(g.grade_min_count,'/',g.grade_max_count) AS label,SUM(IF(u.uom_name = 'OZ' , (st.total_cartons * st.pouches * st.pouch_weight * 0.0625), IF(u.uom_name = 'KG' ,(st.total_cartons * st.pouches * st.pouch_weight*2.204), IF(uom_name = 'GM' ,(st.total_cartons * st.pouches * st.pouch_weight * 0.0022),(st.total_cartons * st.pouches * st.pouch_weight)))))AS 'totalQty',CONCAT(p.code,ft.food_type_code,val1.code,val2.code,val3.code,val4.code,val5.code,'/',IF(sk.soaking_style = 'STPP 2% + SALT 2%','S2S2', IF(sk.soaking_style = 'Only SALT 2%','OS2', IF(sk.soaking_style = 'NP 2% + SALT 2%','NP2S2', IF(sk.soaking_style = 'NT','NT',''))))) AS variantCode, ut.unit_name AS unit FROM " + appSettings.warehouse_db + ".stock st LEFT JOIN " + appSettings.masters_db + ".uoms u ON u.uom_id=st.uom_id  LEFT JOIN " + appSettings.masters_db + ".sku_codes sk ON sk.sku_code_id=st.varient_id LEFT JOIN " + appSettings.masters_db + ".grades g ON g.grade_id=sk.grade_id LEFT JOIN " + appSettings.masters_db + ".products p ON p.product_id=sk.product_id LEFT JOIN " + appSettings.masters_db + ".`food_types` ft ON ft.food_type_id=sk.food_type_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_one_types` val1 ON val1.value_addition_one_id=sk.value_addition_one_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_two_types` val2 ON val2.value_addition_two_id=sk.value_addition_two_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_three_types` val3 ON val3.value_addition_three_id=sk.value_addition_three_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_four_types` val4 ON val4.value_addition_four_id=sk.value_addition_four_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_five_types` val5 ON val5.value_addition_five_id=sk.value_addition_five_id LEFT JOIN " + appSettings.masters_db + ".`rack_position` rp ON rp.rack_position_id=st.location LEFT JOIN " + appSettings.masters_db + ".`unitcodes` ut ON ut.unit_code_id=st.unit_id WHERE st.status = 'StockIn' ";
            // if (req.unitId != 5 || req.role != "ADMIN") {
            //     query = query + ' and st.unit_id = ' + req.unitId;
            // }
            if (req.unitId) {
                query = query + ' and st.unit_id IN (' + req.unitId.toString() + ')';
            }
            // if (req.unitId && req.unitId != 5) {
            //     query = query + ' and st.unit_id = ' + req.unitId;
            // }
            if (req.zoneId > 0) {
                query = query + ' and st.zone_id = ' + req.zoneId;
            }
            if (req.rackId > 0) {
                query = query + ' and rp.rack_id = ' + req.rackId;
            }
            if (req.levelId > 0) {
                query = query + ' and rp.rack_level = ' + req.levelId;
            }
            if (req.stockType) {
                query = query + ' and st.stock_type = "' + req.stockType + '"';
            }
            if (req.reportingFromDate != undefined && req.reportingToDate != undefined) {
                query = query + ' and DATE(st.date)  >= "' + req.reportingFromDate + '" and DATE(st.date) <="' + req.reportingToDate + '"';
            }
            if (req.variantCode) {
                var quotedAndCommaSeparated = "'" + req.variantCode.join("','") + "'";

                query = query + ' and CONCAT(p.code,ft.food_type_code,val1.code,val2.code,val3.code,val4.code,val5.code) IN (' + quotedAndCommaSeparated + ')';
            }
            query = query + " GROUP BY ";
            // if (req.unitId != 5) {
            //     query = query + 'st.unit_id,';
            // }
            query = query + "sk.product_id, sk.food_type_id, sk.value_addition_one_id, sk.value_addition_two_id, sk.value_addition_three_id, sk.value_addition_four_id, sk.value_addition_five_id , sk.grade_id, sk.soaking_style ORDER BY variantCode, ut.unit_name,header ";
            const reportData = await manager.query(query);
            let data: StockSummaryResponse[] = [];
            for (const vart of variantCodes) {
                let gradeData: gradeResponse[] = [];
                for (const grad of getGrades.data) {
                    // // console.log(grad.gradeName);
                    // let obj = reportData.find(o => o.variantCode === vart.varientCode && o.header === grad.gradeName);
                    // console.log(obj);
                    // if(obj != undefined){
                    //     gradeData.push(new gradeResponse(obj.label,obj.totalQty));
                    // }
                    // else{
                    //     gradeData.push(new gradeResponse(grad.gradeName,0));
                    // }
                    let flag;
                    for (const res of reportData) {
                        if (req.loginUnit != 5) {
                            if (vart.varientCode === res.variantCode && vart.unit === res.unit) {
                                // console.log(grad.gradeName + "   " + res.header);
                                if (grad.gradeName === res.header) {
                                    flag = true;
                                    gradeData.push(new gradeResponse(res.label, res.totalQty));
                                    break;
                                }
                                else {
                                    flag = false;
                                }
                            }
                        }
                        else {
                            if (vart.varientCode === res.variantCode) {
                                // console.log(vart.varientCode === res.variantCode);
                                if (grad.gradeName === res.header) {
                                    flag = true;
                                    gradeData.push(new gradeResponse(res.label, res.totalQty));
                                    break;
                                }
                                else {
                                    flag = false;
                                }
                            }
                        }
                        // }
                    }
                    if (!flag) {
                        gradeData.push(new gradeResponse((grad.gradeMinCount + "/" + grad.gradeMaxCount), 0));
                    }
                    // console.log(flag);
                }
                // console.log("new StockSummaryResponse(vart.varientCode,gradeData)"+new StockSummaryResponse(vart.varientCode,gradeData));
                console.log(gradeData)

                data.push(new StockSummaryResponse(vart.varientCode, vart.unit, vart.totalCartons, gradeData, vart.prodShortCode));
            }
            // console.log(query,'query')

            // console.log("reportData"+reportData);
            console.log(data, '---data---')
            if (data.length > 0) {
                const response = new CommonResponse(true, 11101, 'Data retrieved Successfully', data);
                return response;
            }
            else {
                throw new CommonResponse(false, 11101, 'Data not found', data);
            }
        }
        catch (err) {
            //console.log(err);
            throw err;
        }
    }
    async getTransferStock(req: StockTransferDto): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            const connection = getManager();
            let stockUpdate
            let savedLog
            let updateRackPosition
            console.log(req);
            if (req.transferType === "internal") {
                stockUpdate = await manager.getCustomRepository(StockRepository).update({ stockId: Raw(alias => `stock_id IN (${req.stockIds})`) },{location: req.rackPostion, zoneId: req.zoneId, updatedUser: req.createdUser });
                console.log(stockUpdate);
                const stockLogObj = new StockLog();
                for (const stock of req.stockIds) {
                    let stockDetails = await manager.getCustomRepository(StockRepository).find({where:{location: req.selectedRows.find(rec => rec.stockId === Number(stock)).rackPositionId, status:"stockIn"}});
                    console.log(stockDetails);
                    console.log(stockDetails.length);
                    let occupancy;
                    if(stockDetails.length > 0){
                        occupancy = OccupancyEnum.ASSIGNED;
                    }
                    else{
                        occupancy = OccupancyEnum.NOT_OCCUPIED;
                    }
                    stockLogObj.stockId = Number(stock);
                    stockLogObj.oldRackPositiontId = req.selectedRows.find(rec => rec.stockId === Number(stock)).rackPositionId;
                    stockLogObj.updatedRackPositionId = req.rackPostion;
                    stockLogObj.createdUser = req.createdUser;
                    stockLogObj.purpose = req.transferType;
                    stockLogObj.cartons = req.selectedRows.find(rec => rec.stockId === Number(stock)).cartons;
                    stockLogObj.plantId = req.selectedRows.find(rec => rec.stockId === Number(stock)).plantId;
                    savedLog = await manager.getCustomRepository(StockLogRepository).save(stockLogObj);
                    updateRackPosition = await this.rackPositionRepository.updateOccupancyAfterTransfer({ rackPositionId: req.selectedRows.find(rec => rec.stockId === Number(stock)).rackPositionId, newRackPositionId: req.rackPostion, saleOrderId: req.selectedRows[0].saleOrderId, occupancy:occupancy })
                    if (!savedLog || !updateRackPosition) {
                        throw new ErrorResponse(11106, 'Something Went Wrong');
                    }
                }
                if (stockUpdate.affected && savedLog.stockLogId > 0) {

                        let oldRackPosition = await connection.query("SELECT rack_code AS rack FROM "+appSettings.masters_db+".rack_position WHERE rack_position_id = "+savedLog.oldRackPositiontId);
                        let newRackPosition = await connection.query("SELECT rack_code AS rack FROM "+appSettings.masters_db+".rack_position WHERE rack_position_id = "+savedLog.updatedRackPositionId);
                        let poDetails = await connection.query("SELECT s.total_cartons AS total,u.unit_name AS unit, sk.variant_code AS productSKU, sid.po_number AS poNumber FROM "+appSettings.warehouse_db+".stock s left join "+appSettings.sales_db+".sale_order_items si on si.sale_order_item_id = s.sale_order_item_id left join "+appSettings.masters_db+".sku_codes sk on sk.sku_code_id = si.varient_id left join "+appSettings.masters_db+".unitcodes u on u.unit_code_id = s.unit_id left join "+appSettings.sales_db+".so_invoice_details sid on sid.sale_order_id = s.sale_order_id WHERE s.stock_id = "+savedLog.stockId);
                        console.log(poDetails);
                        // let query = `SELECT rp.rack_code as oldRackCode , rpu.rack_code as UpadatedRack,s.total_cartons as total,sid.po_number as saleOrder, sk.variant_code AS productName,uc.unit_name as unit FROM ` + appSettings.warehouse_db + `.stock_log sl LEFT JOIN ` + appSettings.masters_db + `.rack_position rp ON rp.rack_position_id = sl.old_rack_position_id LEFT JOIN ` + appSettings.masters_db + `.rack_position rpu ON rpu.rack_position_id = sl.updated_rack_position_id LEFT JOIN ` +  appSettings.warehouse_db + `.stock s ON s.stock_id = sl.stock_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = s.sale_order_id LEFT JOIN `+ appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id=s.varient_id LEFT JOIN `+appSettings.masters_db+`.unitcodes uc ON uc.unit_code_id = s.unit_id WHERE sl.stock_log_id = `+savedLog.stockLogId
                        // const result = await connection.query(query)
                        // console.log('---result-----',result)

                        let message;
                        // if(result.length > 0){
                            const time = moment().format("DD-MM-YYYY HH:mm")
                            // commented whatsapp Broadcaste
                            // message = await new BroadCastMessageRequest(37,time+"\n"+
                            // "\Unit :*" + (result[0].unit+'*\n')+
                            // "\Sale order No. :*" + (result[0].saleOrder+'*\n')+
                            // "\Product :*" + (result[0].productName+'*\n')+
                            // "\Old Rack :*" + (result[0].oldRackCode+'*\n') +
                            // "\New Rack :*" + (result[0].UpadatedRack+'*\n')+
                            // "\Stock :*" + (result[0].total+'*\n')+
                            // "\n" ,['917036784473'])
                            // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(message);
                            const parameters = [
                                { "type": "text", "text": time},
                                { "type": "text", "text": poDetails[0].unit != undefined ? poDetails[0].unit : "No Data" },
                                { "type": "text", "text": poDetails[0].poNumber != undefined ? poDetails[0].poNumber : "No Data" },
                                { "type": "text", "text": poDetails[0].productSKU != undefined ? poDetails[0].productSKU : "No Data" },
                                { "type": "text", "text": oldRackPosition[0].rack != undefined ? oldRackPosition[0].rack : "No Data" },
                                { "type": "text", "text": newRackPosition[0].rack != undefined ? newRackPosition[0].rack : "No Data" },
                                { "type": "text", "text": poDetails[0].total != undefined ? poDetails[0].total : "No Data" }];
                                console.log("parameters");
                                console.log(parameters);
                            const contacts = whatsApp.contacts;
                            for(const contact of contacts){
                                const req = await new MessageParameters(contact, 'wh_internal_tranfer', parameters)
                                // const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                                // console.log("messageStatus"+messageStatus);
                            }
                        // }
                    manager.completeTransaction();
                    return new CommonResponse(true, 1111, 'Stock Transfered Successfully');
                } else {
                    await manager.releaseTransaction();
                    return new CommonResponse(false, 9999, "Transfer Failed, Please Try Again")
                }
            }
            else if (req.transferType === "saleOrder") {
                stockUpdate = await manager.getCustomRepository(StockRepository).update({ stockId: Raw(alias => `stock_id IN (${req.stockIds})`) }, { saleOrderId: req.saleOrderId, saleOrderItemId: req.saleOrderItemId, updatedUser: req.createdUser });
                console.log(stockUpdate);
                const stockLogObj = new StockLog();
                for (const stock of req.stockIds) {
                    stockLogObj.stockId = Number(stock);
                    stockLogObj.oldSoId = req.selectedRows.find(rec => rec.stockId === Number(stock)).saleOrderId;
                    stockLogObj.updatedSoId = req.saleOrderId;
                    stockLogObj.oldSoItemId = req.selectedRows.find(rec => rec.stockId === Number(stock)).saleOrderItemId;
                    stockLogObj.updatedSoItemId = req.saleOrderItemId;
                    stockLogObj.createdUser = req.createdUser;
                    stockLogObj.purpose = req.transferType;
                    stockLogObj.cartons = req.selectedRows.find(rec => rec.stockId === Number(stock)).cartons;
                    stockLogObj.plantId = req.selectedRows.find(rec => rec.stockId === Number(stock)).plantId;

                    savedLog = await manager.getCustomRepository(StockLogRepository).save(stockLogObj);
                    console.log("savedLogsavedLog" + savedLog.stockLogId);
                    if (!savedLog) {
                        throw new ErrorResponse(11106, 'Something Went Wrong');
                    }
                   
                } 
                console.log("savedLog-savedLog" + savedLog)
                if (stockUpdate.affected && savedLog.stockLogId > 0) {

                    let oldSo = await connection.query("SELECT po_number AS poNumber FROM "+appSettings.sales_db+".so_invoice_details sid WHERE sale_order_id = "+savedLog.oldSoId);
                    let updatedSo = await connection.query("SELECT po_number AS poNumber FROM "+appSettings.sales_db+".so_invoice_details sid WHERE sale_order_id = "+savedLog.updatedSoId);
                    let poDetails = await connection.query("SELECT rp.rack_code AS rackCode, s.total_cartons AS total,u.unit_name AS unit, sk.variant_code AS productSKU, sid.po_number AS poNumber FROM "+appSettings.warehouse_db+".stock s left join "+appSettings.masters_db+".rack_position rp on rp.rack_position_id = s.location left join "+appSettings.sales_db+".sale_order_items si on si.sale_order_item_id = s.sale_order_item_id left join "+appSettings.masters_db+".sku_codes sk on sk.sku_code_id = si.varient_id left join "+appSettings.masters_db+".unitcodes u on u.unit_code_id = s.unit_id left join "+appSettings.sales_db+".so_invoice_details sid on sid.sale_order_id = s.sale_order_id WHERE s.stock_id = "+savedLog.stockId);
                    console.log(poDetails);
                    // let query = `SELECT rp.rack_code as oldRackCode , s.total_cartons as total,sid.po_number as saleOrder, sidu.po_number as updatedSaleOrder,sk.variant_code AS productName,uc.unit_name as unit FROM ` + appSettings.warehouse_db + `.stock_log sl LEFT JOIN ` + appSettings.masters_db + `.rack_position rp ON rp.rack_position_id = sl.old_rack_position_id LEFT JOIN ` + appSettings.warehouse_db + `.stock s ON s.stock_id = sl.stock_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = sl.old_so_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sidu ON sidu.sale_order_id = sl.updated_so_id LEFT JOIN `+ appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id=s.varient_id LEFT JOIN `+appSettings.masters_db+`.unitcodes uc ON uc.unit_code_id = s.unit_id WHERE sl.old_so_id IN ('${stockLogObj.oldSoId}')  and sl.updated_so_id = ` + stockLogObj.updatedSoId + ` and sl.stock_id IN('${req.stockIds}') and stock_log_id > 0 `
                    //     const result = await connection.query(query)
                    //     console.log('---result-----',result)
                        let message;

                        const time = moment().format("DD-MM-YYYY HH:mm")
                        const parameters = [
                            { "type": "text", "text": time},
                            { "type": "text", "text": poDetails[0].unit != undefined ? poDetails[0].unit : "No Data" },
                            { "type": "text", "text": oldSo[0].poNumber != undefined ? oldSo[0].poNumber : "No Data" },
                            { "type": "text", "text": updatedSo[0].poNumber != undefined ? updatedSo[0].poNumber : "No Data" },
                            { "type": "text", "text": poDetails[0].productSKU != undefined ? poDetails[0].productSKU : "No Data" },
                            { "type": "text", "text": poDetails[0].rackCode != undefined ? poDetails[0].rackCode : "No Data" },
                            { "type": "text", "text": poDetails[0].total != undefined ? poDetails[0].total : "No Data" }];
                            console.log("parameters");
                            console.log(parameters);
                        const contacts = whatsApp.contacts;
                        for(const contact of contacts){
                            const req = await new MessageParameters(contact, 'wh_saleorder_transfer', parameters)
                            // const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                            // console.log("messageStatus"+messageStatus);
                        }


                    //     if(result.length > 0){
                            // message = await new BroadCastMessageRequest(37,time+"\n"+
                            // "\Unit :*" + (poDetails[0].unit+'*\n')+
                            // "\Old Sale order No. :*" + (oldSo[0].poNumber+'*\n')+
                            // "\New Sale order No. :*" + (updatedSo[0].poNumber+'*\n')+
                            // "\Product :*" + (poDetails[0].productSKU+'*\n')+
                            // "\Rack :*" + (poDetails[0].rackCode+'*\n') +
                            // "\Stock :*" + (poDetails[0].total+'*\n')+
                            // "\n" ,['917036784473'])
                            // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(message);
                        // }
                    manager.completeTransaction();
                    return new CommonResponse(true, 1111, 'Transfered stock to sale order Successfully');
                } else {
                    await manager.releaseTransaction();
                    return new CommonResponse(false, 9999, "Transfer Failed, Please Try Again")
                }
            }
            else if (req.transferType === "warehouse") {
                stockUpdate = await manager.getCustomRepository(StockRepository).update({ stockId: Raw(alias => `stock_id IN (${req.stockIds})`) }, { location: req.rackPostion, zoneId: req.zoneId, updatedUser: req.createdUser });
                console.log(stockUpdate);
                for (const stock of req.stockIds) {
                    let stockDetails = await manager.getCustomRepository(StockRepository).find({where:{location: req.selectedRows.find(rec => rec.stockId === Number(stock)).rackPositionId, status:"stockIn"}});
                    console.log(stockDetails);
                    console.log(stockDetails.length);
                    let occupancy;
                    if(stockDetails.length > 0){
                        occupancy = OccupancyEnum.ASSIGNED;
                    }
                    else{
                        occupancy = OccupancyEnum.NOT_OCCUPIED;
                    }
                    const stockLogObj = new StockLog();
                    stockLogObj.stockId = Number(stock);
                    stockLogObj.oldRackPositiontId = req.selectedRows.find(rec => rec.stockId === Number(stock)).rackPositionId;
                    stockLogObj.updatedRackPositionId = req.rackPostion;
                    stockLogObj.createdUser = req.createdUser;
                    stockLogObj.purpose = req.transferType;
                    stockLogObj.cartons = req.selectedRows.find(rec => rec.stockId === Number(stock)).cartons;
                    stockLogObj.plantId = req.selectedRows.find(rec => rec.stockId === Number(stock)).plantId;

                    savedLog = await manager.getCustomRepository(StockLogRepository).save(stockLogObj);
                    console.log("savedLogsavedLog" + savedLog.stockLogId);
                    updateRackPosition = await this.rackPositionRepository.updateOccupancyAfterTransfer({ rackPositionId: req.selectedRows.find(rec => rec.stockId === Number(stock)).rackPositionId, newRackPositionId: req.rackPostion, saleOrderId: req.selectedRows[0].saleOrderId, updatedUser:"",versionFlag:0,isActive:false,occupancy: occupancy })
                    if (!savedLog) {
                        throw new ErrorResponse(11106, 'Something Went Wrong');
                    }
                    else {
                        savedLog = savedLog.stockLogId;
                    }
                }
                console.log("savedLog-savedLog" + savedLog)
                if (stockUpdate.affected && savedLog > 0) {
                    manager.completeTransaction();
                    return new CommonResponse(true, 1111, 'Transfered stock Successfully');
                } else {
                    await manager.releaseTransaction();
                    return new CommonResponse(false, 9999, "Transfer Failed, Please Try Again")
                }
            }
            else if (req.transferType === "plant") {
                let raiseForkLiftJobDispatch;
                let raiseForkLiftJobReceiveStock;
                let updateRackPositions: any;
                stockUpdate = await manager.getCustomRepository(StockRepository).update({ stockId: Raw(alias => `stock_id IN (${req.stockIds})`) }, { status: FgStockStatus.StockOut, updatedUser: req.createdUser });
                let stockInId = await manager.getCustomRepository(StockInRepository).findOne({ stockId: Raw(alias => `stock_id IN (${req.stockIds})`) });
                console.log(stockUpdate);
                if (stockUpdate.affected > 0) {
                    updateRackPositions = this.rackPositionService.updateRackStatus({ selectedRows: req.selectedRows });
                    console.log(updateRackPositions);
                    if (updateRackPositions) {
                        const forkLiftJobItemsData: ForkLiftItemsDTO[] = [];
                        let totCartons = 0;
                        let totIssuedQty = 0;
                        req.selectedRows?.forEach(async stock => {
                            totCartons += stock.totalCartons;
                            totIssuedQty += Number(stock.pouches) * Number(stock.pouchWeight) * Number(stock.totalCartons);
                            const forkLiftJobItemData = new ForkLiftItemsDTO(stock.saleOrderId, stock.saleOrderItemId, stock.pallet!=null?stock.pallet:0, stock.rackPositionId, stock.rackPositionId, stock.rackPositionId, stock.date, stock.createdUser, stock.updatedUser, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 0, 0, undefined, (stock.pouches * stock.pouchWeight * stock.totalCartons), 0, stock.totalCartons, stock.plantId, stock.stockId);
                            console.log("forkLiftJobItemsDataforkLiftJobItemsData" + forkLiftJobItemData);
                            forkLiftJobItemsData.push(forkLiftJobItemData);


                            let getReportedCases = 'select reported_cases AS reportedCases,dispatched_qty AS dispatchedQty from ' + appSettings.sales_db + '.sale_order_items where sale_order_item_id =' + stock.saleOrderItemId;
                            let reportedData = await connection.query(getReportedCases);
                            console.log(reportedData[0])
                            let reportedCases = reportedData[0].reportedCases;
                            let dispatchedQty = reportedData[0].dispatchedQty;
                            let updateCases = Number(reportedCases) - Number(stock.totalCartons);
                            let updateDispatchCases = Number(dispatchedQty) + Number(stock.totalCartons);
                            let updateResult = await this.saleOrderService.updateReportedAndDispatchCases({ saleOrderItemId: stock.saleOrderItemId, reported: updateCases, dispatch: updateDispatchCases, dispatchStatus: stock.stockOutType })
                        });

                        const forkLiftJobDataDispatch = new ForkLiftJobDTO(0, "", new Date(), ForkLiftJobStatus.Completed, stockInId.reportingLogId, TransactionType.dispatch, forkLiftJobItemsData, "Admin", req.selectedRows[0].plantId, "", "", totCartons, totIssuedQty)
                        const forkLiftJobDataTransfer = new ForkLiftJobDTO(0, "", new Date(), ForkLiftJobStatus.Open, stockInId.reportingLogId, TransactionType.stockTransfer, forkLiftJobItemsData, "Admin", req.toPlant, "", "", totCartons, totIssuedQty, 0, 0, 0, req.selectedRows[0].plantId, req.toPlant);
                        raiseForkLiftJobDispatch = await this.forkLiftJobService.createForkLiftJob(forkLiftJobDataDispatch)
                        raiseForkLiftJobReceiveStock = await this.forkLiftJobService.createForkLiftJob(forkLiftJobDataTransfer)
                    }
                }
                console.log(stockUpdate.affected + "***" + raiseForkLiftJobDispatch.status + "****" + updateRackPositions + "***" + raiseForkLiftJobReceiveStock.status);
                if (stockUpdate.affected && raiseForkLiftJobDispatch.status && raiseForkLiftJobReceiveStock.status && updateRackPositions) {
                    manager.completeTransaction();
                    return new CommonResponse(true, 1111, 'Transfered stock Successfully');
                } else {
                    await manager.releaseTransaction();
                    return new CommonResponse(false, 9999, "Transfer Failed, Please Try Again")
                }
            }
            // else if(req.transferType === "plant"){
            //     stockUpdate = await manager.getCustomRepository(StockRepository).update({ stockId: Raw(alias => `stock_id IN (${req.stockIds})`) }, { plantId:req.toPlant,location:req.rackPostion, zoneId:req.zoneId, updatedUser:req.createdUser});
            //     console.log(stockUpdate);
            //     for(const stock of req.stockIds){
            //         const stockLogObj = new StockLog();
            //         stockLogObj.stockId = Number(stock);
            //         stockLogObj.oldPlantId = req.selectedRows.find(rec => rec.stockId === Number(stock)).plantId;
            //         stockLogObj.updatedPlantId = req.toPlant;
            //         stockLogObj.oldRackPositiontId = req.selectedRows.find(rec => rec.stockId === Number(stock)).rackPositionId;
            //         stockLogObj.updatedRackPositionId = req.rackPostion;
            //         stockLogObj.createdUser = req.createdUser;
            //         savedLog = await manager.getCustomRepository(StockLogRepository).save(stockLogObj);
            //         console.log("savedLogsavedLog" + savedLog.stockLogId);
            //         if (!savedLog) {
            //             throw new ErrorResponse(11106, 'Something Went Wrong');
            //         }
            //         else{
            //             savedLog = savedLog.stockLogId;
            //         }
            //     }
            //         console.log("savedLog-savedLog"+savedLog)
            //     if (stockUpdate.affected && savedLog && updateRackPosition>0) {
            //         manager.completeTransaction();
            //         return new CommonResponse(true, 1111, 'Transfered stock to plant Successfully');
            //     } else {
            //         return new CommonResponse(false, 9999, "Transfer Failed, Please Try Again")
            //     }
            // }
            else {
                return new CommonResponse(false, 9999, "Something went wrong, Please Try Again")
            }
        }
        catch (err) {
            await manager.releaseTransaction();
            console.log(err)
            return err;
        }

    }


    async getAllStockForStockReport(req?: StockReportFilters): Promise<StockResponseData> {
        const entityManager = getManager();
        try {
            const manager = getManager();
            let dataQuery = `SELECT inv.po_number AS poNumber,s.sale_order_id as saleOrderId,so.sale_order_no AS saleOrderNumber,s.stock_id AS stockId,s.lot_no AS lotNo,
       s.total_cartons  AS totalCartons,s.unit_id AS unitId,s.packing_completed AS packingCompleted,z.zone_name AS coldStorage,r.rack_code AS rackPosition,s.location AS stockLocationId,s.pallet_code AS palletCode,b.brand_name AS brandName,p.name AS productName,sc.variant_code AS variantCode,s.min_grade AS minGrade,s.max_grade AS maxGrade,concat(s.min_grade,'-',s.max_grade) as grade,s.state AS stockState,s.date as stockDate,s.stock_type as stockType,pm.no_of_pouches as pouches,pm.pouches_per_row as pouchWeight,ec.end_customer_name as endCustomer,si.value_addition_one_id as typeOne,si.value_addition_two_id as typeTwo,si.value_addition_three_id as typeThree,si.value_addition_four_id as typeFour,si.value_addition_five_id as typeFive,s.shift as shift,s.unit_id as plantId,u.uom_name as uomName,s.pouches_shortage as pouchesShortage,s.cartons_shortage as cartonsShortage,s.product_category as productCategory,
       IF(u.uom_name = "OZ" , (s.total_cartons * s.pouches * s.pouch_weight * 0.028),
                IF(u.uom_name = 'LB' ,(s.total_cartons * s.pouches * s.pouch_weight * 0.454),
                IF(u.uom_name = 'GM' ,(s.total_cartons * s.pouches * s.pouch_weight * 0.001),
                (s.total_cartons * s.pouches * s.pouch_weight)))) AS 'quantity',
        pm.packing_method_name as packStyle ,s.created_at as stockCreated,uc.unit_name as unitName,s.remarks AS remarks
        FROM ` + warehouseStockTable + ` s 
        LEFT JOIN ` + salesSoTable + ` so ON so.sale_order_id=s.sale_order_id
        LEFT JOIN ` + salesInvTable + ` inv ON inv.sale_order_id=s.sale_order_id  
        LEFT JOIN ` + appSettings.sales_db + `.sale_order_track sot ON s.sale_order_id=sot.sale_order_id  
        LEFT JOIN ` + coldStorageTable + ` z ON z.zone_id=s.zone_id
        LEFT JOIN ` + rackPositionTable + ` r ON r.rack_Position_id=s.location 
        LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=s.brand_id 
        LEFT JOIN ` + appSettings.masters_db + `.products p ON p.product_id=s.product_id
        LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=s.varient_id 
        LEFT JOIN ` + appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id = s.pack_style_id
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = s.unit_id
        LEFT JOIN ` + appSettings.masters_db + `.end_customers ec ON ec.end_customer_id=inv.end_customer_id
        LEFT JOIN erpx_dev_masters.uoms u ON u.uom_id = pm.uom_id
        LEFT JOIN ` + salesSoItemTable + ` si ON si.sale_order_item_id=s.sale_order_item_id 
        
         where s.stock_id > 0 `
            if (req.lifeCycleStatus === "So stock out") {
                dataQuery = dataQuery + ' and  s.stock_type != "dummy" and  s.status = "StockOut"';
            }
            if (req.lifeCycleStatus === undefined) {
                dataQuery = dataQuery + ' and s.status = "StockIn"';
            }
            if (req.lifeCycleStatus === "So stock in") {
                dataQuery = dataQuery + ' and  s.stock_type != "dummy" and s.status = "StockIn"';
            }

            if (req.lifeCycleStatus === "Stock not moved beyond ETD(With SO)") {
                dataQuery = dataQuery + ' and  s.stock_type != "dummy" and DATE(sot.dispatched_date) > DATE(inv.act_edl_date)';
            }
            if (req.lifeCycleStatus === "Stock moved BEFORE ETD(With SO)") {
                dataQuery = dataQuery + ' and s.stock_type != "dummy" and DATE(sot.dispatched_date) < DATE(inv.act_edl_date)';
            }
            if (req.lifeCycleStatus === "Stock moved onetime(With SO)") {
                dataQuery = dataQuery + ' and s.stock_type != "dummy" and DATE(sot.dispatched_date) = DATE(inv.act_edl_date)';
            }
            if (req.lifeCycleStatus === "With out SO Stock in") {
                dataQuery = dataQuery + ' and s.status = "StockIn" and stock_type = "dummy"';
            }
            if (req.lifeCycleStatus === "With out SO Stock out") {
                dataQuery = dataQuery + ' and s.status = "StockOut" and stock_type = "dummy"';
            }
            if (req.lifeCycleStatus === "Dummy stock not moved beyond 30days") {
                dataQuery = dataQuery + ' and stock_type = "dummy" AND (DATE(s.created_at) < DATE(NOW()) - INTERVAL 30 DAY OR DATE(s.updated_at) < DATE(NOW()) - INTERVAL 30 DAY) AND s.status = "StockIn"';
            }
            if (req.lifeCycleStatus === "Dummy stock not moved beyond 60days") {
                dataQuery = dataQuery + ' and stock_type = "dummy" AND (DATE(s.created_at) < DATE(NOW()) - INTERVAL 60 DAY OR DATE(s.updated_at) < DATE(NOW()) - INTERVAL 60 DAY) AND s.status = "StockIn"';
            }
            if (req.deadStock === "Above 180 days") {
                dataQuery = dataQuery + ' and  DATEDIFF( CURDATE() , s.date ) > 180 ';
            }
            if (req.deadStock === "Below 180 days") {
                dataQuery = dataQuery + ' and  DATEDIFF( CURDATE() , s.date ) < 180 ';
            }
            if (req.deadStock === "Below 100 days") {
                dataQuery = dataQuery + ' and  DATEDIFF( CURDATE() , s.date ) < 100 ';
            }
            if (req.unitId && req.unitId.length) {
                dataQuery = dataQuery + ' and  s.unit_id IN (' + req.unitId.toString() + ')';
            }
            if (req.plantId > 0) {
                dataQuery = dataQuery + ' and  s.unit_id = ' + req.plantId;
            }
            if (req.coldStorage && req.coldStorage.length) {
                dataQuery = dataQuery + ' and s.zone_id IN (' + req.coldStorage.toString() + ')';
            }
            if (req.shift && req.shift.length) {
                let shiftWithQuotes = req.shift.map((it) => { return `'${it}'` })
                dataQuery = dataQuery + ' and s.shift IN (' + shiftWithQuotes + '  )';
            }
            if (req.soType && req.soType.length) {
                let soTypeWithQuotes = req.soType.map((it) => { return `'${it}'` })
                dataQuery = dataQuery + ' and s.stock_type IN  (' + soTypeWithQuotes + ')';
            }
            if (req.stockFromDate && req.stockFromDate.length) {
                dataQuery = dataQuery + ' and DATE(s.date)  >= "' + req.stockFromDate + '" and DATE(s.date) <="' + req.stockToDate + '"';
            }
            if (req.product) {
                dataQuery = dataQuery + ' and sc.sku_code_id = ' + req.product;
            }
            console.log('***********', dataQuery)
            dataQuery = dataQuery + ' ORDER BY DATE(s.date) DESC';
            var stockData: any = await entityManager.query(dataQuery);
            const data = await manager.query(dataQuery)
            if (data.length > 0) {
                return new StockResponseData(true, 1001, 'Stock data retrieved successfully', stockData);
            } else {
                throw new StockResponseData(false, 99998, 'No Record Found');
            }

        } catch (error) {
            console.log('------error-------', error)
            return error;
        }
    }

    async getProductDropForStockReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT s.varient_id as varientId, s.unit_id , sc.variant_code as variantCode FROM  ` + warehouseStockTable + ` s
        LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=s.varient_id 
         WHERE s.stock_id > 0  and sc.is_active = true `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and s.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY sc.sku_code_id  ORDER BY sc.variant_code ASC `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1141, 'Data retreived sucessfully', data)
        } else {
            return new CommonResponse(false, 1411, 'No data')
        }
    }



    async getDeadStockData(req?: StockReportFilters): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT s.stock_id , SUM(s.total_cartons) as totalCartons , sc.variant_code AS variant,uc.unit_name as unitName FROM ` + appSettings.warehouse_db + `.stock s 
        LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id =  s.varient_id
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = s.unit_id
        WHERE DATEDIFF( CURDATE() , s.created_at ) > `+ globalVariable.WarehouseDeadStock
        if (req.unitId && req.unitId.length) {
            query = query + ' and  s.unit_id IN (' + req.unitId.toString() + ')';
        }
        query = query + ` GROUP BY s.stock_id`
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1141, 'Data retreived sucessfully', data)
        } else {
            return new CommonResponse(false, 1411, 'No data')
        }
    }

    async getColdDropForStockRep(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT s.zone_id AS zoneId, z.zone_name AS coldStorage , s.unit_id  FROM  ` + warehouseStockTable + ` s
        LEFT JOIN ` + coldStorageTable + ` z ON z.zone_id=s.zone_id 
        WHERE s.zone_id> 0` ;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and s.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY z.zone_name  ORDER BY coldStorage `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1141, 'Data retreived sucessfully', data)
        } else {
            return new CommonResponse(false, 1411, 'No data')
        }
    }
    async getMoveStockToDummy(req: SoPlantRequest): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            const getDummySO = await this.saleOrderService.getDummySaleOrders({ plantId: req.plantId })
            const stockUpdate = await manager.getCustomRepository(StockRepository).update({ saleOrderId: req.saleOrderId, status: FgStockStatus.StockIn }, { stockType: StockStatus.dummy, saleOrderId: getDummySO.data[0].saleOrderId })
            console.log(stockUpdate);
            const unReserveRacks = await this.rackPositionService.getUnreserveRackPositions({ saleOrderId: req.saleOrderId });
            console.log("unReserveRacks : " + unReserveRacks.status);

            if (stockUpdate.affected) {
                manager.completeTransaction();
                return new CommonResponse(true, 1111, 'Stock moved to dummy Successfully');
            } else {
                await manager.releaseTransaction();
                throw new ErrorResponse(9999, "Update Failed, Please Try Again")
            }
        } catch (error) {
            await manager.releaseTransaction();
            return error;
        }
    }
    async getWarehouseRackDetails(req: RackReserveRequest): Promise<WarehouseDashboardResponseModel> {
        const manager = getManager();
        console.log("hii")
        try {
            const colCountQuery = `select MAX(rp.rack_column) AS colCount from ` + appSettings.masters_db + `.rack r left join ` + appSettings.masters_db + `.rack_position rp ON rp.rack_id=r.rack_id where r.rack_id = ` + req.rackId;
            // const colCountQuery = `select MAX(rack_column) AS colCount from ` + appSettings.masters_db + `.rack_position where zone_id=` + req.zoneId + ` and rack_id=` + req.rackId + ` and plant_id= ` + req.plantId;
            const colCount = await manager.query(colCountQuery);
            const racksQuery = `select rack_id,rack_code,rack_type,plant_id AS plantId from ` + appSettings.masters_db + `.rack where allocated_zone_id=` + req.zoneId + ` and rack_id = ` + req.rackId + ` limit 1`;
            const racksData = await manager.query(racksQuery);
            console.log(racksData);

            let levelsQuery;
            if (req.plantId != 2) {
                levelsQuery = `select level_id,level_code from ` + appSettings.masters_db + `.level where is_active= true order by level_id desc`;
            }
            else {
                levelsQuery = `select level_id,level_code from ` + appSettings.masters_db + `.level where is_active= true order by level_id asc`;
            }

            const levelsData = await manager.query(levelsQuery);
            const data = [];
            const racksInfo: WarehouseDashboard[] = [];
           
          
                    let warehouseResponseFront: WarehouseResponseData[] = [];
                    let warehouseResponseRear: WarehouseResponseData[] = [];
                    let rackPositionsFrontQuery;
                    rackPositionsFrontQuery = `SELECT z.zone_id as zoneId,z.zone_code AS zoneCode,r.rack_id as rackId,r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,r.plant_id AS unitId, UPPER(r.rack_position_type) AS rackPositionType, r.is_reserved AS isReserved, SUM(st.total_cartons) AS totalCartons, Max(st.pallet_capacity) AS palletCapacity, r.rack_level AS rackLevel, r.rack_column AS rackColumn,r.is_active AS isActive FROM ` + appSettings.masters_db + `.rack_position r LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.location= r.rack_position_id and st.status = "StockIn" LEFT JOIN ` + appSettings.masters_db + `.level l ON l.level_id= r.rack_level LEFT JOIN ` + appSettings.masters_db + `.rack rs ON rs.rack_id=r.rack_id LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id=rs.allocated_zone_id where r.rack_id=` + racksData[0].rack_id + ` and r.rack_position_type='front' group by r.rack_level,r.rack_position_id `
                    if (req.plantId != 2) {
                        rackPositionsFrontQuery = rackPositionsFrontQuery + ` order by r.rack_column desc,r.rack_level asc`;
                    }
                    else {
                        rackPositionsFrontQuery = rackPositionsFrontQuery + ` order by r.rack_column asc,r.rack_level asc`;
                    }


                    warehouseResponseFront = await manager.query(rackPositionsFrontQuery);

                    let rackPositionsRearQuery
                     rackPositionsRearQuery = `SELECT z.zone_id as zoneId,z.zone_code AS zoneCode,r.rack_id as rackId,r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,r.plant_id AS unitId, UPPER(r.rack_position_type) AS rackPositionType, r.is_reserved AS isReserved,SUM(st.total_cartons) AS totalCartons, Max(st.pallet_capacity) AS palletCapacity, r.rack_level AS rackLevel, r.rack_column AS rackColumn,r.is_active AS isActive FROM ` + appSettings.masters_db + `.rack_position r LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.location= r.rack_position_id AND st.status = "StockIn" LEFT JOIN ` + appSettings.masters_db + `.level l ON l.level_id= r.rack_level LEFT JOIN ` + appSettings.masters_db + `.rack rs ON rs.rack_id=r.rack_id LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id=rs.allocated_zone_id where r.rack_id=` + racksData[0].rack_id + ` and r.rack_position_type='rear' group by r.rack_level,r.rack_position_id `
                    if (req.plantId != 2) {
                        rackPositionsRearQuery = rackPositionsRearQuery + ` order by r.rack_column desc,r.rack_level asc`;
                    }
                    else {
                        rackPositionsRearQuery = rackPositionsRearQuery +  ` order by r.rack_column asc,r.rack_level asc`;
                    }


                    warehouseResponseRear = await manager.query(rackPositionsRearQuery);

                if (racksData.length > 0) {
                    const rackData = new WarehouseDashboard();
                    rackData.rackId = racksData[0].rack_id;
                    rackData.rackName = racksData[0].rack_code;
                    rackData.colCount = colCount[0].colCount;
                    rackData.rackType = racksData[0].rack_type;
                    rackData.plantId = racksData[0].plantId;
                    let rackPositionsData: RackLevelResponseDto[] = [];
                    for (const level of levelsData) {
                    
                        let rackType: RackTypeResponseDto[] = [];
                        // console.log(racksData[0].rack_id);
                        let rearRacksData = new RackTypeResponseDto("REAR", warehouseResponseRear.filter((rec) => rec.rackLevel === level.level_id))
                        let frontRacksData = new RackTypeResponseDto("FRONT", warehouseResponseFront.filter((rec) => rec.rackLevel === level.level_id))
                        rackType.push(rearRacksData)
                        rackType.push(frontRacksData)
                        // console.log(rearRacksData)
                        // console.log(rackType)
                        let rearData = new RackLevelResponseDto(level.level_id, rackType)
                        // let frontData = new RackLevelResponseDto(level.level_id,frontRacksData)
                        // console.log(rearData)
                        // console.log(frontData)
                        rackPositionsData.push(rearData);
                        // rackPositionsData.push(frontData);
                    }
                    // console.log(rackPositionsData);
                    rackData.rackPositions = rackPositionsData;
                    racksInfo.push(rackData);
                    // for(const [index,rackItem] of racksInfo){
    
                    // }
                    racksInfo[0].expandStatus = true
    
                    // console.log(racksInfo);
                    return new WarehouseDashboardResponseModel(true, 1001, 'data retrieved successfully', racksInfo);
                } else {
                    return new WarehouseDashboardResponseModel(false, 99999, 'Racks Data not found');
                }
                // await new Promise(resolve => setTimeout(resolve, 200));                   
                // warehouseResponse = await manager.find(WarehouseView,{unitId:req.plantId,zoneId:req.zoneId});

        } catch (error) {
            return error;
        }
    }

    async getProductDropForFgStockReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT si.varient_id as varientId, s.processing_unit , sc.variant_code as variantCode FROM  ` + appSettings.sales_db + `.sale_order_items si
        LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=si.varient_id
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details s ON s.sale_order_id=si.sale_order_id
         WHERE si.sale_order_item_id > 0 and sc.is_active = true `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and s.processing_unit = ' + req.unitId;
        }
        query = query + ` GROUP BY sc.sku_code_id  ORDER BY sc.variant_code ASC `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1141, 'Data retreived sucessfully', data)
        } else {
            return new CommonResponse(false, 1411, 'No data')
        }
    }

    async getAllFgStockReport(req: FgSaleReportRequest): Promise<FgStockReportResponse> {
        try {
            console.log(req, '--req')
            const manager = getManager();
            let query = ` SELECT s.sale_order_id as saleOrderId,si.sale_order_item_id as saleOrderItemId,uc.unit_name as plantName,s.po_number as poNumber,s.act_edl_date as etd,br.brand_name as brand,si.category as category,sc.variant_code as variantcode,p.packing_method_name as packingMethodName,si.cases as cases,si.job_cases as jobCases,uc.unit_code_id,
            SUM(IF(st.stock_type='SaleOrder' AND st.cartons_shortage = 'NO' AND st.pouches_shortage = 'NO',st.total_cartons,0)) AS finalFg , SUM(IF(st.cartons_shortage = 'YES' AND st.pouches_shortage = 'YES', st.total_cartons,0)) AS dummy, SUM(IF(st.pouches_shortage = 'NO' AND st.cartons_shortage = 'YES',st.total_cartons,0)) as pouchFinal,round(si.job_cases-(SUM(IF(st.stock_type='SaleOrder' AND st.cartons_shortage = 'NO' AND st.pouches_shortage = 'NO',st.total_cartons,0)) + SUM(IF(((st.stock_type ='Anticipated') OR (st.stock_type = 'superDummy')) AND st.cartons_shortage = 'YES' AND st.pouches_shortage = 'YES', st.total_cartons,0)) + SUM(IF(st.pouches_shortage = 'NO' AND st.cartons_shortage = 'YES',st.total_cartons,0)))) AS balance FROM ` + appSettings.sales_db + `.sale_order_items si LEFT JOIN ` + appSettings.masters_db + `.master_brands br ON br.master_brand_id=si.master_brand_id
      LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details s ON s.sale_order_id=si.sale_order_id
      LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=si.varient_id
      LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.sale_order_item_id=si.sale_order_item_id and st.stock_type!='dummy'
      LEFT JOIN ` + appSettings.sales_db + `.sale_order_track str ON str.sale_order_id=si.sale_order_id
      LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id=si.sale_order_id
      LEFT JOIN ` + appSettings.masters_db + `.packing_methods p ON p.packing_method_id=st.pack_style_id
      LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id=s.processing_unit
      WHERE si.sale_order_item_id > 0 AND str.so_status IN ('OPEN','IN_PROGRESS','CLOSED')  AND st.status = "StockIn" AND so.so_process_type ='MTO'`
            if (req.unitId && req.unitId != 5) {
                query = query + ' and s.processing_unit = ' + req.unitId;
            }
            if (req.saleOrderId) {
                // query = query + ' and si.sale_order_id = ' + req.saleOrderId;
                query = query + ' and s.po_number = "' + req.poNumber + '"';
            }
            if (req.category) {
                query = query + ' and si.category = "' + req.category + '"';
            }
            if (req.brandId) {
                query = query + ' and si.brand_id = "' + req.brandId + '"';
            }
            query = query + ` GROUP BY si.sale_order_item_id, si.sale_order_id ORDER BY (s.act_edl_date IS NULL), s.act_edl_date, s.po_number asc;`
            const fgStockReportDto: FgStockReportModel[] = await manager.query(query);
            console.log(fgStockReportDto);
            //     for(const [index,res] of fgStockReportDto.entries()){
            //       console.log(index)
            //         (response) => {
            //             console.log(response[0][0].jobCases)
            //             let jobcasesQty = Number(response[0][0].jobCases)>0?response[0][0].jobCases:0;
            //             fgStockReportDto[index].required = jobcasesQty;
            //             fgStockReportDto[index].balance = Number(jobcasesQty)-(Number(res.finalFg)+Number(res.dummy))!=null?Number(jobcasesQty)-(Number(res.finalFg)+Number(res.dummy)):0
            //         })

            //   }
            let resData: any[] = [];
            for (const res of fgStockReportDto) {
                console.log("IF" + res.dummy + "******" + res.allocatedSaleOrderItemId);
                if (res.allocatedSaleOrderItemId != null) {
                    let allocatedStock = await manager.query("SELECT u.uom_id AS allocatedUOM, um.uom_id AS dummyUOM, SUM(s.stockin_qunatity * s.pouches * s.pouch_weight) AS stockQty, SUM(s.stockin_qunatity) as allocatedCases, soi.pack_style_id as dummyPackStyle, (apm.no_of_pouches * apm.pouches_per_row) as pouchCount,apm.no_of_pouches as allocatedNoOfPouches, apm.pouches_per_row as allocatedPouchesPerRow, si.pack_style_id as allocatedPackStyle from " + appSettings.warehouse_db + ".stock s left join " + appSettings.sales_db + ".sale_order_items soi on soi.sale_order_item_id = s.sale_order_item_id left join " + appSettings.sales_db + ".sale_order_items si on si.sale_order_item_id = s.allocated_sale_orderitem__id left join " + appSettings.masters_db + ".packing_methods apm on apm.packing_method_id = si.pack_style_id left join " + appSettings.masters_db + ".uoms u on u.uom_id = apm.uom_id left join " + appSettings.masters_db + ".uoms um on um.uom_id = s.uom_id where s.allocated_sale_orderitem__id =" + res.allocatedSaleOrderItemId);
                    console.log(allocatedStock);
                    if (allocatedStock.length > 0) {
                        if (allocatedStock[0].dummyPackStyle === allocatedStock[0].allocatedPackStyle) {
                            if (allocatedStock[0].dummyUOM === allocatedStock[0].allocatedUOM) {
                                res.dummy = Number(res.dummy) + (Number(allocatedStock[0].stockQty) / Number(allocatedStock[0].pouchCount));
                                console.log("IF" + res.dummy);
                            }
                            else {
                                let qty
                                const uomVal = UnitsOfWeightInput.find(uom => uom.value == Number(allocatedStock[0].dummyUOM)).name

                                if ((uomVal == 'lb' || uomVal == 'oz') && (allocatedStock[0].allocatedUOM == 1)) {
                                    qty = Number(allocatedStock[0].stockQty) * 2.20462;
                                }
                                if ((uomVal == 'lb' || uomVal == 'oz') && allocatedStock[0].allocatedUOM == 3) {
                                    qty = Number(allocatedStock[0].stockQty) * 0.0625;
                                }
                                if ((uomVal == 'lb' || uomVal == 'oz') && allocatedStock[0].allocatedUOM == 4) {
                                    qty = Number(allocatedStock[0].stockQty) * 0.0022;
                                }

                                if ((uomVal == 'kg' || uomVal == 'gm') && (allocatedStock[0].allocatedUOM == 2)) {
                                    qty = Number(allocatedStock[0].stockQty) * 0.454;
                                }
                                if ((uomVal == 'kg' || uomVal == 'gm') && (allocatedStock[0].allocatedUOM == 3)) {
                                    qty = Number(allocatedStock[0].stockQty) * 0.0283;
                                }
                                if ((uomVal == 'kg' || uomVal == 'gm') && (allocatedStock[0].allocatedUOM == 4)) {
                                    qty = Number(allocatedStock[0].stockQty) * 0.001;
                                }
                                res.dummy = Number(res.dummy) + Math.floor(Number(qty) / Number(allocatedStock[0].pouchCount));
                                console.log("IF" + res.dummy);
                            }
                        }
                        else {
                            let qty
                            const uomVal = UnitsOfWeightInput.find(uom => uom.value == Number(allocatedStock[0].dummyUOM)).name

                            if ((uomVal == 'lb' || uomVal == 'oz') && (allocatedStock[0].allocatedUOM == 1)) {
                                qty = Number(allocatedStock[0].stockQty) * 2.20462;
                            }
                            if ((uomVal == 'lb' || uomVal == 'oz') && allocatedStock[0].allocatedUOM == 3) {
                                qty = Number(allocatedStock[0].stockQty) * 0.0625;
                            }
                            if ((uomVal == 'lb' || uomVal == 'oz') && allocatedStock[0].allocatedUOM == 4) {
                                qty = Number(allocatedStock[0].stockQty) * 0.0022;
                            }

                            if ((uomVal == 'kg' || uomVal == 'gm') && (allocatedStock[0].allocatedUOM == 2)) {
                                qty = Number(allocatedStock[0].stockQty) * 0.454;
                            }
                            if ((uomVal == 'kg' || uomVal == 'gm') && (allocatedStock[0].allocatedUOM == 3)) {
                                qty = Number(allocatedStock[0].stockQty) * 0.0283;
                            }
                            if ((uomVal == 'kg' || uomVal == 'gm') && (allocatedStock[0].allocatedUOM == 4)) {
                                qty = Number(allocatedStock[0].stockQty) * 0.001;
                            }
                            res.dummy = Number(res.dummy) + Math.floor((Number(qty) / Number(allocatedStock[0].pouchCount)));
                            console.log("IF" + res.dummy);
                        }
                        resData.push(res);
                    }
                    else {
                        console.log("ELSE" + res.dummy);
                        resData.push(res);
                    }
                }
                else {
                    console.log("IF ELSE" + res.dummy);
                    resData.push(res);
                }
            }
            const data = await manager.query(query)
            if (data.length > 0) {
                const response = new FgStockReportResponse(true, 11108, "Sale Order Details retrieved successfully", resData);
                return response;
            } else {
                throw new FgStockReportResponse(false, 99998, 'No Record Found');
            }
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    async getPoNoForFgStockReport(req: UnitRequest): Promise<CommonResponse> {
        try {
            console.log(req, '-----------req-----------')
            const manager = getManager()
            let query;
            query = `SELECT si.sale_order_item_id, s.sale_order_id AS saleOrderId ,s.po_number AS poNumber , s.processing_unit FROM ` + appSettings.sales_db + `.sale_order_items si
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details s ON s.sale_order_id=si.sale_order_id
            LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id=si.sale_order_id
            LEFT JOIN ` + appSettings.sales_db + `.sale_order_track str ON str.sale_order_id=si.sale_order_id
            LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.sale_order_item_id=si.sale_order_item_id
            WHERE si.sale_order_item_id > 0 AND str.so_status IN ('OPEN','IN_PROGRESS','CLOSED')
            AND st.status = "StockIn" AND so.so_process_type ='MTO' AND st.stock_type!='dummy'`
            if (req.unitId && req.unitId != 5) {
                query = query + ' and s.processing_unit = ' + req.unitId;
            }
            query = query + ` GROUP BY si.sale_order_id ORDER BY poNumber `;
            const data = await manager.query(query)
            if (data.length > 0) {
                const response = new FgStockReportResponse(true, 11108, "PO Numbers retrieved successfully", data);
                return response;
            } else {
                throw new FgStockReportResponse(false, 94598, 'No Record Found');
            }
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async getBrandDropForFgStockReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT soi.brand_id as brandId ,br.brand_name as brand , s.processing_unit FROM ` + appSettings.sales_db + `.sale_order_items soi
        LEFT JOIN ` + appSettings.masters_db + `.master_brands br ON br.master_brand_id=soi.master_brand_id
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details s ON s.sale_order_id=soi.sale_order_id
        LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.sale_order_item_id=soi.sale_order_item_id
        LEFT JOIN ` + appSettings.sales_db + `.sale_order_track str ON str.sale_order_id=soi.sale_order_id
        LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id=soi.sale_order_id
        WHERE soi.master_brand_id> 0 and str.so_status IN ('OPEN','IN_PROGRESS','CLOSED')AND st.status = "StockIn" AND so.so_process_type ='MTO' AND st.stock_type!='dummy' `;

        if (req.unitId && req.unitId != 5) {
            query = query + ' and s.processing_unit = ' + req.unitId;
        }
        query = query + ` GROUP BY soi.master_brand_id ORDER BY brand `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }
    async getCategoryDropForFgStockReport(req: UnitRequest): Promise<CommonResponse> {
        console.log(req, '***--req')
        const manager = getManager()
        let query = `SELECT si.category AS category ,s.processing_unit FROM ` + appSettings.sales_db + `.sale_order_items si
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details s ON s.sale_order_id=si.sale_order_id
        LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.sale_order_item_id=si.sale_order_item_id
        LEFT JOIN ` + appSettings.sales_db + `.sale_order_track str ON str.sale_order_id=si.sale_order_id
        LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id=si.sale_order_id
        WHERE si.categry_id> 0 and s.processing_unit>0 and str.so_status IN ('OPEN','IN_PROGRESS','CLOSED')AND st.status = "StockIn" AND so.so_process_type ='MTO' AND st.stock_type!='dummy' `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and s.processing_unit = ' + req.unitId;
        }
        query = query + ` GROUP BY si.category ORDER BY category `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }

    async getStockInTransactions(req?: StockInTransactionsRequest): Promise<CommonResponse> {
        try {

            const manager = getManager()
            let query = `SELECT r.reporting_log_id as reportingLogId,DATE(r.created_at) as createdAt, DATE(r.reporting_date) as reportingDate,r.reported_cases as reportingCases,r.rack_postion as rackPosition,r.loose_pouches as loosePouches,rp.rack_code as rackcode,r.lot_code as lotCode,r.shift as shift,r.transaction_type as transactionType,r.packing_completed as packingCompleted,r.pouches_shortage as pouchShortage,r.cartons_shortage as cartonShortage,r.sale_order_id as saleOrderId , si.po_number as poNumber,rp.rack_code as rackCode,sc.variant_code as variantCode,pm.packing_method_name as packStyle,br.brand_name as brandName,r.stock_type as stockType,uc.unit_name as unitName,r.unit_id as unitId,st.product_category as productCategory,st.wh_incharge as whIncharge,r.remarks AS remarks 
            FROM ` + appSettings.warehouse_db + `.reporting r
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id=r.sale_order_id
            LEFT JOIN ` + appSettings.masters_db + `.master_brands br ON br.master_brand_id=r.brand_id
            LEFT JOIN ` + appSettings.masters_db + `.rack_position rp ON rp.rack_position_id=r.rack_postion
            LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON  sc.sku_code_id = r.variant_id
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = r.unit_id
            LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.stock_id = r.stock_id
            LEFT JOIN ` + appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id=r.pack_style_id where r.reporting_log_id > 0 and r.is_active = true`
            if (req.unitId) {

                query = query + ' and r.unit_id = ' + req.unitId;
            }
            if (req.transactionFromDate != undefined) {
                query = query + ' and DATE(r.created_at) >=  "' + req.transactionFromDate + '" and DATE(r.created_at) <="' + req.transactionToDate + '"';
            }
            if (req.reportedFromData != undefined) {
                query = query + ' and DATE(r.reporting_date)  >= "' + req.reportedFromData + '" and DATE(r.reporting_date) <="' + req.reportedToData + '"';
            }
            if (req.product) {
                query = query + ' and sc.sku_code_id = ' + req.product;
            }
            query = query + ` ORDER BY r.created_at ASC`

            const data = await manager.query(query)
            if (data.length > 0) {
                return new CommonResponse(true, 11108, "Stock in transactions retrived sucessfully", data)
            }
            else {
                return new CommonResponse(false, 11108, "No data found")
            }
        } catch (error) {
            throw error
        }
    }
    async getProductDropForStockInReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT r.varient_id as varientId, r.unit_id , sc.variant_code as variantCode FROM  ` + appSettings.warehouse_db + `.reporting r
        LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=r.varient_id 
         WHERE r.reporting_log_id > 0 `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and s.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY sc.sku_code_id  ORDER BY sc.variant_code ASC `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1141, 'Data retreived sucessfully', data)
        } else {
            return new CommonResponse(false, 1411, 'No data')
        }
    }
    async getStockOutTransaction(req?: StockOutTransactionRequest): Promise<CommonResponse> {
        try {
            console.log(req, 'req')
            const manager = getManager();
            let query = `SELECT SUM(IF(uc.uom_name = 'OZ' , (fi.job_cartons * s.pouches * s.pouch_weight * 0.0625), IF(uc.uom_name = 'KG' ,(fi.job_cartons * s.pouches * s.pouch_weight * 2.20462), IF(uc.uom_name = 'GM' ,(fi.job_cartons * s.pouches * s.pouch_weight * 0.0022),(fi.job_cartons * s.pouches * s.pouch_weight))))) AS totalQty,stk.po_number AS allocatedPO,fj.job_purpose as jobPurpose, fi.created_at as transactionDate,fi.stock_id as stockId,s.location, fi.current_position as rackPosition,s.unit_id, u.unit_name as plant,s.stockin_qunatity as cartons,so.po_number as saleOrderNo,sc.variant_code as product,s.status as status,pm.packing_method_name as packingMethod,rp.rack_code as rackPositionCode,s.stockin_qunatity as stockIn,SUM(fi.job_cartons) as stockOut,fi.fork_lift_item_id,br.brand_name as brandName,s.product_category as productCategory,s.pouches_shortage as pouchShortage,s.cartons_shortage as cartonShortage FROM ` + appSettings.warehouse_db + `.fork_lift_items fi 
            LEFT JOIN ` + appSettings.warehouse_db + `.stock s ON s.stock_id = fi.stock_id
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details stk ON stk.sale_order_id = s.allocated_sale_order_id
            LEFT JOIN ` + appSettings.warehouse_db + `.fork_lift_jobs fj ON fj.job_id = fi.fork_lift_job_id
            LEFT JOIN ` + appSettings.masters_db + `.rack_position rp ON rp.rack_position_id = s.location 
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = s.unit_id 
            LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id = s.varient_id
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details so ON so.sale_order_id = s.sale_order_id
            LEFT JOIN ` + appSettings.sales_db + `.sale_order_items si ON si.sale_order_item_id = s.sale_order_item_id 
            LEFT JOIN ` + appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id = s.pack_style_id
            LEFT JOIN ` + appSettings.masters_db + `.uoms uc ON uc.uom_id = pm.uom_id
            LEFT JOIN ` + appSettings.masters_db + `.master_brands br ON br.master_brand_id=si.master_brand_id
            WHERE fi.fork_lift_item_id > 0 `
            if (req.unitId) {
                query = query + ' and fi.unit_id = ' + req.unitId;
            }
            if (req.transactionType) {
                let transactionTypeWithQuotes = req.transactionType.map((it) => { return `'${it}'` })
                query = query + ' and fj.job_purpose IN (' + transactionTypeWithQuotes + ')';
            }
            if (req.saleOrderId) {
                query = query + ' and fi.sale_order_id =' + req.saleOrderId;
            }
            if (req.fromDate != undefined) {
                query = query + ' and DATE(fi.created_at) >=  "' + req.fromDate + '" and DATE(fi.created_at) <= "' + req.toDate + '"';
            }
            if (req.product) {
                query = query + ' and sc.sku_code_id = ' + req.product;
            }
            query = query + ` group by fi.stock_id`
            //query = query + ` GROUP BY rp.rack_position_id `
            const Data = await manager.query(query);
            if (Data.length > 0) {
                const response = new CommonResponse(true, 11208, "Data retrived succesfully", Data);
                return response;
            } else {
                throw new ErrorResponse(99998, 'No Records Found')
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getShipmentStatusReport(req?: ShipmentStatusRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const currDate = new Date();
            const monthStartDate = currDate.getFullYear() + '-' + (Number(currDate.getMonth()) + 1) + '-01'
            let query = `SELECT sid.po_number as poNo,SUM(s.total_cartons) as Nocases,gr.grade_name AS grade,uc.unit_name as prodFacility,br.master_brand_id as masterBrandId ,br.brand_name as brand,sot.dispatched_date as dispatchDate,pm.packing_method_name as packingStyle,
            ci.invoice_number as invoiceNo,co.container_number as containerDetails,co.vehicle_number as vehicleNo ,co.line_seal as linerSeal,d.destination_name as finalDestination,ec.end_customer_name as endCustomer , sk.variant_code as variantCode
             FROM ` + appSettings.sales_db + `.sale_order_track sot  
             LEFT JOIN ` + appSettings.warehouse_db + `.stock s ON s.sale_order_id = sot.sale_order_id
             LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = sot.sale_order_id
             LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sku_code_id = s.varient_id
             LEFT JOIN ` + appSettings.masters_db + `.grades gr ON gr.grade_id = sk.grade_id
             LEFT JOIN ` + appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id = s.pack_style_id
             LEFT JOIN ` + appSettings.masters_db + `.master_brands br ON br.master_brand_id = s.brand_id 
             LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = sid.processing_unit
             LEFT JOIn ` + appSettings.logistics_db + `.container co ON co.sale_order_id = sot.sale_order_id
             LEFT JOIN ` + appSettings.sales_db + `.customer_invoice ci ON ci.sale_order_id = sot.sale_order_id
             LEFT JOIN ` + appSettings.masters_db + `.destination d ON d.destination_id = sid.destination
             LEFT JOIN ` + appSettings.masters_db + `.end_customers ec on ec.end_customer_id = sid.end_customer_id
             WHERE sot.sale_order_id > 0 and sot.is_dispatched=1 `
            if (req.unitId && req.unitId != 5) {
                query = query + ' and sid.processing_unit = ' + req.unitId;
            }
            if (req.saleOrderId) {
                query = query + ' and sot.sale_order_id = ' + req.saleOrderId;
            }
            if (req.masterBrandId) {
                query = query + ' and br.master_brand_id = ' + req.masterBrandId;
            }
            if (req.selectedLoadingFromDate != undefined) {
                query = query + ' and date(sot.dispatched_date) >= "' + req.selectedLoadingFromDate + '" and  date(sot.dispatched_date) <= "' + req.selectedLoadingToDate + '"';
            }
            query = query + ` GROUP BY sot.sale_order_id ORDER BY sot.dispatched_date DESC`
            const Data = await manager.query(query);
            if (Data.length > 0) {
                const response = new CommonResponse(true, 11208, "Data retrived succesfully", Data);
                return response;
            } else {
                throw new ErrorResponse(99998, 'No Records Found')
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getSoDropForShipmentStatusReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = ` SELECT sot.sale_order_id AS saleOrderId , sid.po_number AS poNo ,sid.processing_unit FROM ` + appSettings.sales_db + `.sale_order_track sot 
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = sot.sale_order_id
        LEFT JOIN ` + appSettings.warehouse_db + `.stock s ON s.sale_order_id = sot.sale_order_id
        WHERE s.sale_order_id>0 and sot.is_dispatched='1'`;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and sid.processing_unit = ' + req.unitId;
        }
        query = query + ` GROUP BY  sid.po_number ORDER BY poNo`;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }
    async getbrandDropForShipmentStatusReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT sot.sale_order_id, br.master_brand_id AS masterBrandId , br.brand_name AS masterBrandName , sid.processing_unit FROM ` + appSettings.sales_db + `.sale_order_track sot 
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = sot.sale_order_id
        LEFT JOIN ` + appSettings.warehouse_db + `.stock s ON s.sale_order_id = sot.sale_order_id
        LEFT JOIN ` + appSettings.masters_db + `.master_brands br ON br.master_brand_id = s.brand_id 
        WHERE sot.sale_order_id > 0 AND sot.is_dispatched='1' AND br.master_brand_id > 0 `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and sid.processing_unit = ' + req.unitId;
        }
        query = query + ` GROUP BY  br.brand_name ORDER BY masterBrandName`;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }

    async getAllStockOutSaleOrders(req?: UnitRequest): Promise<CommonResponse> {
        try {
            const manager = getManager()
            let query = 'SELECT distinct fi.sale_order_id as saleOrderId ,si.po_number as poNumber FROM  ' + appSettings.warehouse_db + '.fork_lift_items fi left join ' + appSettings.sales_db + '.so_invoice_details si on si.sale_order_id = fi.sale_order_id'
            if (req.unitId) {
                query = query + ' where fi.unit_id = ' + req.unitId
            };
            const data = await manager.query(query)
            if (data.length > 0) {
                const response = new CommonResponse(true, 11208, "data retrived succesfully", data);
                return response;
            } else {
                throw new ErrorResponse(99998, 'No Records Found')
            }
        } catch (error) {
            throw error;
        }
    }
    async getStockInReverseTransactions(req?: PlantIdRequest): Promise<CommonResponse> {
        try {
            const manager = getManager()
            let query = `SELECT r.reporting_log_id as reportingLogId,DATE(r.created_at) as createdAt, DATE(r.reporting_date) as reportingDate,r.reported_cases as reportingCases,r.rack_postion as rackPosition,r.loose_pouches as loosePouches,rp.rack_code as rackcode,r.lot_code as lotCode,r.shift as shift,r.transaction_type as transactionType,r.packing_completed as packingCompleted,r.pouches_shortage as pouchShortage,r.cartons_shortage as cartonShortage,r.sale_order_id as saleOrderId , si.po_number as poNumber,rp.rack_code as rackCode,sc.variant_code as variantCode,pm.packing_method_name as packStyle,br.brand_name as brandName,r.stock_type as stockType,uc.unit_name as unitName,r.unit_id as unitId,st.product_category as productCategory,st.wh_incharge as whIncharge,uc.unit_name as unit 
            FROM ` + appSettings.warehouse_db + `.reporting r
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id=r.sale_order_id
            LEFT JOIN ` + appSettings.masters_db + `.master_brands br ON br.master_brand_id=r.brand_id
            LEFT JOIN ` + appSettings.masters_db + `.rack_position rp ON rp.rack_position_id=r.rack_postion
            LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON  sc.sku_code_id = r.variant_id
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = r.unit_id
            LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.stock_id = r.stock_id
            LEFT JOIN ` + appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id=r.pack_style_id where r.reporting_log_id > 0 and DATEDIFF(NOW(),r.created_at) < 2  and r.is_active = true and st.status = "StockIn"`
            if (req.plantId != 5 && req.role != "ADMIN") {
                query = query + ' and r.unit_id = ' + req.plantId;
            }
            if (req.plantId && req.plantId != 5) {
                query += ` and r.unit_id=` + req.plantId;
            }
            query = query + ` ORDER BY r.reporting_log_id DESC`

            const data = await manager.query(query)
            if (data.length > 0) {
                return new CommonResponse(true, 11108, "Stock in transactions retrived sucessfully", data)
            }
            else {
                return new CommonResponse(false, 11108, "No data found")
            }
        } catch (error) {
            throw error
        }
    }

    async getStockInUsage() {
        try {
            const manager = getManager();
            let query = `SELECT puc.unit_name,COUNT(*) AS cnt FROM erpx_dev_warehouse.reporting r 
        LEFT JOIN erpx_dev_masters.unitcodes puc ON puc.unit_code_id = r.unit_id  WHERE  DATE(r.created_at)=DATE(NOW()) and r.is_active = true
        GROUP BY r.unit_id  ORDER BY r.unit_id`
            const data = await manager.query(query);
            const messageType = new Date();
            const month = messageType.getMonth() + 1;
            const date = messageType.getFullYear() + '-' + month + '-' + messageType.getDate();
            const time = messageType.toLocaleTimeString();
            const timeForusage = moment().subtract(1, "days").format('MMMM Do, YYYY');

            if (data.length > 0) {
                let stockInTransdata = '';
                for (const sd of data) {
                    stockInTransdata += sd.unit_name + "   *" + sd.cnt + "*\n";
                }

                const message = new BroadCastMessageRequest(25, timeForusage + stockInTransdata, [whatsApp.UsageReport])
                console.log(message);
                const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(message);
            } else {
                const message = new BroadCastMessageRequest(25, timeForusage + 'No data', [whatsApp.UsageReport])
                console.log(message);
                const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(message);
            }
            return new CommonResponse(true, 11108, "msg send Sucessfully", data)
        } catch (error) {
            return new CommonResponse(false, 11108, "No data found")
        }
    }

    async getStockOutUsage() {
        try {
            const manager = getManager();
            let query = `SELECT puc.unit_name,COUNT(*) AS cnt FROM erpx_dev_warehouse.fork_lift_items f
        LEFT JOIN erpx_dev_masters.unitcodes puc ON puc.unit_code_id = f.unit_id  WHERE  DATE(f.created_at)=DATE(NOW())
        GROUP BY f.unit_id  ORDER BY f.unit_id`
            const data = await manager.query(query);
            const messageType = new Date();
            const month = messageType.getMonth() + 1;
            const date = messageType.getFullYear() + '-' + month + '-' + messageType.getDate();
            const time = messageType.toLocaleTimeString();
            const timeForReport = moment().subtract(1, "days").format('MMMM Do, YYYY');

            if (data.length > 0) {
                let stockOutTransdata = '';
                for (const sd of data) {
                    stockOutTransdata += sd.unit_name + "   *" + sd.cnt + "*\n";
                }

                const message = await new BroadCastMessageRequest(26, timeForReport + stockOutTransdata, [whatsApp.UsageReport])
                console.log(message);
                const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(message);
            } else {
                const message = await new BroadCastMessageRequest(26, timeForReport + 'No data', [whatsApp.UsageReport])
                console.log(message);
                const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(message);
            }
            return new CommonResponse(true, 11108, "transfer data retrived", data)
        } catch (error) {
            return new CommonResponse(false, 11108, "No data found")
        }
    }
    async getShiftsDropdownForStockInReport(req?: UnitRequest): Promise<CommonResponse> {
        console.log(req, 'req')
        const manager = getManager()
        let query;
        query = 'select distinct  s.shift from' + appSettings.warehouse_db + '.stock s '
        if (req.unitId && req.unitId != 5) {
            query = query + 'where s.unitId = ' + req.unitId
        }
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1111, 'Data retreived sucessfully', data)
        } else {
            return new CommonResponse(false, 1111, 'No data')
        }
    }
    async getUnitDropdownForStockInReport(): Promise<CommonResponse> {
        const manager = getManager()
        let query;
        query = `SELECT distinct(r.unit_id) , uc.unit_name AS plantName, r.unit_id AS plantId FROM ` + appSettings.warehouse_db + `.reporting r LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = r.unit_id`

        //  if(req.unitId && req.unitId != 5){
        //        query = query + 'where s.unitId = ' + req.unitId
        //  }
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1111, 'Data retreived sucessfully', data)
        } else {
            return new CommonResponse(false, 1111, 'No data')
        }
    }
    async getUnitDropdownForStockReport(): Promise<CommonResponse> {
        const manager = getManager()
        let query;
        query = `SELECT distinct(s.unit_id) , uc.unit_name AS plantName, s.unit_id AS plantId FROM ` + appSettings.warehouse_db + `.stock s LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = s.unit_id`

        //  if(req.unitId && req.unitId != 5){
        //        query = query + 'where s.unitId = ' + req.unitId
        //  }
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1111, 'Data retreived sucessfully', data)
        } else {
            return new CommonResponse(false, 1111, 'No data')
        }
    }
    async moveLeftOverQtytoDummy(req: SoIdRequest): Promise<CommonResponse> {
        console.log(req);
        console.log("**************");

        const res = new GenericTransactionManager();
        try {

            let flag: boolean;
            await res.startTransaction();
            const manager = getManager()
            let getProcessingUnit = 'select processing_unit As unit, sid.po_number AS poNumber from '+appSettings.sales_db+'.so_invoice_details sid where sale_order_id='+req.saleOrderId;
            const resultData = await manager.query(getProcessingUnit);

            let getStockDetails = 'Select s.stock_id AS stockId, s.sale_order_id AS saleOrderId, s.sale_order_item_id AS saleOrderItemId,s.varient_id AS varientId, sid.processing_unit AS processingUnit, s.total_cartons AS totalCartons from ' + appSettings.warehouse_db + '.stock s left join ' + appSettings.sales_db + '.so_invoice_details sid on sid.sale_order_id = s.sale_order_id where status = "StockIn" and s.sale_order_id = ' + req.saleOrderId + ` and s.unit_id =` + resultData[0].unit;
            const data = await manager.query(getStockDetails);
            console.log("data" + data);
            if (data.length > 0) {
                let getDummySO = 'Select sid.sale_order_id AS saleOrderId from ' + appSettings.sales_db + '.so_invoice_details sid left join ' + appSettings.sales_db + '.sale_order s on s.sale_order_id = sid.sale_order_id where sid.processing_unit = ' + data[0].processingUnit + ' and s.so_process_type = "MTS"';
                const dummySO = await manager.query(getDummySO);

                if (dummySO.length > 0) {
                    for (const item of data) {
                        console.log(req.saleOrderId + "*****" + item.saleOrderItemId);
                        let getItemDetails = await this.saleOrderService.getSaleOrderItemDetailsForSoItemId({ saleOrderId: req.saleOrderId, saleOrderItemId: item.saleOrderItemId });
                        console.log(getItemDetails);
                        if (getItemDetails.data) {
                            let checkProductExistInDummySO = 'select si.master_brand_id AS brandId,si.pack_style_id AS packStyleId,sale_order_item_id AS saleOrderItemId,master_brand_id As masterBrandId,varient_id AS varientId, min_grade_id AS minGrade, max_grade_id AS maxGrade,categry_id AS categoryId, pouches AS pouches , pouch_weight AS pouchWeight, pallet_capacity AS palletCapacity, uom_id AS uomId from ' + appSettings.sales_db + '.sale_order_items si where varient_id = ' + getItemDetails.data.varientId + ' and pack_style_id = ' + getItemDetails.data.packStyleId + ' and sale_order_id = ' + dummySO[0].saleOrderId;
                            const itemStatus = await manager.query(checkProductExistInDummySO);
                            console.log(itemStatus);
                            if (itemStatus.length > 0) {
                                const stockLogObj = new StockLog();
                                stockLogObj.stockId = item.stockId;
                                stockLogObj.oldSoId = item.saleOrderId;
                                stockLogObj.oldSoItemId = item.saleOrderItemId;
                                stockLogObj.updatedSoId = dummySO[0].saleOrderId;
                                stockLogObj.updatedSoItemId = dummySO[0].saleOrderItemId;
                                stockLogObj.purpose = "Left Over Quantity After Shipped";
                                stockLogObj.cartons = item.totalCartons;
                                stockLogObj.plantId = req.plantId;

                                let savedLog = await manager.getCustomRepository(StockLogRepository).save(stockLogObj);
                                if (!savedLog) {
                                    throw new ErrorResponse(11106, 'Something Went Wrong');
                                }
                                else {
                                    let query = "Select * from " + appSettings.warehouse_db + ".stock s where stock_id =" + item.stockId;
                                    const stockData = await manager.query(query);

                                    if (stockData[0].stockout_qunatity > 0) {
                                        let stockStatusUpdate = 'Update ' + appSettings.warehouse_db + '.stock set status = "StockOut" where stock_id = ' + item.stockId;
                                        const updateStockStatus = await manager.query(stockStatusUpdate);
                                        console.log(updateStockStatus);
                                        if (updateStockStatus.affectedRows > 0) {
                                            let date = moment(stockData[0].date).format('YYYY-MM-DD hh:mm:ss');
                                            let insertStockquery = 'INSERT INTO ' + appSettings.warehouse_db + '.stock (`stock_id`, `lot_no`, `soaking_time`, `soaking_style`, `pallet_code`, `wh_incharge`, `sale_order_id`, `allocated_sale_order_id`, `allocated_sale_orderitem__id`, `sale_order_item_id`, `total_cartons`, `stockout_qunatity`, `stockin_qunatity`, `total_pouches`, `loose_pouches`, `packing_completed`, `pouches_shortage`, `cartons_shortage`, `is_damaged`, `location`, `zone_id`, `pallet`, `pack_style_id`, `date`, `stock_type`, `status`, `state`, `shift`, `transaction_type`, `stock_out_category`, `product_category`, `brand_id`, `product_id`, `unit_id`, `varient_id`, `min_grade`, `max_grade`, `category_id`, `count`, `pouches`, `pallet_capacity`, `pouch_weight`, `uom_id`, `net_weight`, `code`, `remarks`, `trace_code`, `created_at`, `created_user`, `updated_at`, `updated_user`, `version_flag`) VALUES (DEFAULT, "LOT-DUMMY/01/01/0001", DEFAULT, DEFAULT, 0, DEFAULT, ' + dummySO[0].saleOrderId + ', DEFAULT, DEFAULT, ' + itemStatus[0].saleOrderItemId + ', ' + stockData[0].total_cartons + ', DEFAULT, ' + stockData[0].total_cartons + ', 0, 0, "No", "No", "yes", DEFAULT, ' + stockData[0].location + ', ' + stockData[0].zone_id + ', 0, ' + stockData[0].pack_style_id + ',"' + date + '", "dummy","StockIn", DEFAULT, "ShiftA", "rm", DEFAULT, "G1", ' + itemStatus[0].masterBrandId + ', 0, ' + stockData[0].unit_id + ', ' + itemStatus[0].varientId + ', ' + itemStatus[0].minGrade + ', ' + itemStatus[0].maxGrade + ', ' + itemStatus[0].categoryId + ', 0, ' + itemStatus[0].pouches + ', ' + itemStatus[0].palletCapacity + ', ' + itemStatus[0].pouchWeight + ', ' + itemStatus[0].uomId + ', DEFAULT, DEFAULT, DEFAULT, null, DEFAULT, DEFAULT, DEFAULT, DEFAULT, 1)'
                                            const insertStock = await manager.query(insertStockquery);
                                            console.log(insertStock);
                                            if (insertStock.affectedRows > 0) {
                                                flag = true;
                                                // res.completeTransaction();
                                                // return new CommonResponse(true,1001,"Stock moved to dummy successfully. ",);
                                            }
                                            else {
                                                flag = false
                                                res.releaseTransaction();
                                                return new CommonResponse(false, 1010, "Something went wrong. ",);
                                            }
                                        }
                                    }
                                    else {

                                        let stockUpdate = 'Update ' + appSettings.warehouse_db + '.stock set sale_order_id = ' + dummySO[0].saleOrderId + ',pack_style_id = '+itemStatus[0].packStyleId+',brand_id = '+itemStatus[0].brandId+ ',sale_order_item_id = ' + itemStatus[0].saleOrderItemId + ', stock_type ="dummy" where stock_id = ' + item.stockId;
                                        const updateStock = await manager.query(stockUpdate);
                                        console.log(updateStock);

                                        if (updateStock.affectedRows > 0) {
                                            flag = true;
                                            // res.completeTransaction();
                                            // return new CommonResponse(true,1001,"Stock moved to dummy successfully. ",);
                                        }
                                        else {
                                            flag = false
                                            res.releaseTransaction();
                                            return new CommonResponse(false, 1010, "Something went wrong. ",);
                                        }
                                    }
                                }
                            }
                            else {
                                const req1 = new SaleOrderItemsInfo(dummySO[0].saleOrderItemId, dummySO[0].saleOrderId, getItemDetails.data.itemId, getItemDetails.data.minGrade, getItemDetails.data.maxGrade, getItemDetails.data.foodTypeId, getItemDetails.data.valAddOneId, getItemDetails.data.valAddTwoId, getItemDetails.data.valAddThreeId, getItemDetails.data.valAddFourId, getItemDetails.data.valAddFiveId, getItemDetails.data.pouches, item.totalCartons, getItemDetails.data.caseWeight, getItemDetails.data.netWeight, getItemDetails.data.netAmount, getItemDetails.data.createdUser, getItemDetails.data.pouchWeight, getItemDetails.data.categoryId, getItemDetails.data.unitPrice, getItemDetails.data.brandId, getItemDetails.data.uomId, getItemDetails.data.minGlaze, getItemDetails.data.MaxGlaze, getItemDetails.data.soakingTime, getItemDetails.data.soakingStyle, getItemDetails.data.styleWeighment, getItemDetails.data.varientId, 0, getItemDetails.data.shrimpWeight, getItemDetails.data.innerBagSizeId, getItemDetails.data.skewerSizeItemId, getItemDetails.data.updatedUser, getItemDetails.data.masterBrandId, getItemDetails.data.finalPercentage, getItemDetails.data.category, getItemDetails.data.requiredCount, getItemDetails.data.packStyleId, item.totalCartons, item.totalCartons);
                                console.log("request req" + req1.jobCases);
                                let addDummyProduct = await this.saleOrderService.addSoItem(req1);
                                console.log("addDummyProduct" + addDummyProduct.data);

                                const stockLogObj = new StockLog();
                                stockLogObj.stockId = item.stockId;
                                stockLogObj.oldSoId = item.saleOrderId;
                                stockLogObj.oldSoItemId = item.saleOrderItemId;
                                stockLogObj.updatedSoId = addDummyProduct.data.saleOrderId;
                                stockLogObj.updatedSoItemId = addDummyProduct.data.saleOrderItemId;
                                stockLogObj.purpose = "Left Over Quantity After Shipped";
                                stockLogObj.cartons = item.totalCartons; 
                                stockLogObj.plantId = req.plantId; 

                                let savedLog = await manager.getCustomRepository(StockLogRepository).save(stockLogObj);
                                if (!savedLog) {
                                    throw new ErrorResponse(11106, 'Something Went Wrong');
                                }
                                else {

                                    let query = "Select * from " + appSettings.warehouse_db + ".stock s where stock_id =" + item.stockId;
                                    const stockData = await manager.query(query);

                                    if (stockData[0].stockout_qunatity > 0) {
                                        let stockStatusUpdate = 'Update ' + appSettings.warehouse_db + '.stock set status = "StockOut" where stock_id = ' + item.stockId;
                                        const updateStockStatus = await manager.query(stockStatusUpdate);
                                        console.log(updateStockStatus);
                                        if (updateStockStatus.affectedRows > 0) {
                                            let date = moment(stockData[0].date).format('YYYY-MM-DD hh:mm:ss');
                                            let insertStockquery = 'INSERT INTO ' + appSettings.warehouse_db + '.stock (`stock_id`, `lot_no`, `soaking_time`, `soaking_style`, `pallet_code`, `wh_incharge`, `sale_order_id`, `allocated_sale_order_id`, `allocated_sale_orderitem__id`, `sale_order_item_id`, `total_cartons`, `stockout_qunatity`, `stockin_qunatity`, `total_pouches`, `loose_pouches`, `packing_completed`, `pouches_shortage`, `cartons_shortage`, `is_damaged`, `location`, `zone_id`, `pallet`, `pack_style_id`, `date`, `stock_type`, `status`, `state`, `shift`, `transaction_type`, `stock_out_category`, `product_category`, `brand_id`, `product_id`, `unit_id`, `varient_id`, `min_grade`, `max_grade`, `category_id`, `count`, `pouches`, `pallet_capacity`, `pouch_weight`, `uom_id`, `net_weight`, `code`, `remarks`, `trace_code`, `created_at`, `created_user`, `updated_at`, `updated_user`, `version_flag`) VALUES (DEFAULT, "LOT-DUMMY/01/01/0001", DEFAULT, DEFAULT, 0, DEFAULT, ' + addDummyProduct.data.saleOrderId + ', DEFAULT, DEFAULT, ' + addDummyProduct.data.saleOrderItemId + ', ' + stockData[0].total_cartons + ', DEFAULT, ' + stockData[0].total_cartons + ', 0, 0, "No", "No", "yes", DEFAULT, ' + stockData[0].location + ', ' + stockData[0].zone_id + ', 0, ' + getItemDetails.data.packStyleId + ',"' + date + '", "dummy","StockIn", DEFAULT, "ShiftA", "rm", DEFAULT, "G1", ' + itemStatus[0].masterBrandId + ', 0, ' + stockData[0].unit_id + ', ' + getItemDetails.data.varientId + ', ' + getItemDetails.data.minGrade + ', ' + getItemDetails.data.maxGrade + ', ' + getItemDetails.data.categoryId + ', 0, ' + getItemDetails.data.pouches + ', ' + itemStatus[0].palletCapacity + ', ' + getItemDetails.data.pouchWeight + ', ' + itemStatus[0].uomId + ', DEFAULT, DEFAULT, DEFAULT, null, DEFAULT, DEFAULT, DEFAULT, DEFAULT, 1)'
                                            const insertStock = await manager.query(insertStockquery);
                                            console.log(insertStock);
                                            if (insertStock.affectedRows > 0) {
                                                flag = true;
                                                // res.completeTransaction();
                                                // return new CommonResponse(true,1001,"Stock moved to dummy successfully. ",);
                                            }
                                            else {
                                                flag = false
                                                res.releaseTransaction();
                                                return new CommonResponse(false, 1010, "Something went wrong. ",);
                                            }
                                        }
                                    }
                                    else {
                                        console.log("Main Job");
                                        let stockUpdate = 'Update ' + appSettings.warehouse_db + '.stock set pack_style_id = '+addDummyProduct.data.packStyleId+',brand_id = '+addDummyProduct.data.brandId+',sale_order_id = ' + addDummyProduct.data.saleOrderId + ', sale_order_item_id = ' + addDummyProduct.data.saleOrderItemId + ', stock_type="dummy" where stock_id = ' + item.stockId;
                                        const updateStock = await manager.query(stockUpdate);
                                        console.log(updateStock);
                                        if (updateStock.affectedRows > 0) {
                                            flag = true
                                            // res.completeTransaction();
                                            // return new CommonResponse(true,1001,"Stock moved to dummy successfully. ",);
                                        }
                                        else {
                                            flag = false
                                            res.releaseTransaction();
                                            return new CommonResponse(false, 1010, "Something went wrong. ",);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    res.releaseTransaction();
                    return new CommonResponse(false, 1010, "Dummy SO not found,Please create dummy SO. ",);
                }
            }
            let getSubJobSoId = "Select sid.sale_order_id AS saleOrderId,sid.processing_unit As unit, sid.po_number AS poNumber from "+appSettings.sales_db+".so_invoice_details sid where sid.po_number = '"+resultData[0].poNumber+"' and job_type = 'Sub Job'";
            const resultsData = await manager.query(getSubJobSoId);
            if(resultsData.length > 0){
                let getStockDetails1 = 'Select s.stock_id AS stockId, s.sale_order_id AS saleOrderId, s.sale_order_item_id AS saleOrderItemId,s.varient_id AS varientId, sid.processing_unit AS processingUnit, s.total_cartons AS totalCartons from ' + appSettings.warehouse_db + '.stock s left join ' + appSettings.sales_db + '.so_invoice_details sid on sid.sale_order_id = s.sale_order_id where status = "StockIn" and s.sale_order_id = ' + resultsData[0].saleOrderId + ` and s.unit_id =` + resultsData[0].unit;
                const data1 = await manager.query(getStockDetails1);
                console.log("data" + data1);
                if(data1.length > 0){
                    let getDummySO = 'Select Max(sid.sale_order_id) AS saleOrderId from ' + appSettings.sales_db + '.so_invoice_details sid left join ' + appSettings.sales_db + '.sale_order s on s.sale_order_id = sid.sale_order_id where sid.processing_unit = ' + resultsData[0].unit + ' and s.so_process_type = "MTS"';
                    const dummySO = await manager.query(getDummySO);

                    if (dummySO.length > 0) {
                        for (const item of data1) {
                            console.log(dummySO[0].saleOrderId + "*****" + item.saleOrderItemId);
                            let getItemDetails = await this.saleOrderService.getSaleOrderItemDetailsForSoItemId({ saleOrderId: resultsData[0].saleOrderId, saleOrderItemId: item.saleOrderItemId });
                            console.log(getItemDetails);
                            
                            if (getItemDetails.data) {
                                let checkProductExistInDummySO = 'select si.master_brand_id AS brandId,si.pack_style_id AS packStyleId,sale_order_item_id AS saleOrderItemId,master_brand_id As masterBrandId,varient_id AS varientId, min_grade_id AS minGrade, max_grade_id AS maxGrade,categry_id AS categoryId, pouches AS pouches , pouch_weight AS pouchWeight, pallet_capacity AS palletCapacity, uom_id AS uomId from ' + appSettings.sales_db + '.sale_order_items si where varient_id = ' + getItemDetails.data.varientId + ' and pack_style_id = ' + getItemDetails.data.packStyleId + ' and sale_order_id = ' + dummySO[0].saleOrderId;
                                const itemStatus = await manager.query(checkProductExistInDummySO);
                                console.log(itemStatus);
                                if (itemStatus.length > 0) {
                                    const stockLogObj = new StockLog();
                                    stockLogObj.stockId = item.stockId;
                                    stockLogObj.oldSoId = item.saleOrderId;
                                    stockLogObj.oldSoItemId = item.saleOrderItemId;
                                    stockLogObj.updatedSoId = dummySO[0].saleOrderId;
                                    stockLogObj.updatedSoItemId = dummySO[0].saleOrderItemId;
                                    stockLogObj.purpose = "Left Over Quantity After Shipped";
                                    stockLogObj.cartons = item.totalCartons;
                                    stockLogObj.plantId = resultsData[0].unit;

                                    let savedLog = await manager.getCustomRepository(StockLogRepository).save(stockLogObj);
                                    if (!savedLog) {
                                        throw new ErrorResponse(11106, 'Something Went Wrong');
                                    }
                                    else {
                                        let query = "Select * from " + appSettings.warehouse_db + ".stock s where stock_id =" + item.stockId;
                                        const stockData = await manager.query(query);

                                        if (stockData[0].stockout_qunatity > 0) {
                                            let stockStatusUpdate = 'Update ' + appSettings.warehouse_db + '.stock set status = "StockOut" where stock_id = ' + item.stockId;
                                            const updateStockStatus = await manager.query(stockStatusUpdate);
                                            console.log(updateStockStatus);
                                            if (updateStockStatus.affectedRows > 0) {
                                                let date = moment(stockData[0].date).format('YYYY-MM-DD hh:mm:ss');
                                                let insertStockquery = 'INSERT INTO ' + appSettings.warehouse_db + '.stock (`stock_id`, `lot_no`, `soaking_time`, `soaking_style`, `pallet_code`, `wh_incharge`, `sale_order_id`, `allocated_sale_order_id`, `allocated_sale_orderitem__id`, `sale_order_item_id`, `total_cartons`, `stockout_qunatity`, `stockin_qunatity`, `total_pouches`, `loose_pouches`, `packing_completed`, `pouches_shortage`, `cartons_shortage`, `is_damaged`, `location`, `zone_id`, `pallet`, `pack_style_id`, `date`, `stock_type`, `status`, `state`, `shift`, `transaction_type`, `stock_out_category`, `product_category`, `brand_id`, `product_id`, `unit_id`, `varient_id`, `min_grade`, `max_grade`, `category_id`, `count`, `pouches`, `pallet_capacity`, `pouch_weight`, `uom_id`, `net_weight`, `code`, `remarks`, `trace_code`, `created_at`, `created_user`, `updated_at`, `updated_user`, `version_flag`) VALUES (DEFAULT, "LOT-DUMMY/01/01/0001", DEFAULT, DEFAULT, 0, DEFAULT, ' + dummySO[0].saleOrderId + ', DEFAULT, DEFAULT, ' + itemStatus[0].saleOrderItemId + ', ' + stockData[0].total_cartons + ', DEFAULT, ' + stockData[0].total_cartons + ', 0, 0, "No", "No", "yes", DEFAULT, ' + stockData[0].location + ', ' + stockData[0].zone_id + ', 0, ' + stockData[0].pack_style_id + ',"' + date + '", "dummy","StockIn", DEFAULT, "ShiftA", "rm", DEFAULT, "G1", ' + itemStatus[0].masterBrandId + ', 0, ' + stockData[0].unit_id + ', ' + itemStatus[0].varientId + ', ' + itemStatus[0].minGrade + ', ' + itemStatus[0].maxGrade + ', ' + itemStatus[0].categoryId + ', 0, ' + itemStatus[0].pouches + ', ' + itemStatus[0].palletCapacity + ', ' + itemStatus[0].pouchWeight + ', ' + itemStatus[0].uomId + ', DEFAULT, DEFAULT, DEFAULT, null, DEFAULT, DEFAULT, DEFAULT, DEFAULT, 1)'
                                                const insertStock = await manager.query(insertStockquery);
                                                console.log(insertStock);
                                                if (insertStock.affectedRows > 0) {
                                                    flag = true;
                                                    // res.completeTransaction();
                                                    // return new CommonResponse(true,1001,"Stock moved to dummy successfully. ",);
                                                }
                                                else {
                                                    flag = false
                                                    res.releaseTransaction();
                                                    return new CommonResponse(false, 1010, "Something went wrong. ",);
                                                }
                                            }
                                        }
                                        else {

                                            let stockUpdate = 'Update ' + appSettings.warehouse_db + '.stock set sale_order_id = ' + dummySO[0].saleOrderId + ',pack_style_id = '+itemStatus[0].packStyleId+',brand_id = '+itemStatus[0].brandId+ ',sale_order_item_id = ' + itemStatus[0].saleOrderItemId + ', stock_type ="dummy" where stock_id = ' + item.stockId;
                                            const updateStock = await manager.query(stockUpdate);
                                            console.log(updateStock);

                                            if (updateStock.affectedRows > 0) {
                                                flag = true;
                                                // res.completeTransaction();
                                                // return new CommonResponse(true,1001,"Stock moved to dummy successfully. ",);
                                            }
                                            else {
                                                flag = false
                                                res.releaseTransaction();
                                                return new CommonResponse(false, 1010, "Something went wrong. ",);
                                            }
                                        }
                                    }
                                }
                                else {
                                    const req1 = new SaleOrderItemsInfo(dummySO[0].saleOrderItemId, dummySO[0].saleOrderId, getItemDetails.data.itemId, getItemDetails.data.minGrade, getItemDetails.data.maxGrade, getItemDetails.data.foodTypeId, getItemDetails.data.valAddOneId, getItemDetails.data.valAddTwoId, getItemDetails.data.valAddThreeId, getItemDetails.data.valAddFourId, getItemDetails.data.valAddFiveId, getItemDetails.data.pouches, item.totalCartons, getItemDetails.data.caseWeight, getItemDetails.data.netWeight, getItemDetails.data.netAmount, getItemDetails.data.createdUser, getItemDetails.data.pouchWeight, getItemDetails.data.categoryId, getItemDetails.data.unitPrice, getItemDetails.data.brandId, getItemDetails.data.uomId, getItemDetails.data.minGlaze, getItemDetails.data.MaxGlaze, getItemDetails.data.soakingTime, getItemDetails.data.soakingStyle, getItemDetails.data.styleWeighment, getItemDetails.data.varientId, 0, getItemDetails.data.shrimpWeight, getItemDetails.data.innerBagSizeId, getItemDetails.data.skewerSizeItemId, getItemDetails.data.updatedUser, getItemDetails.data.masterBrandId, getItemDetails.data.finalPercentage, getItemDetails.data.category, getItemDetails.data.requiredCount, getItemDetails.data.packStyleId, item.totalCartons, item.totalCartons);
                                    console.log("request req" + req1.jobCases);
                                    let addDummyProduct = await this.saleOrderService.addSoItem(req1);
                                    console.log(addDummyProduct)
                                    console.log("addDummyProduct" + addDummyProduct.data.packStyleId);
                                    console.log("addDummyProduct" + addDummyProduct.data.brandId);
                                    console.log("addDummyProduct" + addDummyProduct.data.saleOrderId);
                                    console.log("addDummyProduct" + addDummyProduct.data.saleOrderItemId);

                                    const stockLogObj = new StockLog();
                                    stockLogObj.stockId = item.stockId;
                                    stockLogObj.oldSoId = item.saleOrderId;
                                    stockLogObj.oldSoItemId = item.saleOrderItemId;
                                    stockLogObj.updatedSoId = addDummyProduct.data.saleOrderId;
                                    stockLogObj.updatedSoItemId = addDummyProduct.data.saleOrderItemId;
                                    stockLogObj.purpose = "Left Over Quantity After Shipped";
                                    stockLogObj.cartons = item.totalCartons; 
                                    stockLogObj.plantId = resultsData[0].unit; 

                                    let savedLog = await manager.getCustomRepository(StockLogRepository).save(stockLogObj);
                                    if (!savedLog) {
                                        throw new ErrorResponse(11106, 'Something Went Wrong');
                                    }
                                    else {

                                        let query = "Select * from " + appSettings.warehouse_db + ".stock s where stock_id =" + item.stockId;
                                        const stockData = await manager.query(query);

                                        if (stockData[0].stockout_qunatity > 0) {
                                            let stockStatusUpdate = 'Update ' + appSettings.warehouse_db + '.stock set status = "StockOut" where stock_id = ' + item.stockId;
                                            const updateStockStatus = await manager.query(stockStatusUpdate);
                                            console.log(updateStockStatus);
                                            if (updateStockStatus.affectedRows > 0) {
                                                let date = moment(stockData[0].date).format('YYYY-MM-DD hh:mm:ss');
                                                let insertStockquery = 'INSERT INTO ' + appSettings.warehouse_db + '.stock (`stock_id`, `lot_no`, `soaking_time`, `soaking_style`, `pallet_code`, `wh_incharge`, `sale_order_id`, `allocated_sale_order_id`, `allocated_sale_orderitem__id`, `sale_order_item_id`, `total_cartons`, `stockout_qunatity`, `stockin_qunatity`, `total_pouches`, `loose_pouches`, `packing_completed`, `pouches_shortage`, `cartons_shortage`, `is_damaged`, `location`, `zone_id`, `pallet`, `pack_style_id`, `date`, `stock_type`, `status`, `state`, `shift`, `transaction_type`, `stock_out_category`, `product_category`, `brand_id`, `product_id`, `unit_id`, `varient_id`, `min_grade`, `max_grade`, `category_id`, `count`, `pouches`, `pallet_capacity`, `pouch_weight`, `uom_id`, `net_weight`, `code`, `remarks`, `trace_code`, `created_at`, `created_user`, `updated_at`, `updated_user`, `version_flag`) VALUES (DEFAULT, "LOT-DUMMY/01/01/0001", DEFAULT, DEFAULT, 0, DEFAULT, ' + addDummyProduct.data.saleOrderId + ', DEFAULT, DEFAULT, ' + addDummyProduct.data.saleOrderItemId + ', ' + stockData[0].total_cartons + ', DEFAULT, ' + stockData[0].total_cartons + ', 0, 0, "No", "No", "yes", DEFAULT, ' + stockData[0].location + ', ' + stockData[0].zone_id + ', 0, ' + getItemDetails.data.packStyleId + ',"' + date + '", "dummy","StockIn", DEFAULT, "ShiftA", "rm", DEFAULT, "G1", ' + itemStatus[0].masterBrandId + ', 0, ' + stockData[0].unit_id + ', ' + getItemDetails.data.varientId + ', ' + getItemDetails.data.minGrade + ', ' + getItemDetails.data.maxGrade + ', ' + getItemDetails.data.categoryId + ', 0, ' + getItemDetails.data.pouches + ', ' + itemStatus[0].palletCapacity + ', ' + getItemDetails.data.pouchWeight + ', ' + itemStatus[0].uomId + ', DEFAULT, DEFAULT, DEFAULT, null, DEFAULT, DEFAULT, DEFAULT, DEFAULT, 1)'
                                                const insertStock = await manager.query(insertStockquery);
                                                console.log(insertStock);
                                                if (insertStock.affectedRows > 0) {
                                                    flag = true;
                                                    // res.completeTransaction();
                                                    // return new CommonResponse(true,1001,"Stock moved to dummy successfully. ",);
                                                }
                                                else {
                                                    flag = false
                                                    res.releaseTransaction();
                                                    return new CommonResponse(false, 1010, "Something went wrong. ",);
                                                }
                                            }
                                        }
                                        else {
                                            console.log("Sub Job");
                                            let stockUpdate = 'Update ' + appSettings.warehouse_db + '.stock set pack_style_id = '+addDummyProduct.data.packStyleId+',brand_id = '+addDummyProduct.data.brandId+',sale_order_id = ' + addDummyProduct.data.saleOrderId + ', sale_order_item_id = ' + addDummyProduct.data.saleOrderItemId + ', stock_type="dummy" where stock_id = ' + item.stockId;
                                            const updateStock = await manager.query(stockUpdate);
                                            console.log(updateStock);
                                            if (updateStock.affectedRows > 0) {
                                                flag = true
                                                // res.completeTransaction();
                                                // return new CommonResponse(true,1001,"Stock moved to dummy successfully. ",);
                                            }
                                            else {
                                                flag = false
                                                res.releaseTransaction();
                                                return new CommonResponse(false, 1010, "Something went wrong. ",);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        res.releaseTransaction();
                        return new CommonResponse(false, 1010, "Dummy SO not found,Please create dummy SO. ",);
                    }
                }
                console.log(flag);
            }
            else{
                flag = true
            }
            console.log(flag);
            if (!flag) {
                res.releaseTransaction();
                return new CommonResponse(false, 1010, "Something went wrong. ",);
            }
            else {
                res.completeTransaction();
                return new CommonResponse(true, 1001, "Stock moved to dummy successfully. ",);
            }

        } catch (error) {
            await res.releaseTransaction();
            return new CommonResponse(false, 11108, "No data found")
        }
    }

    async getStockDetails(req?: RackPostionReq): Promise<CommonResponse> {
        const res = new GenericTransactionManager();
        try {
            // await res.startTransaction();
            const manager = getManager()
            let getStockDetails = 'Select s.stock_type as stockType,r.rack_code AS rackCode,s.stock_id AS stockId,SUM(s.total_cartons) AS cartons,s.status AS status,sid.po_number AS poNumber,sk.variant_code AS variantCode,pm.max_pallet_capacity AS maxPalletCapacity from ' + appSettings.warehouse_db + '.stock s left join ' + appSettings.masters_db + '.rack_position r on r.rack_position_id = s.location left join ' + appSettings.sales_db + '.so_invoice_details sid on sid.sale_order_id = s.sale_order_id left join ' + appSettings.sales_db + '.sale_order_items si on si.sale_order_item_id = s.sale_order_item_id left join ' + appSettings.masters_db + '.packing_methods pm on pm.packing_method_id = si.pack_style_id left join ' + appSettings.masters_db + '.sku_codes sk on sk.sku_code_id = si.varient_id where status = "StockIn" and s.location = ' + req.rackPositionId + ' group by s.sale_order_id, si.varient_id order by sid.po_number ASC';
            const data = await manager.query(getStockDetails);
            console.log(getStockDetails);
            if (data.length > 0) {
                return new CommonResponse(true, 1010, "Stock Details retrived successfully. ", data);
            }
            else {
                return new CommonResponse(false, 1010, "No data found. ",);
            }
        } catch (error) {
            // await res.releaseTransaction();
            return new CommonResponse(false, 11108, "No data found")
        }
    }

    async getDummyPackingReport(req?: DPReportRequest): Promise<CommonResponse> {
        try {
            const manager = getManager()

            let query = `SELECT DATE(rp.reporting_date) as reportingDate,rp.sale_order_item_id,
            soi.po_number as customerPO,rp.variant_id ,sc.variant_code as skuCode,st.product_category as productCategory,
            rp.pack_style_id,pm.packing_method_name as packingStyle,rp.shift as shift, uc.unit_name as unit, st.stock_type as soType,
             b.brand_name as brandName,rp.brand_id,
            SUM(IF(rp.pouches_shortage="YES" AND rp.cartons_shortage="YES",rp.reported_cases,0)) AS pouchShortage,
            SUM(IF(rp.pouches_shortage="NO" AND rp.cartons_shortage="YES",rp.reported_cases,0)) AS cartonShortage,
            SUM(IF(rp.pouches_shortage="NO" AND rp.cartons_shortage="NO",rp.reported_cases,0)) AS finalPacking,
            SUM(rp.reported_cases) AS totalPacking,rp.transaction_type as transactionType,
            ROUND(SUM(rp.reported_cases*pm.pouches_per_row*pm.no_of_pouches),0) AS cartonweight,
            ROUND(SUM(IF(pm.uom_id=1,rp.reported_cases*pm.pouches_per_row*pm.no_of_pouches*2.20462,IF(pm.uom_id=4,rp.reported_cases*pm.pouches_per_row*pm.no_of_pouches*0.00220462,IF(pm.uom_id=3,rp.reported_cases*pm.pouches_per_row*pm.no_of_pouches*0.0625,rp.reported_cases*pm.pouches_per_row*pm.no_of_pouches)))),0) AS weight,si.value_addition_four_id as valAddFour
            FROM ` + appSettings.warehouse_db + `.reporting rp
            LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soi ON soi.sale_order_id=rp.sale_order_id
            LEFT JOIN `+ appSettings.sales_db + `.sale_order_items si ON si.sale_order_item_id=rp.sale_order_item_id
            LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=rp.variant_id
            LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.stock_id=rp.stock_id
            LEFT JOIN `+ appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id=rp.pack_style_id
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id=rp.unit_id
            LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=rp.brand_id
            WHERE rp.sale_order_id > 0 `
            if (req.fromDate != undefined) {
                query = query + ' and date(rp.reporting_date) between "' + req.fromDate + '" and "' + req.toDate + '"';
            }
            if (req.masterBrandId) {
                query = query + ' and b.master_brand_id = ' + req.masterBrandId
            }
            if (req.skuCodeId) {
                query = query + ' and rp.variant_id = ' + req.skuCodeId
            }
            if (req.shift) {
                var quotedAndCommaSeparated = "'" + req.shift.join("','") + "'";
                query = query + ' and rp.shift IN (' + quotedAndCommaSeparated + ')';
            }
            if (req.stockType) {
                query = query + ' and st.stock_type = "' + req.stockType + '"';
            }
            if (req.unitId && req.unitId != 5) {
                query = query + ' and rp.unit_id = ' + req.unitId
            }
            if (req.foodTypeId) {
                query = query + ' and sc.food_type_id = ' + req.foodTypeId;
            }
            query = query + ' GROUP BY rp.sale_order_item_id order by `weight` DESC ';
            const data = await manager.query(query);
            if (data.length > 0) {
                const response = new CommonResponse(true, 1111, 'Data retrived successfully', data);
                return response;
            }
            else {
                return new CommonResponse(false, 1010, 'Data not found');
            }
        } catch (error) {
            return error;
        }
    }
    async getBrandDropForDummyPackingReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = ` SELECT rp.brand_id AS masterBrandId , b.brand_name AS masterBrandName , rp.unit_id FROM ` + appSettings.warehouse_db + `.reporting rp
        LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=rp.brand_id
        WHERE rp.brand_id> 0 `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and rp.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY rp.brand_id ORDER BY masterBrandName `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }
    async getVariantDropForDummyPackingReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT rp.variant_id AS skuCodeId , sc.variant_code AS variantCode , rp.unit_id FROM ` + appSettings.warehouse_db + `.reporting rp
        LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=rp.variant_id
        WHERE  rp.variant_id> 0 and sc.is_active = true `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and rp.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY rp.variant_id ORDER BY variantCode `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }


    async getVariantDropdown(req?: RackZoneLevelRequest): Promise<CommonResponse> {
        try {
            console.log(req.role, 'req')
            const manager = getManager();
            let variantDropQuery = "SELECT sk.sku_code_id As skuCodeId, CONCAT(p.code,ft.food_type_code,val1.code,val2.code,val3.code,val4.code,val5.code) AS varientCode,sk.soaking_style FROM " + appSettings.warehouse_db + ".stock st  LEFT JOIN " + appSettings.masters_db + ".uoms u ON u.uom_id=st.uom_id  LEFT JOIN " + appSettings.masters_db + ".sku_codes sk ON sk.sku_code_id=st.varient_id  LEFT JOIN " + appSettings.masters_db + ".products p ON p.product_id=sk.product_id LEFT JOIN " + appSettings.masters_db + ".`food_types` ft ON ft.food_type_id=sk.food_type_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_one_types` val1 ON val1.value_addition_one_id=sk.value_addition_one_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_two_types` val2 ON val2.value_addition_two_id=sk.value_addition_two_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_three_types` val3 ON val3.value_addition_three_id=sk.value_addition_three_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_four_types` val4 ON val4.value_addition_four_id=sk.value_addition_four_id LEFT JOIN " + appSettings.masters_db + ".`value_addition_five_types` val5 ON val5.value_addition_five_id=sk.value_addition_five_id LEFT JOIN " + appSettings.masters_db + ".`rack_position` rp ON rp.rack_position_id=st.location WHERE sk.sku_code_id is not null and st.status = 'StockIn' ";

            if (req.unitId) {
                variantDropQuery = variantDropQuery + ' and st.unit_id IN (' + req.unitId.toString() + ')';
            }

            if (req.stockType) {
                variantDropQuery = variantDropQuery + ' and st.stock_type = "' + req.stockType + '"';
            }

            variantDropQuery = variantDropQuery + " GROUP BY sk.product_id, sk.food_type_id, sk.value_addition_one_id, sk.value_addition_two_id, sk.value_addition_three_id, sk.value_addition_four_id,sk.value_addition_five_id ORDER BY varientCode";

            const variantCodes = await manager.query(variantDropQuery);
            if (variantCodes.length > 0) {
                const response = new CommonResponse(true, 11101, 'Data retrieved Successfully', variantCodes);
                return response;
            }
            else {
                throw new CommonResponse(false, 11101, 'Data not found', variantCodes);
            }
        }
        catch (err) {
            console.log(err);
            throw err;
        }
    }

    async getValueAdditionsFiltersData(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `select val1.code as code1,val1.name as name1,val1.value_addition_one_id as val1Id from  ` + appSettings.warehouse_db + `.reporting r  LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id=r.variant_id left join ` + appSettings.masters_db + `.value_addition_one_types val1 ON val1.value_addition_one_id=sk.value_addition_one_id GROUP BY sk.value_addition_one_id
            `
            const data = await manager.query(query);
            if (data.length > 0) {
                const response = new CommonResponse(true, 11101, 'Data retrieved Successfully', data);
                return response;
            }
            else {
                throw new CommonResponse(false, 11101, 'Data not found', data);
            }
        }
        catch (err) {
            console.log(err);
            throw err;
        }
    }

    async getValueAdditionsTwoFiltersData(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `select val2.code as code2,val2.name as name2,val2.value_addition_two_id as val2Id from  ` + appSettings.warehouse_db + `.reporting r  LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id=r.variant_id  LEFT JOIN ` + appSettings.masters_db + `.value_addition_two_types val2 ON val2.value_addition_two_id=sk.value_addition_two_id  GROUP BY sk.value_addition_two_id
            `
            const data = await manager.query(query);
            if (data.length > 0) {
                const response = new CommonResponse(true, 11101, 'Data retrieved Successfully', data);
                return response;
            }
            else {
                throw new CommonResponse(false, 11101, 'Data not found', data);
            }
        }
        catch (err) {
            console.log(err);
            throw err;
        }
    }

    async getValueAdditionsThreeFiltersData(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `select val3.code as code3,val3.name as name3,val3.value_addition_three_id as val3Id from  ` + appSettings.warehouse_db + `.reporting r LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id=r.variant_id left join ` + appSettings.masters_db + `.value_addition_three_types val3 ON val3.value_addition_three_id=sk.value_addition_three_id GROUP BY sk.value_addition_three_id
            `
            const data = await manager.query(query);
            if (data.length > 0) {
                const response = new CommonResponse(true, 11101, 'Data retrieved Successfully', data);
                return response;
            }
            else {
                throw new CommonResponse(false, 11101, 'Data not found', data);
            }
        }
        catch (err) {
            console.log(err);
            throw err;
        }
    }

    async getValueAdditionsfourFiltersData(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `select val4.code as code4,val4.name as name4,val4.value_addition_four_id as val4Id from  ` + appSettings.warehouse_db + `.reporting r  LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id=r.variant_id left join ` + appSettings.masters_db + `.value_addition_four_types val4 ON val4.value_addition_four_id=sk.value_addition_four_id GROUP BY sk.value_addition_four_id `
            const data = await manager.query(query);
            if (data.length > 0) {
                const response = new CommonResponse(true, 11101, 'Data retrieved Successfully', data);
                return response;
            }
            else {
                throw new CommonResponse(false, 11101, 'Data not found', data);
            }
        }
        catch (err) {
            console.log(err);
            throw err;
        }
    }

    async getValueAdditionsfiveFiltersData(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `select val5.code as code5,val5.name as name5, val5.value_addition_five_id as val5Id from  ` + appSettings.warehouse_db + `.reporting r LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id=r.variant_id left join ` + appSettings.masters_db + `.value_addition_five_types val5 ON val5.value_addition_five_id=sk.value_addition_five_id GROUP BY sk.value_addition_five_id`
            const data = await manager.query(query);
            if (data.length > 0) {
                const response = new CommonResponse(true, 11101, 'Data retrieved Successfully', data);
                return response;
            }
            else {
                throw new CommonResponse(false, 11101, 'Data not found', data);
            }
        }
        catch (err) {
            console.log(err);
            throw err;
        }
    }
    @Cron('0 */2 * * *')
    async updateWHAnalyticsDB(): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        const connection = getManager();
        try {
            //   await manager.startTransaction();

            // var mysql = require('mysql');
            // var con = mysql.createConnection({
            //   host: "167.71.230.198",
            //   user: "ramakrishna",
            //   password: "R@ms1905",
            // //   database: "erpx_dev_analytics"
            // });
            const queryResult = "SELECT Max(reporting_log_id) as maxId from " + appSettings.analytics_db + ".stock_in";
            const getMaxId = await connection.query(queryResult);
            // const getMaxId = con.query(queryResult, async function(err,result)
            // {
            let query;
            if (getMaxId[0].maxId != null) {
                query = `SELECT reporting_log_id as reportingLogId from ` + appSettings.warehouse_db + `.reporting r where r.reporting_log_id > ` + getMaxId[0].maxId;
            }
            else {
                query = `SELECT reporting_log_id as reportingLogId from ` + appSettings.warehouse_db + `.reporting r`;
                const stockInQuery = " TRUNCATE TABLE " + appSettings.analytics_db + ".stock_in";
                const truncatStatus = await connection.query(stockInQuery);
            }

            console.log(query);
            const reportingData = await connection.query(query);
            console.log(reportingData);
            let setStockInFlag = new Set<boolean>();
            for (const stock of reportingData) {
                let stockInQuery = "Select r.reporting_log_id AS reportingLogId,r.reporting_date AS reportingDate,r.sale_order_id AS saleOrderId,r.sale_order_item_id AS saleOrderItemId,r.reported_cases AS reportedCases,r.loose_pouches AS loosePouches,r.rack_postion AS rackPostion,r.reported_person AS reportedPerson,r.lot_code AS lotCode,r.shift AS shift,r.transaction_type AS transactionType,r.packing_completed AS packingCompleted,r.stock_id AS stockId,r.unit_id AS unitId,r.manual_reported AS manualReported,r.cold_storage_id AS coldStorageId,r.created_at AS createdAt,r.created_user AS createdUser,r.trace_code AS traceCode,r.remarks AS remarks,r.is_active AS isActive,r.variant_id AS variantId,r.brand_id AS brandId,r.pack_style_id AS packStyleId,r.pouches_shortage AS pouchesShortage,r.cartons_shortage AS cartonsShortage,r.stock_type AS stockType,rp.rack_code AS rackPositionCode,u.unit_name AS unitCode,zp.zone_code AS coldStorageCode,sk.variant_code AS variantCode,mb.brand_name AS brand,pm.no_of_pouches AS noOfPouches,pm.pouches_per_row AS pouchesPerRow,um.uom_name AS uom, sid.po_number AS poNumber from " + appSettings.warehouse_db + ".reporting r left join " + appSettings.sales_db + ".so_invoice_details sid on sid.sale_order_id = r.sale_order_id left join " + appSettings.masters_db + ".rack_position rp on rp.rack_position_id = r.rack_postion LEFT JOIN " + appSettings.masters_db + ".`unitcodes` u ON u.unit_code_id=r.unit_id LEFT JOIN " + appSettings.masters_db + ".`zone_master` zp ON zp.zone_id=r.cold_storage_id LEFT JOIN " + appSettings.masters_db + ".`sku_codes` AS sk ON sk.sku_code_id=r.variant_id LEFT JOIN " + appSettings.masters_db + ".`master_brands` AS mb ON mb.master_brand_id=r.brand_id left join " + appSettings.masters_db + ".packing_methods pm on pm.packing_method_id = r.pack_style_id left join " + appSettings.masters_db + ".uoms um on um.uom_id = pm.uom_id where r.reporting_log_id = " + stock.reportingLogId;
                let reportData = await connection.query(stockInQuery);
                console.log("stockInQuery" + reportData);
                const created_at = reportData[0].createdAt ? "'" + moment(reportData[0].createdAt).format('YYYY-MM-DD hh:mm:ss') + "'" : null
                let traceCode = reportData[0].traceCode != null ? reportData[0].traceCode : 0;

                const insertQuery = `Insert into ` + appSettings.analytics_db + `.stock_in(reporting_log_id,reporting_date,sale_order_id,sale_order_item_id,reported_cases,loose_pouches,rack_postion,reported_person,lot_code,shift,transaction_type,packing_completed,stock_id,unit_id,manual_reported,cold_storage_id,created_at,created_user,trace_code,remarks,is_active,variant_id,brand_id,pack_style_id,pouches_shortage,cartons_shortage,stock_type,rack_position_code,unit_code,cold_storage_code,t_code,variant_code,brand,no_of_pouches,pouches_per_row,uom,po_number)values(${reportData[0].reportingLogId},'${moment(reportData[0].reportingDate).format("YYYY-MM-DD HH:MM:SS")}',${reportData[0].saleOrderId},${reportData[0].saleOrderItemId},${reportData[0].reportedCases},${reportData[0].loosePouches},${reportData[0].rackPostion},'${reportData[0].reportedPerson}','${reportData[0].lotCode}','${reportData[0].shift}','${reportData[0].transactionType}','${reportData[0].packingCompleted}',${reportData[0].stockId},${reportData[0].unitId},${reportData[0].manualReported},${reportData[0].coldStorageId},${created_at},'${reportData[0].createdUser}','${traceCode}','${reportData[0].remarks}',${reportData[0].isActive},${reportData[0].variantId},${reportData[0].brandId},${reportData[0].packStyleId},'${reportData[0].pouchesShortage}','${reportData[0].cartonsShortage}','${reportData[0].stockType}','${reportData[0].rackPositionCode}','${reportData[0].unitCode}','${reportData[0].coldStorageCode}','${reportData[0].tCode}','${reportData[0].variantCode}',"${reportData[0].brand}",${reportData[0].noOfPouches},${reportData[0].pouchesPerRow},'${reportData[0].uom}','${reportData[0].poNumber}')`;
                const stockInInsertRes = await connection.query(insertQuery);
                console.log("stockInInsertRes" + stockInInsertRes.affectedRows);
                if (stockInInsertRes.affectedRows > 0) {
                    setStockInFlag.add(true)
                } else {
                    setStockInFlag.add(false)
                    break;
                }
            }
            if (!setStockInFlag.has(false)) {
                const stockOutQueryResult = "SELECT Max(fork_lift_item_id) as maxId from " + appSettings.analytics_db + ".stock_out";
                const getOutMaxId = await connection.query(stockOutQueryResult);
                // const getOutMaxId = con.query(stockOutQueryResult, async function(err,result)
                // {
                let query;
                if (getOutMaxId[0].maxId != null) {
                    query = `SELECT fork_lift_item_id as forkLiftItemId from ` + appSettings.warehouse_db + `.fork_lift_items fi where fi.fork_lift_item_id > ` + getOutMaxId[0].maxId;
                }
                else {
                    query = `SELECT fork_lift_item_id as forkLiftItemId from ` + appSettings.warehouse_db + `.fork_lift_items fi`;
                    const stockOutQuery = " TRUNCATE TABLE " + appSettings.analytics_db + ".stock_out";
                    const truncatStatus = await connection.query(stockOutQuery);
                }
                console.log(query);
                const stockOutData = await connection.query(query);
                console.log(stockOutData);
                let setStockOutFlag = new Set<boolean>();
                for (const stock of stockOutData) {
                    let stockOutQuery = "Select r.fork_lift_item_id AS forkLiftItemId,r.sale_order_id AS saleOrderId,r.sale_order_item_id AS saleOrderItemId,r.current_position AS currentPosition,r.target_position AS targetPosition,r.real_position AS realPosition,r.date AS date,r.sync_status AS syncStatus,r.created_at AS createdAt,r.created_user AS createdUser,r.fork_lift_job_id AS forkLiftJobId,r.job_cartons AS jobCartons,r.issued_quantity AS issuedQuantity,r.received_quantity AS receivedQuantity,r.unit_id AS unitId,r.stock_id AS stockId,fj.job_code AS jobCode,fj.status AS status,fj.job_purpose AS jobPurpose,fj.reported_id AS reportedId,fj.shortage_cartons AS shortageCartons,fj.damaged_cartons AS damagedCartons,fj.excess_quantity AS excessQuantity,fj.damaged_quantity AS damagedQuantity,fj.transfer_status AS transferStatus,fj.from_plant_id AS fromPlantId,fj.to_plant_id AS toPlantId,crp.rack_code AS currentPositionCode,trp.rack_code AS targetPositionCode,rrp.rack_code AS realPositionCode,u.unit_name AS unitCode,fu.unit_name AS fromPlantCode,tu.unit_name AS toPlantCode, IF(s.stock_type = null, 'SaleOrder', s.stock_type) AS stockType,sid.po_number AS poNumber, um.uom_name AS uom, pm.no_of_pouches AS noOfPouches, pm.pouches_per_row AS pouchesPerRow from " + appSettings.warehouse_db + ".fork_lift_items r left join " + appSettings.sales_db + ".so_invoice_details sid on sid.sale_order_id = r.sale_order_id left join " + appSettings.warehouse_db + ".stock s on s.stock_id = r.stock_id left join " + appSettings.warehouse_db + ".fork_lift_jobs fj on fj.job_id = r.fork_lift_job_id left join " + appSettings.masters_db + ".rack_position crp on crp.rack_position_id = r.current_position left join " + appSettings.masters_db + ".rack_position trp on trp.rack_position_id = r.target_position left join " + appSettings.masters_db + ".rack_position rrp on rrp.rack_position_id = r.real_position LEFT JOIN " + appSettings.masters_db + ".`unitcodes` u ON u.unit_code_id=r.unit_id LEFT JOIN " + appSettings.masters_db + ".`unitcodes` fu ON fu.unit_code_id=fj.from_plant_id  LEFT JOIN " + appSettings.masters_db + ".`unitcodes` tu ON tu.unit_code_id=fj.to_plant_id Left join "+appSettings.masters_db+".packing_methods pm on pm.packing_method_id = s.pack_style_id Left join "+appSettings.masters_db+".uoms um on um.uom_id = s.uom_id where r.fork_lift_item_id = " + stock.forkLiftItemId;
                    let reportData = await connection.query(stockOutQuery);
                    console.log("stockInQuery" + reportData[0].stockType);
                    console.log("stockInQuery" + reportData);
                    let created_at = moment(reportData[0].createdAt).format('YYYY-MM-DD HH:MM:SS')
                    let date = reportData[0].date != null ? moment(reportData[0].date).format('YYYY-MM-DD HH:MM:SS') : moment().format('YYYY-MM-DD HH:MM:SS');
                    const stockoutInsertQuery = `Insert into ` + appSettings.analytics_db + `.stock_out(fork_lift_item_id,sale_order_id,sale_order_item_id,current_position,target_position,real_position,date,sync_status,created_user,fork_lift_job_id,job_cartons,issued_quantity,received_quantity,unit_id,stock_id,job_code,status,job_purpose,reported_id,shortage_cartons,damaged_cartons,excess_quantity,damaged_quantity,transfer_status,from_plant_id,to_plant_id,current_position_code,target_position_code,real_position_code,unit_code,from_plant_code,to_plant_code,stock_type,po_number,uom,no_of_pouches,pouches_per_row)values(${reportData[0].forkLiftItemId},${reportData[0].saleOrderId},${reportData[0].saleOrderItemId},${reportData[0].currentPosition},${reportData[0].targetPosition},${reportData[0].realPosition},'${moment(reportData[0].date).format("YYYY-MM-DD HH:MM:SS")}',${reportData[0].syncStatus},'${reportData[0].createdUser}',${reportData[0].forkLiftJobId},${reportData[0].jobCartons},${reportData[0].issuedQuantity},${reportData[0].receivedQuantity},${reportData[0].unitId},${reportData[0].stockId},'${reportData[0].jobCode}','${reportData[0].status}','${reportData[0].jobPurpose}',${reportData[0].reportedId},${reportData[0].shortageCartons},${reportData[0].damagedCartons},${reportData[0].excessQuantity},${reportData[0].damagedQuantity},'${reportData[0].transferStatus}',${reportData[0].fromPlantId},${reportData[0].toPlantId},'${reportData[0].currentPositionCode}','${reportData[0].targetPositionCode}','${reportData[0].realPositionCode}','${reportData[0].unitCode}','${reportData[0].fromPlantCode}','${reportData[0].toPlantCode}','${reportData[0].stockType}','${reportData[0].poNumber}','${reportData[0].uom}','${reportData[0].noOfPouches}','${reportData[0].pouchesPerRow}')`;
                    const stockOutInsertRes = await connection.query(stockoutInsertQuery);
                    console.log("stockOutInsertRes" + stockOutInsertRes);

                    if (stockOutInsertRes.affectedRows > 0) {
                        setStockOutFlag.add(true)
                    } else {
                        setStockOutFlag.add(false)
                        break;
                    }

                }
                if (!setStockOutFlag.has(false)) {
                    const stockQuery = " TRUNCATE TABLE " + appSettings.analytics_db + ".stock";
                    const truncatStatus = await connection.query(stockQuery);
                    // const truncatStatus = con.query(stockQuery, async function(err,res)
                    // {
                    const stockDataQuery = "Select s.stock_id AS stockId , s.lot_no AS lotNo , s.soaking_time AS soakingTime , s.soaking_style AS soakingStyle , s.wh_incharge AS whIncharge ,  s.sale_order_id AS saleOrderId , s.sale_order_item_id AS saleOrderItemId , s.total_cartons AS totalCartons , s.total_pouches AS totalPouches , s.loose_pouches AS loosePouches , s.packing_completed AS packingCompleted , s.pouches_shortage AS pouchesShortage ,  s.cartons_shortage AS cartonsShortage ,  s.location AS location , s.zone_id AS zoneId , s.date AS date , s.stock_type AS stockType ,  s.status AS status ,  s.state AS state ,  s.product_category AS productCategory , s.brand_id AS brandId , s.product_id AS productId , s.unit_id AS unitId , s.varient_id AS varientId , s.min_grade AS minGrade , s.max_grade AS maxGrade , s.category_id AS categoryId , s.count AS count ,  s.pouches AS pouches , s.pallet_capacity AS palletCapacity , s.pouch_weight AS pouchWeight , s.net_weight AS netWeight ,  s.code AS code ,  s.created_at AS createdAt ,  s.created_user AS createdUser , s.stockout_qunatity AS stockoutQunatity ,  s.allocated_sale_order_id AS allocatedSaleOrderId ,  s.allocated_sale_orderitem__id AS allocatedSaleOrderitemId ,  s.stockin_qunatity AS stockinQunatity ,  s.shift AS shift , s.transaction_type AS transactiontype ,  s.stock_out_category AS stockOutCategory ,  s.uom_id AS uomId ,  s.trace_code AS traceCode ,  s.is_damaged AS isDamaged ,  s.remarks AS remarks , rp.rack_code AS rackPositionCode ,  zp.zone_code AS zoneCode ,  mb.brand_name AS brand ,  p.name AS product ,  uc.unit_name AS unitCode ,  sku.variant_code AS variantCode ,  isc.item_sub_category AS category ,  u.uom_name AS uomCode, sid.po_number AS poNumber,r.rack_status AS rackStatus from " + appSettings.warehouse_db + ".stock s left join " + appSettings.sales_db + ".so_invoice_details sid on sid.sale_order_id = s.sale_order_id left join " + appSettings.masters_db + ".rack_position rp on rp.rack_position_id = s.location left join " + appSettings.masters_db + ".rack r on r.rack_id = rp.rack_id left join " + appSettings.masters_db + ".zone_master zp on zp.zone_id = s.zone_id left join " + appSettings.masters_db + ".master_brands mb on mb.master_brand_id = s.brand_id left join " + appSettings.masters_db + ".products p on p.product_id = s.product_id left join " + appSettings.masters_db + ".unitcodes uc on uc.unit_code_id = s.unit_id left join " + appSettings.masters_db + ".uoms u on u.uom_id = s.uom_id left join " + appSettings.masters_db + ".sku_codes sku on sku.sku_code_id = s.varient_id left join " + appSettings.masters_db + ".item_sub_categories isc on isc.item_sub_category_id = s.category_id ";
                    console.log(stockDataQuery)
                    let stockData = await connection.query(stockDataQuery);
                    console.log("stockData" + stockData)
                    if (stockData.length > 0) {
                        let setStockFlag = new Set<boolean>();
                        for (const res of stockData) {
                            let date = moment(res.date).format('YYYY-MM-DD HH:MM:SS')
                            let createdAt = moment(res.created_at).format('YYYY-MM-DD HH:MM:SS')
                            let traceCode = res.traceCode != null ? res.traceCode : 0
                            const insertQuery = `Insert into ` + appSettings.analytics_db + `.stock (stock_id,lot_no,soaking_time,soaking_style,wh_incharge, sale_order_id,sale_order_item_id,total_cartons,total_pouches,loose_pouches,packing_completed,pouches_shortage, cartons_shortage, location,zone_id,date,stock_type, status, state, product_category,brand_id,product_id,unit_id,varient_id,min_grade,max_grade,category_id,count, pouches,pallet_capacity,pouch_weight,net_weight, code, created_user,stockout_qunatity, allocated_sale_order_id, allocated_sale_orderitem__id, stockin_qunatity, shift,transaction_type, stock_out_category, uom_id, trace_code, is_damaged, remarks,rack_position_code, zone_code, brand, product, unit_code, variant_code, category, uom_code,po_number,rack_type)values(${res.stockId},"${res.lotNo}","${res.soakingTime}","${res.soakingStyle}","${res.whIncharge}", ${res.saleOrderId},${res.saleOrderItemId},${res.totalCartons},${res.totalPouches},${res.loosePouches},"${res.packingCompleted}","${res.pouchesShortage}","${res.cartonsShortage}",${res.location},${res.zoneId},"${date}","${res.stockType}","${res.status}","${res.state}","${res.productCategory}",${res.brandId},${res.productId},${res.unitId},${res.varientId},${res.minGrade},${res.maxGrade},${res.categoryId},${res.count}, ${res.pouches},${res.palletCapacity},${res.pouchWeight},${res.netWeight}, ${res.code}, "${res.createdUser}",${res.stockoutQunatity}, ${res.allocatedSaleOrderId}, ${res.allocatedSaleOrderitemId}, ${res.stockinQunatity}, "${res.shift}","${res.transactiontype}", "${res.stockOutCategory}", ${res.uomId}, "${traceCode}", "${res.isDamaged}", "${res.remarks}","${res.rackPositionCode}", "${res.zoneCode}", "${res.brand}", "${res.product}", "${res.unitCode}", "${res.variantCode}", "${res.category}", "${res.uomCode}","${res.poNumber}",${res.rackStatus})`;
                            const stockinsertRes = await connection.query(insertQuery);
                            console.log("stockinsertRes" + stockinsertRes);
                            if (stockinsertRes.affectedRows > 0) {
                                setStockFlag.add(true)
                            } else {
                                setStockFlag.add(false)
                                break;
                            }

                        }
                        if (!setStockFlag.has(false)) {
                            return new CommonResponse(true, 1010, 'Dumped warehouse data successfully . ')
                        }
                        else {
                            // await manager.releaseTransaction()
                            return new CommonResponse(false, 1110, 'Stock insertion failed. ')
                        }
                    }
                    // })
                }
                else {
                    // await manager.releaseTransaction()
                    return new CommonResponse(false, 1110, 'Stock out update failed. ')
                }
                // })
            }
            else {
                // await manager.releaseTransaction()
                return new CommonResponse(false, 1110, 'Stock in update failed. ')
            }

            // })

        } catch (error) {
            // await manager.releaseTransaction();
            return error;
        }
    }


    async getFoodTypeFiltersData(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `select ft.food_type as foodType,ft.food_type_code as foodTypecode,ft.food_type_id as foodTypeId from  ` + appSettings.warehouse_db + `.reporting r LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id=r.variant_id left join ` + appSettings.masters_db + `.food_types ft ON ft.food_type_id=sk.food_type_id GROUP BY sk.food_type_id`
            const data = await manager.query(query);
            if (data.length > 0) {
                const response = new CommonResponse(true, 11101, 'Data retrieved Successfully', data);
                return response;
            }
            else {
                throw new CommonResponse(false, 11101, 'Data not found', data);
            }
        }
        catch (err) {
            console.log(err);
            throw err;
        }
    }
    @Cron('0 8 * * *')
    async getLifeCycleUsage() {
        try {
            const manager = getManager();
            let unitQuery = "SELECT unit_name AS unitName, unit_code_id AS unitId from " + appSettings.masters_db + ".unitcodes where plant_type = 'Plant' and is_active = true order by unit_name ASC";
            let deadStockBeyond30daysQuery = "SELECT 'Dummy Production Stock Not Moved Beyond 30days' AS lifeCycleStatus,u.unit_name AS unit, COUNT(DISTINCT s.sale_order_id) AS cnt,SUM(total_cartons) AS totalCartons, SUM(IF(um.uom_name = 'OZ' , (s.total_cartons * s.pouches * s.pouch_weight * 0.0625), IF(um.uom_name = 'KG' ,(s.total_cartons * s.pouches * s.pouch_weight), IF(um.uom_name = 'GM' ,(s.total_cartons * s.pouches * s.pouch_weight * 0.0022),(s.total_cartons * s.pouches * s.pouch_weight)))))AS totalQty FROM `erpx_dev_warehouse`.stock s LEFT JOIN `erpx_dev_masters`.uoms um ON um.uom_id = s.uom_id LEFT JOIN erpx_dev_masters.unitcodes u ON u.unit_code_id = s.unit_id WHERE s.stock_type = 'dummy' AND DATE(s.date) < DATE(NOW()) - INTERVAL 30 DAY AND s.status = 'StockIn' GROUP BY s.unit_id";
            let deadStockBeyond60daysQuery = "SELECT 'Dummy Production Stock Not Moved Beyond 60days' AS lifeCycleStatus,u.unit_name AS unit, COUNT(DISTINCT s.sale_order_id) AS cnt,SUM(total_cartons) AS totalCartons, SUM(IF(um.uom_name = 'OZ' , (s.total_cartons * s.pouches * s.pouch_weight * 0.0625),IF(um.uom_name = 'KG' ,(s.total_cartons * s.pouches * s.pouch_weight), IF(um.uom_name = 'GM' ,(s.total_cartons * s.pouches * s.pouch_weight * 0.0022),(s.total_cartons * s.pouches * s.pouch_weight)))))AS totalQty FROM `erpx_dev_warehouse`.stock s LEFT JOIN `erpx_dev_masters`.uoms um ON um.uom_id = s.uom_id LEFT JOIN erpx_dev_masters.unitcodes u ON u.unit_code_id = s.unit_id WHERE s.stock_type = 'dummy' AND DATE(s.date) < DATE(NOW()) - INTERVAL 60 DAY AND s.status = 'StockIn' GROUP BY s.unit_id";
            let stockMovedBeyondEtdQuery = "SELECT u.unit_name AS unit,SUM(s.total_cartons) AS totalCartons,COUNT(DISTINCT(s.sale_order_id)) AS poCount,SUM(IF(um.uom_name = 'OZ' , (s.total_cartons * s.pouches * s.pouch_weight * 0.0625), IF(um.uom_name = 'KG' ,(s.total_cartons * s.pouches * s.pouch_weight), IF(um.uom_name = 'GM' ,(s.total_cartons * s.pouches * s.pouch_weight * 0.0022),(s.total_cartons * s.pouches * s.pouch_weight)))))AS totalQty FROM " + appSettings.warehouse_db + ".`stock` s LEFT JOIN " + appSettings.sales_db + ".`sale_order_track` so ON so.sale_order_id = s.sale_order_id LEFT JOIN " + appSettings.sales_db + ".`so_invoice_details` soi ON soi.sale_order_id = s.sale_order_id LEFT JOIN " + appSettings.masters_db + ".`uoms` um ON um.uom_id = s.uom_id LEFT JOIN " + appSettings.masters_db + ".`unitcodes` u ON u.unit_code_id = soi.processing_unit WHERE s.status = 'StockIn' AND stock_type = 'SaleOrder' AND (DATE(so.dispatched_date) >= DATE(soi.act_edl_date) OR DATE(so.dispatched_date) IS NULL) GROUP BY soi.processing_unit";
            let stockMovedBeyondEtd = await manager.query(stockMovedBeyondEtdQuery);
            let deadStockBeyond60days = await manager.query(deadStockBeyond60daysQuery)
            let deadStockBeyond30days = await manager.query(deadStockBeyond30daysQuery)
            let units = await manager.query(unitQuery)
            let stockMovedBeyondEtdData = '';
            let deadStockBeyond60daysData = '';
            let deadStockBeyond30daysData = '';
            const time = moment().format("DD-MM-YYYY HH:mm")
            if (stockMovedBeyondEtd.length > 0) {
                for (const sd of stockMovedBeyondEtd) {
                    stockMovedBeyondEtdData += "\\n*Plant:* " + sd.unit + "\\n*SO's :* " + sd.poCount + "\\n*Cartons :* " + sd.totalCartons.toLocaleString(undefined, { maximumFractionDigits: 0 }) + "\\n*Quantity (IN LB's):* " + Math.round(sd.totalQty).toLocaleString(undefined, { maximumFractionDigits: 0 }) + "\\n";
                }
            }
            if (deadStockBeyond60days.length > 0) {
                for (const sd of deadStockBeyond60days) {
                    deadStockBeyond60daysData += "\\n*Plant:* " + sd.unit + "\\n*SO's :* " + sd.cnt + "\\n*Cartons :* " + sd.totalCartons.toLocaleString(undefined, { maximumFractionDigits: 0 }) + "\\n*Quantity (IN LB's):* " + Math.round(sd.totalQty).toLocaleString(undefined, { maximumFractionDigits: 0 }) + "\\n";
                }
            }
            if (deadStockBeyond30days.length > 0) {
                for (const sd of deadStockBeyond30days) {
                    deadStockBeyond30daysData += "\\n*Plant:* " + sd.unit + "\\n*SO's :* " + sd.cnt + "\\n*Cartons :* " + sd.totalCartons.toLocaleString(undefined, { maximumFractionDigits: 0 }) + "\\n*Quantity (IN LB's):* " + Math.round(sd.totalQty).toLocaleString(undefined, { maximumFractionDigits: 0 }) + "\\n";
                }
            }
            let messageStatus;
            const parameters = [
                { "type": "text", "text": time},
                { "type": "text", "text": stockMovedBeyondEtd.length > 0 ? stockMovedBeyondEtdData : 'No Data' },
                { "type": "text", "text": deadStockBeyond30days.length > 0 ? deadStockBeyond30daysData : 'No Data' },
                { "type": "text", "text": deadStockBeyond60days.length > 0 ? deadStockBeyond60daysData : "No Data" },]
                console.log("parameters");
                console.log(parameters);
            const contacts = whatsApp.contacts;
            let statusFlag =true
            for(const contact of contacts){
                const req = await new MessageParameters(contact, 'fg_wh_life_cycle_usage_report', parameters)
                messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                console.log(messageStatus);
                    if(messageStatus.status){
                        const whatsapplogDto = new WhatsAppLogDto(contact,'fg_wh_life_cycle_usage_report','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.warehouseModuleId)
                        await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                    }else{
                        statusFlag = false
                    }
            }

            // const message = await new BroadCastMessageRequest(23,
            //      time +
            //     " \n*Stock Against SO's Beyond ETD :*\n" + (stockMovedBeyondEtd.length > 0 ? stockMovedBeyondEtdData : 'No Data\n') +
            //     "\n*Dummy Stock Beyond 30 Days :*\n" + (deadStockBeyond30days.length > 0 ? deadStockBeyond30daysData : 'No Data\n') +
            //     "\n*Dummy Stock Beyond 60 Days :*\n" + (deadStockBeyond60days.length > 0 ? deadStockBeyond60daysData : 'No Data\n'),[whatsApp.UsageReport])
            // console.log(message);
            // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(message);


            if (messageStatus) {
                return new CommonResponse(true, 11108, "Message Sent Sucessfully", messageStatus)
            }else{
                statusFlag = false

            }
        } catch (error) {
            return new CommonResponse(false, 11108, "No data found")
        }
    }

    @Cron('0 8 * * *')
    async dummyAndFgStockWtsApp() {
        try {
            const manager = getManager();
            let unitQuery = "SELECT unit_name AS unitName, unit_code_id AS unitId from " + appSettings.masters_db + ".unitcodes where plant_type = 'Plant' and is_active = true order by unit_name ASC";
            let unitsData = await manager.query(unitQuery);
            let top3DummySkus: string[] = [];
            let top3DummySku

            
            for (const unit of unitsData) {
                let query = "Select unit_id AS unitId,COUNT(s.varient_id) AS cnt, sc.variant_code as varient,SUM(s.total_cartons) as totalCartons,  ROUND(SUM(IF(stock_type = 'dummy',(IF(um.uom_name = 'OZ' ,  (s.total_cartons * s.pouches * s.pouch_weight * 0.0625), IF(um.uom_name = 'KG' ,  (s.total_cartons * s.pouches * s.pouch_weight), IF(um.uom_name = 'GM' ,(s.total_cartons * s.pouches * s.pouch_weight * 0.0022), (s.total_cartons * s.pouches * s.pouch_weight))))),0))) AS dummytotalQty , u.unit_name as unit from " + appSettings.warehouse_db + ".stock s LEFT JOIN " + appSettings.masters_db + ".unitcodes u ON u.unit_code_id = s.unit_id LEFT JOIN `erpx_dev_masters`.`sku_codes` sc ON sc.sku_code_id = s.varient_id LEFT JOIN " + appSettings.masters_db + ".uoms um ON um.uom_id = s.uom_id  where unit_id = " + unit.unitId + " and stock_type = 'dummy' and status = 'stockIn' group by varient_id order by cnt desc limit 3"

                let data = await manager.query(query)
                let msg = "\\n*" + unit.unitName + "*\\n";
                if (data.length > 0) {
                    for (const pr of data) {
                        msg += "\\n*Product :* " + pr.varient + "\\n*Cartons:* " + pr.totalCartons + "\\n*Qty:* " + Math.round(pr.dummytotalQty).toLocaleString(undefined, { maximumFractionDigits: 0 }) + "\\n";
                    }
                    top3DummySku += msg
                }
                else {
                    top3DummySku += msg;
                    top3DummySku += "No Data \\n";
                }
            }
            let reportQuery = 'SELECT s.unit_id,u.unit_name AS unit , SUM(IF(s.stock_type = "SaleOrder",reported_cases,0)) AS saleOrderCartons,SUM(IF(s.stock_type = "dummy",reported_cases,0)) AS dummyCartons,SUM(IF(s.stock_type = "SuperDummy",reported_cases,0)) AS superDummyCartons,SUM(IF(s.stock_type = "SaleOrder",(IF(um.uom_name = "OZ" , (s.reported_cases * st.pouches * st.pouch_weight * 0.0625), IF(um.uom_name = "KG" ,(s.reported_cases * st.pouches * st.pouch_weight), IF(um.uom_name = "GM" ,(s.reported_cases * st.pouches * st.pouch_weight * 0.0022),(s.reported_cases * st.pouches * st.pouch_weight))))),0)) AS saleOrdertotalQty,SUM(IF(s.stock_type = "dummy",(IF(um.uom_name = "OZ" , (s.reported_cases * st.pouches * st.pouch_weight * 0.0625), IF(um.uom_name = "KG" ,(s.reported_cases * st.pouches * st.pouch_weight), IF(um.uom_name = "GM" ,(s.reported_cases * st.pouches * st.pouch_weight * 0.0022),(s.reported_cases * st.pouches * st.pouch_weight))))),0)) AS dummytotalQty,SUM(IF(s.stock_type = "superDummy",(IF(um.uom_name = "OZ" , (s.reported_cases * st.pouches * st.pouch_weight * 0.0625), IF(um.uom_name = "KG" ,(s.reported_cases * st.pouches * st.pouch_weight), IF(um.uom_name = "GM" ,(s.reported_cases * st.pouches * st.pouch_weight * 0.0022),(s.reported_cases * st.pouches * st.pouch_weight))))),0)) AS superDummytotalQty  FROM ' + appSettings.warehouse_db + '.`reporting` s LEFT JOIN ' + appSettings.warehouse_db + '.`stock` st ON st.stock_id = s.stock_id  LEFT JOIN ' + appSettings.masters_db + '.unitcodes u ON u.unit_code_id = s.unit_id LEFT JOIN ' + appSettings.masters_db + '.uoms um ON um.uom_id = st.uom_id  WHERE DATE(s.created_at) = DATE(NOW()) - 1 AND s.is_active = TRUE  GROUP BY s.unit_id'
            let reportData = await manager.query(reportQuery)
            let reportQueryData = '';
            const time = moment().subtract(1, 'day').format("DD-MMMM-YYYY HH:mm")
            const timetwo = moment().format("DD-MMMM-YYYY HH:mm")


            if (reportData.length > 0) {
                for (const fg of reportData) {
                    reportQueryData += "\\n*" + fg.unit + "*\\n*FG Cartons :* " + fg.saleOrderCartons + "\\n*FG Qty (IN LB's):* " + Math.round(fg.saleOrdertotalQty).toLocaleString(undefined, { maximumFractionDigits: 0 })  + "\\n*Dummy Cartons :* " + fg.dummyCartons + "\\n*Dummy Qty (IN LB's):* " + Math.round(fg.dummytotalQty).toLocaleString(undefined, { maximumFractionDigits: 0 })  + "\\n*Super Dummy Cartons :* " + fg.superDummyCartons + "\\n*Super Dummy Qty (IN LB's):* " + Math.round(fg.superDummytotalQty).toLocaleString(undefined, { maximumFractionDigits: 0 })  + "\\n";
                }
            }
            
            // let urlMsg = '👇click the below link for report :';
            // let reportUrl = appSettings.whatsapp_redirection_url + '/stock-report-warehouse';

            // const message = await new BroadCastMessageRequest(19,
            //     "\nFGStock Report Date :"+ time +
            //     "\n*Plant Wise Data*\n" + (reportData.length > 0 ? reportQueryData : 'No Data\n') +
            //     "\n*Top 3 Dummy Products :*\n" + (top3DummySkus.length > 0 ? top3DummySkus : 'No Data\n') +"\n*",[whatsApp.UsageReport])
            // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(message);
            // if (messageStatus.status) {
            //     return new CommonResponse(true, 11108, "Message Sent Sucessfully", messageStatus)
            // }


            let messageStatus;
            const parameters = [
                { "type": "text", "text": time},
                { "type": "text", "text": reportData.length > 0 ? reportQueryData : 'No Data' },
                { "type": "text", "text": top3DummySku.length > 0 ? top3DummySku : "No Data" },]
                console.log("parameters");
                console.log(parameters);
            const contacts = whatsApp.contacts;
            for(const contact of contacts){
                const req = await new MessageParameters(contact, 'fg_wh_dummy_stock_report', parameters)
                messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                console.log(messageStatus);
                if(messageStatus.status){
                    const whatsapplogDto = new WhatsAppLogDto(contact,'fg_wh_dummy_stock_report','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.warehouseModuleId)
                    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                }

            }

            if (messageStatus.status) {
                return new CommonResponse(true, 11108, "Message Sent Sucessfully", messageStatus)
            }
        } catch (error) {
            return new CommonResponse(false, 11108, "No data found")
        }
    }

    @Cron('0 8 * * *')
    async getColdstorageCapacityAlert():Promise<CommonResponse>{
        const manager = getManager();

        let query = ` SELECT uc.unit_name as unitName,zm.zone_name as zoneName, rp.plant_id,rp.zone_id,SUM(IF (rp.occupancy != "Not Occupied", 1, 0)) AS "occupied", 
            (SUM(IF (rp.occupancy != "Not Occupied", 1, 0))/COUNT(rp.rack_position_id))*100 AS occupiedPercentage,
            SUM(IF(rp.occupancy = "Not Occupied", 1, 0)) AS "not occupied", (SUM(IF (rp.occupancy = "Not Occupied", 1, 0))/COUNT(rp.rack_position_id))*100 AS NotoccupiedPercentage FROM `+ appSettings.masters_db + `.rack_position rp 
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = rp.plant_id 
            LEFT JOIN ` + appSettings.masters_db + `.zone_master zm ON zm.zone_id = rp.zone_id WHERE rp.is_active = TRUE `
            query = query + ` GROUP BY rp.zone_id, rp.plant_id `
            const zoneData =  await manager.query(query);
            const groupByPlant = zoneData.reduce((group,data) => {
                const {unitName} = data;
                group[unitName] = group[unitName] ?? [];
                group[unitName].push( data ? data : 'no data')
                return group;
            },{})
            const time = moment().format("DD-MMMM-YYYY HH:mm")
            
            const mes  = Object.keys(groupByPlant).length ?  (`Warehouse Occupancy - ${time} \\n` + Object.keys(groupByPlant).map((key) => {
                return `\\n*${key}:*\\n  ${groupByPlant[key].map((el) => {
                    let color;
                    color = Number(el.occupiedPercentage) > 90 ? ` 🔴 ` : Number(el.occupiedPercentage) > 75 ? ` 🟠` : ` 🟢`
                    return el.zoneName + ' - '+ "*" + Math.round(el.occupiedPercentage).toLocaleString(undefined, { maximumFractionDigits: 0 }) + " %" + color + "*\\n"} )}`
            })) : (`Warehouse Occupancy ${time} \\n\\n *No data found for all units*`  )
           
        // const message = await new BroadCastMessageRequest(36,mes,['7036784473'])
        // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(message);
        

        let messageStatus;
        const parameters = [
            { "type": "text", "text": time},
            { "type": "text", "text": mes.length > 0 ? mes : 'No Data' },]
            console.log("parameters");
            console.log(parameters);
        const contacts = whatsApp.contacts;
        const statusFlag =true;
        for(const contact of contacts){
            const req = await new MessageParameters(contact, 'fg_wh_capacity_alert', parameters)
            messageStatus = await this.wpService.sendMessageThroughFbApi(req);
            console.log(messageStatus);
            if(messageStatus.status){
                const whatsapplogDto = new WhatsAppLogDto(contact,'fg_wh_capacity_alert','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.warehouseModuleId)
                await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
            }

        }
        if (messageStatus.status) {
            return new CommonResponse(true, 11108, "Message Sent Sucessfully", messageStatus)
        }

        return new CommonResponse(false, 11108, "No data found")
    }
    async getDummyProducts(): Promise<CommonResponse> {
        const manager = getManager();
        let query = `SELECT unit_id,u.unit_name as unit ,SUM(IF(stock_type = "dummy",total_cartons,0)) AS dummyCartons FROM ` + appSettings.warehouse_db + `.stock s left join ` + appSettings.masters_db + `.unitcodes u on u.unit_code_id = s.unit_id  WHERE DATE(s.created_at) = DATE(NOW()) - 1 GROUP BY s.unit_id `
        let data = await manager.query(query)
        let reportData = '';
        const time = moment().format("DD-MMMM-YYYY HH:mm")
        if (data.length > 0) {
            for (const dp of data) {
                reportData += "\n*" + dp.unit + "*\n*Cartons :* " + dp.dummyCartons + "\n";
            }
        }
        const message = await new MessageRequest('917036784473',
            "Dummy Products :" + time,
            "\n*Plant Wise Data*\n" + (data.length > 0 ? reportData : 'No Data\n'), "ERPX")
        var messageStatus = await this.wpService.sendPersonalMessage(message);

        if (messageStatus.status) {
            return new CommonResponse(true, 11108, "Message Sent Sucessfully", messageStatus)
        } else {
            return new CommonResponse(false, 11108, "No data found")
        }
    }

async getDummyStock(req:PlantIdRequest):Promise<CommonResponse> {
        try{
            const manager = getManager();
            let query = `select if(soi.sale_order_id != null , 1, 0) AS flag,GROUP_CONCAT(DISTINCT(s.stock_id) SEPARATOR ',') AS stockIds,soi.sale_order_id AS isSOExist,sk.sku_code_id AS variantId,sk.variant_code AS productSku, SUM(s.total_cartons) AS cartons,pm.packing_method_name AS packStyle,Round(SUM(IF(um.uom_name = 'KG' , (pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*2.204), IF(um.uom_name = 'oz',(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*0.0625), IF(um.uom_name = 'LB',(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons), IF(um.uom_name = 'gm',(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*0.0022),(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons)))))),0)  AS availableQty, um.uom_name AS uom, (SELECT MAX(soi.sale_order_id) FROM erpx_dev_sales.sale_order_items soi LEFT JOIN `+appSettings.sales_db+`.so_invoice_details sid ON sid.sale_order_id = soi.sale_order_id LEFT JOIN erpx_dev_sales.sale_order so ON so.sale_order_id = soi.sale_order_id WHERE soi.job_cases > soi.reported_cases and soi.job_cases > 0 AND so.status IN ('OPEN','INPROGRESS') AND so_process_type = 'MTO'  AND sid.processing_unit =`+req.plantId+`) AS reprocessSoId from `+appSettings.warehouse_db+`.stock s left join `+appSettings.masters_db+`.sku_codes sk on sk.sku_code_id = s.varient_id LEFT JOIN `+appSettings.masters_db+`.packing_methods pm ON pm.packing_method_id = s.pack_style_id LEFT JOIN `+appSettings.masters_db+`.uoms um ON um.uom_id = pm.uom_id LEFT JOIN erpx_dev_sales.sale_order_items soi ON soi.varient_id = s.varient_id AND soi.sale_order_id = (SELECT MAX(soi.sale_order_id) FROM erpx_dev_sales.sale_order_items soi LEFT JOIN `+appSettings.sales_db+`.so_invoice_details sid ON sid.sale_order_id = soi.sale_order_id LEFT JOIN erpx_dev_sales.sale_order so ON so.sale_order_id = soi.sale_order_id WHERE soi.job_cases > soi.reported_cases and soi.job_cases > 0 and soi.varient_id = s.varient_id AND so.status IN ('OPEN','INPROGRESS') AND so_process_type = 'MTO'  AND sid.processing_unit =`+req.plantId+`) where stock_type = 'dummy' and s.status = 'StockIn' and product_category IN ('g1','g2','rj') and state = 'Stock'`;
            if(req.plantId != 5){
                query = query + `and s.unit_id = `+req.plantId;
            } 
            query = query +` group by s.varient_id order by if(soi.sale_order_id >0 , 1, 0) desc,Round(SUM(IF(um.uom_name = 'KG' , (pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*2.204), IF(um.uom_name = 'oz',(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*0.0625), IF(um.uom_name = 'LB',(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons), IF(um.uom_name = 'gm',(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*0.0022),(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons)))))),0) desc, sk.variant_code,pm.packing_method_name ASC`;
            let queryResult = await manager.query(query);
            if (queryResult.length > 0) {
                return new CommonResponse(true, 1001, "Stock data retrieved successfully", queryResult);
            }
            else {
                return new CommonResponse(false, 11108, "No data found");
            }
        } catch (error) {
            return new CommonResponse(false, 11108, "No data found");
        }
    }
    async getAllocatedStock(req:PlantIdRequest):Promise<CommonResponse> {
        try{
            const manager = getManager();
            let getAllocatedStockDetails = "Select s.stock_id AS stockId,if(s.state = 'Allocated For Repacking', 'Repacking', if(s.state = 'Allocated For Reprocessing','ReProcessing','')) AS process,Round(IF(um.uom_name = 'KG' , (pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*2.204), IF(um.uom_name = 'oz',(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*0.0625), IF(um.uom_name = 'LB',(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons), IF(um.uom_name = 'gm',(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*0.0022),(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons))))),0) AS qty, soi.po_number AS poNumber,soii.po_number AS allocatedSO,total_cartons AS totalCartons, pm.packing_method_name AS packStyle,rp.rack_code AS location,sc.variant_code AS productSKU, si.hl_per AS hlPer,si.final_percentage AS finalPercentage,si.min_grade_id AS minGrade, si.max_grade_id AS maxGrade,SUM(s.pouches) AS pouches, SUM(total_cartons) AS cases,si.shrimp_weight AS shrimpWeight,si.uom_id AS uomId from "+appSettings.warehouse_db+".stock s LEFT JOIN "+appSettings.sales_db+".sale_order_items si on si.sale_order_item_id = s.allocated_sale_orderitem__id LEFT JOIN "+appSettings.sales_db+".so_invoice_details soi on soi.sale_order_id = s.sale_order_id LEFT join "+appSettings.sales_db+".so_invoice_details soii on soii.sale_order_id = s.allocated_sale_order_id LEFT JOIN "+appSettings.masters_db+".sku_codes sc on sc.sku_code_id = s.varient_id LEFT JOIN "+appSettings.masters_db+".packing_methods pm on pm.packing_method_id = s.pack_style_id LEFT JOIN "+appSettings.masters_db+".rack_position rp on rp.rack_position_id = s.location LEFT JOIN "+appSettings.masters_db+".uoms um ON um.uom_id = pm.uom_id where s.state IN ('Allocated For Repacking','Allocated For Reprocessing') and stock_type='dummy'";
            if(req.plantId != 5){
                getAllocatedStockDetails = getAllocatedStockDetails + " and s.unit_id ="+req.plantId;
            }
            getAllocatedStockDetails = getAllocatedStockDetails + " group by s.stock_id";
            let queryResult = await manager.query(getAllocatedStockDetails);
            if(queryResult.length>0){
                return new CommonResponse(true,1001,"Allocated stock retrived successfully. ",queryResult);
            }
            else{
                return new CommonResponse(false, 11108, "No data found");
            }
        }
        catch (error) {
            return new CommonResponse(false, 11108, "No data found",error);
        }
    }
    async getSaleOrderToAssignReprocessing(req:AssignRepackingRequest):Promise<CommonResponse>{
        try{
            const manager = getManager();
            let query = 'SELECT si.sale_order_id AS saleOrderId,si.item_id AS productId,si.master_brand_id AS brand, si.final_percentage AS finalPercetage,soi.act_edl_date AS etd, soi.sale_order_id AS saleOrderId, si.min_grade_id AS minGrade, si.max_grade_id AS maxGrade, si.sale_order_item_id AS saleOrderItemId,si.hl_per AS hlPer,si.final_percentage AS finalPercentage,si.varient_id AS varientId, sk.variant_code AS productSku, soi.po_number AS poNumber, pm.packing_method_name AS packStyle, u.uom_name AS uom,job_cases AS cases, Round((job_cases*pm.no_of_pouches*pm.pouches_per_row),2) AS requiredQty,Round((reported_cases*pm.no_of_pouches*pm.pouches_per_row),2) AS productionQty,SUM(psm.no_of_pouches*psm.pouches_per_row*s.total_cartons) AS allocatedQty, Round((IF((job_cases*pm.no_of_pouches*pm.pouches_per_row) >0,(job_cases*pm.no_of_pouches*pm.pouches_per_row),0) - IF((reported_cases*pm.no_of_pouches*pm.pouches_per_row) >0 ,(reported_cases*pm.no_of_pouches*pm.pouches_per_row), 0) -IF(SUM(s.total_cartons)>0,SUM(psm.no_of_pouches*psm.pouches_per_row*s.total_cartons),0)),2) AS balanceReq, 0 AS availableQty, null AS stockIds, u.uom_id AS uomId, mb.brand_name AS brand FROM '+appSettings.sales_db+'.`sale_order_items` si LEFT JOIN '+appSettings.masters_db+'.`packing_methods` pm ON pm.packing_method_id = si.pack_style_id LEFT JOIN '+appSettings.masters_db+'.master_brands mb on mb.master_brand_id = si.master_brand_id LEFT JOIN '+appSettings.masters_db+'.uoms u on u.uom_id = pm.uom_id LEFT JOIN '+appSettings.masters_db+'.`sku_codes` sk ON sk.sku_code_id = si.varient_id LEFT JOIN '+appSettings.sales_db+'.`sale_order` so ON so.sale_order_id = si.sale_order_id LEFT JOIN '+appSettings.sales_db+'.`so_invoice_details` soi ON soi.sale_order_id = so.sale_order_id LEFT JOIN '+appSettings.warehouse_db+'.stock s on s.allocated_sale_orderitem__id = si.sale_order_item_id  and s.state = "Allocated For Reprocessing" LEFT JOIN '+appSettings.masters_db+'.`packing_methods` psm ON psm.packing_method_id = s.pack_style_id WHERE si.job_cases  > si.reported_cases AND so.status IN ("Open","INPROGRESS") AND so.so_process_type = "MTO" and soi.processing_unit = '+ req.plantId + ' and si.job_cases > 0 GROUP BY si.sale_order_item_id order by soi.po_number ASC';
            let queryResult = await manager.query(query);
            console.log(queryResult);
            console.log(queryResult.length);

            
            for(const res of queryResult){
                console.log(res);
                console.log(req);
                // let reprocessingQty = await this.getReProcessingStock({product:res.productId,brand:res.brand,minGrade:res.minGrade,maxGrade:res.maxGrade,finalPercentage:res.finalPercentage,requiredRmQty:res.requiredRmQty,variantId:Array(res.varientId)});
                // console.log("reprocessingQty");
                // console.log(reprocessingQty.data);
                let stockIdsQuery = 'Select s.date,stock_id AS stockId,ROUND(SUM(IF(um.uom_name = "KG" , (pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*2.204), IF(um.uom_name = "oz",(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*0.0625), IF(um.uom_name = "LB",(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons),IF(um.uom_name = "gm",(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*0.0022),(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons)))))),2) AS qty from '+appSettings.warehouse_db+'.stock s left join '+appSettings.masters_db+'.packing_methods pm on pm.packing_method_id = s.pack_style_id LEFT JOIN erpx_dev_masters.uoms um ON um.uom_id = pm.uom_id where stock_id IN ('+req.stockIds+') GROUP BY s.location order by s.date ASC';
            let stockIdsQueryResult = await manager.query(stockIdsQuery);
            console.log("stockIdsQueryResult")
            console.log(stockIdsQueryResult)
            let stockIds:Number[] = [];
            let quantity:number  = 0;
            for(const ress of stockIdsQueryResult){
                console.log(Number(res.balanceReq));
                console.log(res.uom);
                console.log("Before");
                console.log(quantity);
                if(Number(quantity) < Number(res.balanceReq)){
                    if(res.uom === "LB"){
                        let val = Number(ress.qty).toFixed(2);
                        quantity =  Number(quantity)+Number(val);
                    }
                    else if(res.uom === "OZ"){
                        let val = (Number(ress.qty)*16).toFixed(2);
                        quantity =  Number(quantity)+Number(val);
                    }
                    else if(res.uom === "KG"){
                        let val = Number((ress.qty)*0.454).toFixed(2)
                        quantity =  Number(quantity)+Number(val);
                    }
                    else if(res.uom === "GM"){
                        let val = (Number(ress.qty)*453.6).toFixed(2)
                        quantity =  Number(quantity)+Number(val);
                        }
                    stockIds.push(ress.stockId);
                    res.availableQty = Number(quantity);
                }
                else if(quantity > res.balanceReq){
                    res.availableQty = Number(quantity);
                    break
                }
                console.log("After");
                console.log(quantity)
            }
                
                res.stockIds = req.stockIds;
            }
            if(queryResult.length > 0 && queryResult[0].poNumber != null){
                return new CommonResponse(true, 1001, "Sale Orders retrieved successfully", queryResult);
            }
            else{
                return new CommonResponse(false, 11108, "No data found");
            }
        }catch (error) {
            return new CommonResponse(false, 11108, "No data found");
        }
    }
    async getSaleOrderToAssignRepacking(req:AssignRepackingRequest):Promise<CommonResponse>{
        try{
            const manager = getManager();
            let query = 'SELECT si.category AS category,mb.brand_name AS brand,soi.act_edl_date AS etd, so.sale_order_id AS saleOrderId, si.min_grade_id AS minGrade, si.max_grade_id AS maxGrade, si.sale_order_item_id AS saleOrderItemId,si.hl_per AS hlPer,si.final_percentage AS finalPercentage, sk.variant_code AS productSku, soi.po_number AS poNumber, pm.packing_method_name AS packStyle, u.uom_id AS uomId,u.uom_name AS uom,job_cases AS jobCases, Round((job_cases*pm.no_of_pouches*pm.pouches_per_row),2) AS requiredQty,Round((reported_cases*pm.no_of_pouches*pm.pouches_per_row),2) AS productionQty,SUM(s.total_cartons) AS allocatedQty, Round((IF((job_cases*pm.no_of_pouches*pm.pouches_per_row) >0,(job_cases*pm.no_of_pouches*pm.pouches_per_row),0) - IF((reported_cases*pm.no_of_pouches*pm.pouches_per_row) >0 ,(reported_cases*pm.no_of_pouches*pm.pouches_per_row), 0) -IF(SUM(s.total_cartons)>0,SUM(s.total_cartons),0)),2) AS balanceReq, 0 AS availableQty,0 AS pouches, 0 AS cases, null AS stockIds,si.shrimp_weight AS shrimpWeight FROM '+appSettings.sales_db+'.`sale_order_items` si LEFT JOIN '+appSettings.masters_db+'.master_brands mb on mb.master_brand_id = si.master_brand_id LEFT JOIN '+appSettings.masters_db+'.`packing_methods` pm ON pm.packing_method_id = si.pack_style_id LEFT JOIN '+appSettings.masters_db+'.uoms u on u.uom_id = pm.uom_id LEFT JOIN '+appSettings.masters_db+'.`sku_codes` sk ON sk.sku_code_id = si.varient_id LEFT JOIN '+appSettings.sales_db+'.`sale_order` so ON so.sale_order_id = si.sale_order_id LEFT JOIN '+appSettings.sales_db+'.`so_invoice_details` soi ON soi.sale_order_id = so.sale_order_id LEFT JOIN '+appSettings.warehouse_db+'.stock s on s.allocated_sale_orderitem__id = si.sale_order_item_id  and s.state = "Allocated For Repacking" WHERE si.job_cases  > si.reported_cases and si.varient_id = '+req.varientId+' AND so.status IN ("Open","INPROGRESS") AND so.so_process_type = "MTO" and soi.processing_unit = '+ req.plantId + ' and si.job_cases > 0 group by si.sale_order_item_id order by soi.po_number ASC';
            let queryResult = await manager.query(query);
            console.log(queryResult);
            console.log(queryResult.length);
            for(const res of queryResult){
                console.log(res);
                console.log(req);
                let stockIdsQuery = 'Select s.date,stock_id AS stockId,ROUND(SUM(IF(um.uom_name = "KG" , (pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*2.204), IF(um.uom_name = "oz",(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*0.0625), IF(um.uom_name = "LB",(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons),IF(um.uom_name = "gm",(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons*0.0022),(pm.pouches_per_row*pm.no_of_pouches*s.total_cartons)))))),2) AS qty, SUM(pm.no_of_pouches) AS totalPouches, SUM(s.total_cartons) AS totalCases from '+appSettings.warehouse_db+'.stock s left join '+appSettings.masters_db+'.packing_methods pm on pm.packing_method_id = s.pack_style_id LEFT JOIN erpx_dev_masters.uoms um ON um.uom_id = pm.uom_id where stock_id IN ('+req.stockIds+') GROUP BY s.location order by s.date ASC';
            let stockIdsQueryResult = await manager.query(stockIdsQuery);
            console.log("stockIdsQueryResult")
            console.log(stockIdsQueryResult)
            let stockIds:Number[] = [];
            let quantity:number  = 0;
            let pouchCount:number  = 0;
            let casesCount:number  = 0;


            for(const ress of stockIdsQueryResult){
                console.log(ress.totalPouches)
                console.log(Number(res.balanceReq));
                console.log(res.uom);
                console.log("Before");
                console.log(quantity);
                console.log(pouchCount);
                console.log(casesCount);


                if(Number(quantity) < Number(res.balanceReq)){
                    if(res.uom === "LB"){
                        let val = Number(ress.qty).toFixed(2);
                        quantity =  Number(quantity)+Number(val);
                    }
                    else if(res.uom === "OZ"){
                        let val = (Number(ress.qty)*16).toFixed(2);
                        quantity =  Number(quantity)+Number(val);
                    }
                    else if(res.uom === "KG"){
                        let val = Number((ress.qty)*0.454).toFixed(2)
                        quantity =  Number(quantity)+Number(val);
                    }
                    else if(res.uom === "GM"){
                        let val = (Number(ress.qty)*453.6).toFixed(2)
                        quantity =  Number(quantity)+Number(val);
                        }
                    stockIds.push(ress.stockId);
                    res.availableQty = Number(quantity);
                }
                else if(quantity > res.balanceReq){
                    res.availableQty = Number(quantity);
                    break
                }
                let pouch = Number(ress.totalPouches).toFixed(2);
                pouchCount = Number(pouchCount) +Number(pouch);
                res.pouches = Number(pouchCount);

                let cases = Number(ress.totalCases).toFixed(2);
                casesCount = Number(casesCount) +Number(cases);
                res.cases = Number(casesCount);

                console.log("After");
                console.log(quantity)
                console.log(pouchCount);
                console.log(casesCount);


            }
                
                res.stockIds = stockIds;
            }
            if(queryResult.length > 0 && queryResult[0].poNumber != null){
                console.log(" ************************************************************************************************");
                console.log(queryResult);

                return new CommonResponse(true, 1001, "Sale Orders retrieved successfully", queryResult);
            }
            else {
                return new CommonResponse(false, 11108, "No data found");
            }
        } catch (error) {
            return new CommonResponse(false, 11108, "No data found");
        }
    }
    async generatePickList(req: SaleOrderIdRequest): Promise<CommonResponse> {
        try {
            let concatStr = ''
            if (req.stockOutType == StockTypesEnum.RE_PACK) {
                concatStr = ' and s.state in ("' + FgStockStates.AllocatedForRepacking + '","' + FgStockStates.PartiallyAssignedForRepacking + '")'
            } else if (req.stockOutType == StockTypesEnum.RE_PROCESS) {
                concatStr = ' and s.state in ("' + FgStockStates.AllocatedForReprocessing + '","' + FgStockStates.PartiallyAssignedForReprocessing + '")'
            }
            else {
                concatStr = ' and s.state="' + FgStockStates.Stock + '"'
            }
            const manager = getManager();
            let query = `SELECT wr.reporting_log_id AS reportingLogId, s.sale_order_item_id AS saleOrderItemId,location AS rackPositionId,inv.po_number AS poNumber,so.sale_order_id as saleOrderId,so.sale_order_no AS saleOrderNumber,s.stock_id AS stockId,s.lot_no AS lotNo,s.total_cartons AS totalCartons,s.unit_id AS unitId,s.packing_completed AS packingCompleted,z.zone_name AS coldStorage,r.rack_code AS rackPosition,s.location AS stockLocationId,wr.pallet_code AS palletCode,b.brand_name AS brandName,p.name AS productName, sc.variant_code AS variantCode,s.min_grade AS minGrade,s.max_grade AS maxGrade,concat(s.min_grade,'-',s.max_grade) as grade,s.state AS stockState,soi.pouches,soi.pouch_weight as pouchWeight, soi.soaking_style AS soakingStyle, soi.soaking_time AS soakingTime, s.total_cartons AS stockOutQty,pm.packing_method_name  as packStyle,s.stock_type as stockType,s.pouches_shortage AS pouchesShortage,s.cartons_shortage AS cartonsShortage,s.product_category as productCategory,uc.unit_name as unitName, pm.packing_method_name AS packStyle FROM ` + warehouseStockTable + ` s LEFT JOIN ` + salesInvTable + ` inv ON inv.sale_order_id=s.sale_order_id 
            LEFT JOIN `+ salesSoTable + ` so ON so.sale_order_id=s.sale_order_id 
            LEFT JOIN `+ salesSoItemTable + ` soi ON soi.sale_order_item_id=s.sale_order_item_id 
            LEFT JOIN `+ coldStorageTable + ` z ON z.zone_id=s.zone_id
            LEFT JOIN `+ rackPositionTable + ` r ON r.rack_position_id=s.location
            LEFT JOIN `+ appSettings.warehouse_db + `.reporting wr ON wr.stock_id=s.stock_id and wr.reporting_log_id = (select Max(reporting_log_id) AS reportingLogId from ` + appSettings.warehouse_db + `.reporting wr where wr.stock_id = s.stock_id)
            LEFT JOIN `+ appSettings.masters_db + `.master_brands b ON b.master_brand_id=s.brand_id
            LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id=s.product_id
            LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=s.varient_id
            LEFT JOIN `+ appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id = s.pack_style_id
            LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = s.unit_id
            where s.status='StockIn' and s.sale_order_id=`+ req.saleOrderId + ` and s.location>0` + concatStr;
             if (req.plantId != 5) {
                query = query + ' and s.unit_id = ' + req.plantId;
            }
            const rawData = await manager.query(query);
            console.log(rawData);
            console.log(rawData.length);

            if (rawData.length > 0) {
                let forkLiftItemDto: ForkLiftItemsDTO[] = [];
                let totJobCartons;
                for (const res of rawData) {
                    console.log(res);
                    totJobCartons = Number(totJobCartons) + Number(res.totalCartons);
                    let data = new ForkLiftItemsDTO(res.saleOrderId, res.saleOrderItemId, res.palletCode, res.rackPositionId, res.rackPositionId, null, null, res.createdUser, null, undefined, "", "", "", "", "", "", "", "", "", 0, 0, "", 0, 0, res.totalCartons, res.unitId, res.stockId)
                    forkLiftItemDto.push(data);
                }
                console.log(forkLiftItemDto)
                let forkLiftDto = new ForkLiftJobDTO(null, null, null, ForkLiftJobStatus.Open, rawData[0].reportingLogId, TransactionType.dispatch, forkLiftItemDto, rawData[0].createdUser, rawData[0].unitId, rawData[0].lotCode, null, totJobCartons, 0, 0, 0, 0, null, null, TransactionType.dispatch);
                console.log(forkLiftDto);
                let updateForkLiftJob = await this.forkLiftJobService.createForkLiftJob(forkLiftDto);
                if (updateForkLiftJob.status) {
                    return new CommonResponse(true, 1001, "Pick List generated successfully. ",);
                }
                else {
                    return new CommonResponse(false, 1010, "Something went wrong. ",);
                }
            }
            else {
                console.log("hi")
                return new CommonResponse(false, 1010, "No data found. ",);
            }
        } catch (error) {
            console.log(error)
            return new CommonResponse(false, 11108, "No data found");
        }
    }
    async getAssignSuperDummyToRepack(req: AssignSuperDummyRepackingRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let allocateRepack = await this.stockRepository.update({ stockId: Raw(alias => `stock_id IN (${req.stockIds})`) }, { state:FgStockStates.AllocatedForRepacking, allocatedSaleOrderId:req.allocatedSaleOrderId, allocatedSaleOrderItemId:req.allocatedSaleOrderItemId});
            if(allocateRepack.affected >0){
                return new CommonResponse(true, 1001, "Assigned Repacking successfully. ", allocateRepack);
            }
            else {
                return new CommonResponse(false, 1010, "Something went wrong. ", allocateRepack);
            }
        } catch (error) {
            return new CommonResponse(false, 11108, "No data found");
        }
    }
    async getSuperDummyStock(req: UnitRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let superDummyStock = "Select group_Concat(s.stock_id) AS stockIds,sid.po_number AS poNumber,sk.variant_code AS variantCode,pm.packing_method_name AS packStyle, SUM(s.total_cartons) AS cartons, s.sale_order_id AS allocatedSaleOrderId, s.sale_order_item_id AS allocatedSaleOrderItemId from " + appSettings.warehouse_db + ".stock s left join " + appSettings.sales_db + ".so_invoice_details sid on sid.sale_order_id = s.sale_order_id left join " + appSettings.sales_db + ".sale_order_items si on si.sale_order_item_id = s.sale_order_item_id left join " + appSettings.masters_db + ".sku_codes sk on sk.sku_code_id = s.varient_id left join " + appSettings.masters_db + ".packing_methods pm on pm.packing_method_id = s.pack_style_id WHERE s.unit_id = " + req.unitId + " AND s.stock_type = 'superDummy' AND s.state = 'stock' AND s.STATUS = 'stockIn' group by s.sale_order_id , s.sale_order_item_id";
            let queryResult = await manager.query(superDummyStock);
            console.log(queryResult)
            if (queryResult.length > 0 && queryResult[0].poNumber != null) {
                return new CommonResponse(true, 1001, "Super Dummy stock retrieved successfully", queryResult);
            }
            else {
                return new CommonResponse(false, 11108, "No data found");
            }
        } catch (error) {
            return new CommonResponse(false, 11108, "No data found");
        }
    }

    async getStockInReverseReportdata(req?: StockInReverseReq): Promise<CommonResponse> {
        try {
            const manager = getManager()
            let query = `SELECT r.reporting_log_id as reportingLogId,DATE(r.created_at) as createdAt, DATE(r.reporting_date) as reportingDate,r.reported_cases as reportingCases,r.rack_postion as rackPosition,r.loose_pouches as loosePouches,rp.rack_code as rackcode,r.lot_code as lotCode,r.shift as shift,r.transaction_type as transactionType,r.packing_completed as packingCompleted,r.pouches_shortage as pouchShortage,r.cartons_shortage as cartonShortage,r.sale_order_id as saleOrderId , si.po_number as poNumber,rp.rack_code as rackCode,sc.variant_code as variantCode,pm.packing_method_name as packStyle,br.brand_name as brandName,r.stock_type as stockType,uc.unit_name as unitName,r.unit_id as unitId,st.product_category as productCategory,st.wh_incharge as whIncharge,uc.unit_name as unit 
            FROM ` + appSettings.warehouse_db + `.reporting r
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id=r.sale_order_id
            LEFT JOIN ` + appSettings.masters_db + `.master_brands br ON br.master_brand_id=r.brand_id
            LEFT JOIN ` + appSettings.masters_db + `.rack_position rp ON rp.rack_position_id=r.rack_postion
            LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON  sc.sku_code_id = r.variant_id
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = r.unit_id
            LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.stock_id = r.stock_id
            LEFT JOIN ` + appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id=r.pack_style_id where r.reporting_log_id > 0  and r.is_active = false `
            // if (req.plantId != 5 && req.role != "ADMIN") {
            //     query = query + ' and r.unit_id = ' + req.plantId;
            // }
            if (req.plantId && req.plantId != 5) {
                query = query + ` and r.unit_id=` + req.plantId;
            }
            if (req.fromDate != undefined) {
                query = query + ' and DATE(r.reporting_date) between  "' + req.fromDate + '" and "' + req.toDate + '"';
            }
            if (req.saleOrderId) {
                query = query + ` and r.sale_order_id = ` + req.saleOrderId;
            }
            if (req.varientId) {
                query = query + ` and r.variant_id = ` + req.varientId
            }
            query = query + ` ORDER BY r.reporting_log_id ASC`

            const data = await manager.query(query)
            if (data.length > 0) {
                return new CommonResponse(true, 11108, "Stock in transactions retrived sucessfully", data)
            }
            else {
                return new CommonResponse(false, 11108, "No data found")
            }
        } catch (error) {
            throw error
        }
    }

    async getCheckPickListGeneratedORNot(req: SaleOrderIdRequest): Promise<CommonResponse> {

        try {
            const manager = getManager();
            console.log(req);
            let stockData = "Select Distinct(location) As rackPosition from " + appSettings.warehouse_db + ".stock s where s.status = 'stockIn' and sale_order_id = " + req.saleOrderId + " order by location";
            let checkResult = await manager.query(stockData);
            let flag = false;
            for (const res of checkResult) {
                let checkJob = "Select * from " + appSettings.warehouse_db + ".fork_lift_items fli left join " + appSettings.warehouse_db + ".fork_lift_jobs flj on flj.job_id = fli.fork_lift_job_id where sale_order_id = " + req.saleOrderId + " and current_position =" + res.rackPosition + " and flj.job_purpose='dispatch'";
                let jobResult = await manager.query(checkJob);
                if (jobResult.length > 0) {
                    flag = false;
                }
                else {
                    flag = true;
                }
            }
            if (flag) {
                return new CommonResponse(true, 1001, "Stock not found to dispatch");
            }
            else {
                return new CommonResponse(false, 1001, "Stock not found to dispatch");
            }
        }
        catch (error) {
            console.log(error)
            return new CommonResponse(false, 11108, "No data found");
        }
    }
    async getPOsInStock(req: SaleOrderIdRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = "Select s.sale_order_id AS saleOrderId,sid.po_number AS saleOrderNumber from " + appSettings.warehouse_db + ".stock s left join " + appSettings.sales_db + ".so_invoice_details sid on sid.sale_order_id = s.sale_order_id where s.status = 'StockIn' group by s.sale_order_id";
            let result = await manager.query(query);
            if (result.length > 0) {
                return new CommonResponse(true, 1001, "Customer PO's retrived successfully.");
            }
            else {
                return new CommonResponse(false, 1011, "No data found.");
            }
        }
        catch (error) {
            console.log(error)
            return new CommonResponse(false, 11108, "No data found");
        }
    }



    async getSaleOrderDropForStockInReverse(req: StockInReverseReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT si.po_number as poNumber,r.sale_order_id as saleOrderId  FROM ` + appSettings.warehouse_db + `.reporting r
    LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id=r.sale_order_id
    LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.stock_id = r.stock_id
    where r.reporting_log_id > 0 and  r.is_active = false  `
        if (req.plantId && req.plantId != 5) {
            query = query + ` and r.unit_id = ` + req.plantId;
        }
        query = query + ` GROUP BY r.sale_order_id `
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 11108, "data retrived sucessfully", data)
        } else {
            return new CommonResponse(false, 11108, "No data found")
        }
    }

    async getVariantDropForStockInReverse(req: StockInReverseReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT sc.variant_code as variantCode,r.variant_id as varientId  FROM ` + appSettings.warehouse_db + `.reporting r
    LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON  sc.sku_code_id = r.variant_id
    LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.stock_id = r.stock_id
    where r.reporting_log_id > 0 and  r.is_active = false `
        if (req.plantId && req.plantId != 5) {
            query = query + ` and r.unit_id = ` + req.plantId;
        }
        query = query + ` GROUP BY r.variant_id `
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 11108, "data retrived sucessfully", data)
        } else {
            return new CommonResponse(false, 11108, "No data found")
        }
    }
    async getPlantDropForStockInReverse(req: StockInReverseReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT uc.unit_name as unitName,r.unit_id as plantId  FROM ` + appSettings.warehouse_db + `.reporting r
    LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = r.unit_id
    LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.stock_id = r.stock_id
    where r.reporting_log_id > 0 AND r.is_active = false `
        if (req.plantId && req.plantId != 5) {
            query = query + ` and r.unit_id = ` + req.plantId;
        }
        query = query + ` GROUP BY r.unit_id `
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 11108, "data retrived sucessfully", data)
        } else {
            return new CommonResponse(false, 11108, "No data found")
        }
    }

 async getlocationsHistoryReportData():Promise<CommonResponse>{
    const manager = getManager()
    let stockInQuery = `SELECT si.po_number AS poNumber ,if(r.reporting_log_id > 0,'STOCK IN','-') as actionItems, SUM(r.reported_cases) as cartons FROM ` +appSettings.warehouse_db + `.reporting r 
    LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = r.sale_order_id 
    WHERE r.is_active = TRUE AND r.reporting_log_id > 0 GROUP BY  r.sale_order_id `

    let dispatchQuery = `SELECT si.po_number AS poNumber, SUM(fli.job_cartons) AS cartons, if(flj.job_purpose = 'dispatch' , 'DISPATCHED STOCK','-') as actionItems FROM ` + appSettings.warehouse_db + `.fork_lift_items fli
    LEFT JOIN ` + appSettings.warehouse_db + `.fork_lift_jobs flj ON flj.job_id = fli.fork_lift_job_id 
    LEFT jOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = fli.sale_order_id 
    LEFT jOIN ` + appSettings.warehouse_db + `.reporting r ON  r.reporting_log_id = flj.reported_id 
    WHERE flj.job_purpose = 'dispatch' GROUP BY fli.sale_order_id `

    let transactionsQuery = `SELECT rpo.rack_code AS oldRack, rpn.rack_code AS newRack ,sio.po_number AS oldSo ,siu.po_number AS upadatedSo,if(sl.stock_log_id > 0 , 'INTERNAL TRANSFER' ,'-') as actionItems  FROM ` + appSettings.warehouse_db + `.stock_log sl
    LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sio ON sio.sale_order_id = sl.old_so_id
    LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details siu ON siu.sale_order_id = sl.updated_so_id 
    LEFT JOIN ` + appSettings.masters_db + `.rack_position rpo ON rpo.rack_position_id = sl.old_rack_position_id 
    LEFT JOIN ` + appSettings.masters_db + `.rack_position rpn ON rpn.rack_position_id = sl.updated_rack_position_id WHERE sl.stock_log_id > 0 GROUP BY sl.old_so_id `
    
     const transactionData = await manager.query(transactionsQuery)
     const dispatchData = await manager.query(dispatchQuery)
     const stockInData = await manager.query(stockInQuery)
     const data = [...dispatchData,...transactionData,...stockInData]
    
  if(data.length >0){
    return new CommonResponse(true, 11108, "data retrived sucessfully", data)
    }else {
        return new CommonResponse(false, 11108, "No data found")
  }
 }
 async getReverseAllocatedStock(req:AllocationRevereseRequest):Promise<CommonResponse> {
    const manager = new GenericTransactionManager();
    try{
        console.log(req);
        let assignedRmQty
        let gmsMinWeight
        let gmsMaxWeight
        let state
        if (req.category == 'ReProcessing') {
            assignedRmQty = req.rmStockQty;
            state = FgStockStates.AllocatedForReprocessing
        }
        if (req.category == 'Repacking') {
            state = FgStockStates.AllocatedForRepacking
            gmsMinWeight = 454 / req.minGrade;
            gmsMaxWeight = 454 / req.maxGrade;
            const productPercentageafterhl = 1000 * req.hlPercentage / 100;
            const productPercentageafterSoaking = productPercentageafterhl * req.finalPercentage / 100;
            console.log("productPercentageafterhl" + productPercentageafterhl);
            console.log(productPercentageafterSoaking);
            const rmRatioPerKg = 1000 / productPercentageafterSoaking;
            console.log(rmRatioPerKg);
            let outputMinWeight
            let outputMaxWeight
            if (req.finalPercentage != 0 && req.hlPercentage != 0) {
                outputMinWeight = gmsMinWeight / ((req.finalPercentage / 100) * (req.hlPercentage / 100));
                outputMaxWeight = gmsMaxWeight / ((req.finalPercentage / 100) * (req.hlPercentage / 100));

            } else {
                outputMinWeight = 0
                outputMaxWeight = 0
            }
            console.log(outputMinWeight);
            console.log(outputMaxWeight);

            const productMinCount = 1000 / outputMinWeight;
            const productMaxCount = 1000 / outputMaxWeight;
            const avgCount = (productMinCount + productMaxCount) / 2;
            const count = Math.ceil(avgCount);

            let assignedNetQty = req.rmStockQty;
            assignedNetQty = Number(req.totalPouches) * Number(req.shrimpWeight);

            console.log("assignedNetQty");
            console.log(assignedNetQty);

            //conversion of case weight into Kg if UOM in SO is LB 
            if (req.uomId == 2) {
                assignedNetQty = assignedNetQty * 0.453592
            }
            if (req.uomId == 3) {
                assignedNetQty = assignedNetQty * 0.0283495
            }
            if (req.uomId == 4) {
                assignedNetQty = assignedNetQty * 0.001
            }
            console.log(assignedNetQty+"assignedNetQty");
            assignedRmQty = Number(assignedNetQty) * Number(rmRatioPerKg);
            console.log(assignedRmQty+"assignedRmQty 0");
            console.log(rmRatioPerKg);

            assignedRmQty = Number(assignedRmQty) * Number(req.totalCases);
            console.log(req.totalCases+"req.totalCases");
            console.log(assignedRmQty+"assignedRmQty 1");


            console.log(productMinCount+"**"+productMaxCount+"**"+avgCount+"**"+count+"**"+assignedNetQty+"**"+assignedRmQty);
        }
        console.log(req.stockId);
        const stockResponse = await this.stockRepository.find({
            where: { stockId: Raw(alias => `stock_id IN (${req.stockId})`) },
        });
        console.log(stockResponse);
        console.log('99999999999999');
        console.log(stockResponse);
        await manager.startTransaction();
        const updateAllocatedStock = await manager.getCustomRepository(StockRepository).update({ stockId: Raw(alias => `stock_id IN (${req.stockId})`) }, { allocatedSaleOrderId: 0, allocatedSaleOrderItemId: 0, state: FgStockStates.Stock });
        if(updateAllocatedStock.affected){

                manager.completeTransaction();
                const response = new StockAssigningResponse(true, 1111, 'Stock Assigned Successfully');
                return response;
        } else {
            await manager.releaseTransaction();
            throw new ErrorResponse(11106, 'Something Went Wrong when allocation reverse. ');
        }
    }catch (error) {
        await manager.releaseTransaction();
        return new CommonResponse(false, 11108, "No data found");
    }
 }

    async getUpdateStockLocation(req:LocationUpdateRequest):Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try{
            await manager.startTransaction();
            let stockResult = await manager.getCustomRepository(StockRepository).findOne({ where: { stockId: req.stockId }});
            console.log("stockResult ****************");
            console.log(stockResult);
            if(stockResult.stockId > 0){
                let oldLocation = stockResult.location;
                const updateStockLocation = await manager.getCustomRepository(StockRepository).update({ stockId: req.stockId}, { location: req.rackPosition});
                let savedLog
                if(updateStockLocation.affected){
                    const stockLogObj = new StockLog();
                    stockLogObj.stockId = stockResult.stockId;
                    stockLogObj.oldRackPositiontId = oldLocation;
                    stockLogObj.updatedRackPositionId = req.rackPosition;
                    stockLogObj.purpose = "Location Update";
                    stockLogObj.cartons = stockResult.totalCartons;
                    stockLogObj.plantId = stockResult.plantId; 
                    savedLog = await manager.getCustomRepository(StockLogRepository).save(stockLogObj);
                    if (!savedLog) {
                        throw new ErrorResponse(11106, 'Something Went Wrong');
                    }
                    let updateNewLocationStatus = await this.rackPositionService.updateRackPostionOccupancy({rackId:req.rackPosition,saleOrderId:stockResult.saleOrderId});
                    if(updateNewLocationStatus.status){
                        let updateOldLocationStatus = await this.rackPositionService.updateRackPostionOccupancyNotOccupied({rackId:oldLocation,saleOrderId:0});
                        if(updateOldLocationStatus.status){
                            manager.completeTransaction();
                            const response = new CommonResponse(true, 1111, 'Location updated successfully');
                            return response;
                        }
                        else{
                            await manager.releaseTransaction();
                            return new CommonResponse(false, 11108, "something went wrong.");
                        }
                    }
                }
                else{
                    await manager.releaseTransaction();
                    return new CommonResponse(false, 11108, "something went wrong.");
                }
            }
            else{
                await manager.releaseTransaction();
                return new CommonResponse(false, 11108, "No data found");
            }
        }catch (error) {
            console.log(error);
            await manager.releaseTransaction();
            return new CommonResponse(false, 11108, "No data found");
        }
    }

}
